export default {
  common: {
    noFace: 'لا يوجد وجه',
    noPermissionTip: 'ليس لديك صلاحية لاستخدام هذه الميزة. يرجى شراء أو تجديد للمتابعة.',
    selected: 'حدد',
    open1: 'فتح',
    doubleClick: 'انقر نقرًا مزدوجًا',
    inputKeywordSearch: 'أدخل البحث عن الكلمات الرئيسية',
    inputKeywordStartSearch: 'أدخل الكلمة الأساسية لبدء البحث',
    searchHistory: 'سجل البحث',
    clearHistory: 'مسح التاريخ',
    notFoundRelatedResults: 'لم يتم العثور على نتائج ذات صلة',
    switch: 'تبديل',
    searchProductionLine: 'خط إنتاج المعدات',
    selectProductionLine: 'حدد خط الإنتاج',
    rotateAngleTip: 'تدوير {angle}',
    plankText: 'اللوحة',
    sendToEzSort: 'إرسال إلى ملصق الألوان',
    downloadEzSort: 'تنزيل Zhihui Color Label',
    notDownloadTip: 'إذا فشل فتح Zhihua Color Label بشكل طبيعي، فقد يكون ذلك بسبب عدم تنزيله. الرجاء النقر فوق الزر أدناه لتنزيل Zhihui Color Label',
    updateTip: 'تم اكتشاف تحديث البرنامج، يرجى إعادة تشغيل الخزانة!',
    betaTest: 'مجاني للاختبار الداخلي',
    ersortSpecail: 'حصريًا لـ Color Label',
    exclusiveFeature: 'ميزة حصرية',
    elementCanBeDragTip: 'يمكن سحب العناصر',
    checkPlankIsConflict: 'اكتشاف حالة اللوحة',
    preferenceSaveErr: 'استثناء حفظ التفضيلات',
    guimen: 'باب الخزانة',
    preferenceLoadTip: 'تحميل إعدادات التفضيلات الخاصة بك',
    preferenceLoadErrTip: 'فشل تحميل إعدادات التفضيلات، يرجى التحديث والمحاولة مرة أخرى لتجنب التسبب في أخطاء في إعدادات التفضيلات الخاصة بك!',
    localFileIsBeingWrite: 'كتابة الملفات المحلية',
    taskMonitor: 'مراقبة المهام',
    downloadByType: 'تنزيل {type}',
    slotKnifeErr: 'أداة المعالجة المحددة للفتحة مفقودة، يرجى التحقق من إعدادات خط الإنتاج! 【{msg}】',
    anewChooseCatalog: 'إعادة تحديد الدليل',
    downloadSetting: 'إعدادات التنزيل',
    attention: 'ملاحظة',
    unit: 'الحظر',
    defaultUse: 'الاستخدام افتراضيًا',
    defaultChooseUse: 'التحديد افتراضيًا',
    requestFail: 'فشل الطلب',
    downloadDoneByType: '{type} اكتمل التنزيل',
    sysTip: 'موجه النظام',
    pleaseChoose: 'يرجى تحديد',
    confirmDelete: 'تأكيد الحذف',
    notDataTipByType: 'لا توجد بيانات حتى الآن، يرجى البدء بـ {msg}',
    paginationTotalTip: '{current}-{page} العناصر/إجمالي {total} العناصر',
    chooseAmountData: '{number} تم تحديد البيانات',
    moreOperate: 'أكثر',
    transferByType: 'نقل{type}',
    clickCopy: 'انقر للنسخ {type}',
    currentLine: 'الصف الحالي',
    remark: 'ملاحظة',
    customFunction: 'وظائف مخصصة',
    limitedTimeTrial: 'إعفاء محدود',
    startDate: 'تاريخ البدء',
    endDate: 'تاريخ الانتهاء',
    startTime: 'وقت البدء',
    endTime: 'وقت النهاية',
    lastMonth: 'الشهر الماضي',
    lastSixMonth: 'الأشهر الستة الماضية',
    lastYear: 'العام الماضي',
    searchByType: 'الرجاء إدخال {type} للاستعلام',
    addTime: 'أضف الوقت',
    startArrange: 'ابدأ بالتنضيد',
    select: 'يختار',
    search: 'يبحث',
    name: 'اسم',
    plankNo: 'رقم اللوحة',
    plankName: 'اسم المجلس',
    orderNo: 'رقم الطلب',
    order: 'طلب',
    partNameWithoutRoomCabinet: 'اسم اللوحة (بدون غرفة/خزانة)',
    plankRemark: 'ملاحظات المجلس',
    room: 'غرفة',
    orderAddress: 'عنوان المشروع',
    matCode: 'المادة',
    matCode2: 'المادة',
    plankMatCode: 'مادة اللوحة',
    count: 'الكمية',
    customer: 'العميل',
    customerInfo: 'معلومات العميل',
    factoryOrderNo: 'رقم طلب المصنع',
    roomName: 'اسم الغرفة',
    color: 'اللون',
    plankColor: 'لون اللوحة',
    plankThick: 'سمك اللوحة',
    plankHighGloss: 'سمة التمييز',
    thick: 'السماكة',
    front: 'الواجهة الأمامية',
    back: 'الجانب العكسي',
    slot: 'الفتحة',
    hole: 'الفتحة',
    hsInfo: '{hole} الفتحة {slot} الفتحة',
    diameter: 'القطر',
    finishedWidth: 'عرض المنتج النهائي',
    finishedHeight: 'طول المنتج النهائي',
    finishedArea: 'مساحة المنتج النهائي (㎡)',
    remarks: 'ملاحظات',
    remark1: 'ملاحظات 1',
    remark2: 'ملاحظات 2',
    remark3: 'ملاحظات 3',
    remark4: 'ملاحظات 4',
    remark5: 'ملاحظات 5',
    remark6: 'ملاحظات 6',
    remark7: 'ملاحظات 7',
    remark8: 'ملاحظات 8',
    remark9: 'ملاحظات 9',
    remark10: 'ملاحظات 10',
    remark11: 'ملاحظات 11',
    remark12: 'ملاحظات 12',
    remark13: 'ملاحظات 13',
    remark14: 'ملاحظات 14',
    remark15: 'ملاحظات 15',
    remark16: 'ملاحظات 16',
    texture: 'الملمس',
    normal: 'الحبوب العمودية',
    reverse: 'الحبوب الأفقية',
    notCare: 'بدون نسيج',
    holeSlotsStastic: 'عدد الثقوب والفتحات',
    edge: {
      title: 'إحكام الحواف',
      info: 'الحافة معلومات الختم',
      front: 'نطاقات الحافة الأمامية',
      back: 'نطاقات الحافة الخلفية',
      left: 'نطاقات الحافة اليسرى',
      right: 'نطاقات الحافة اليمنى',
      up: 'نطاقات الحافة العلوية',
      down: 'نطاقات الحافة السفلية'
      },
    isSpecial: 'شكل خاص',
    notSpecial: 'شكل غير خاص',
    textOfDoorPlank: 'لوحة الباب',
    textOfNotDoorPlank: 'لوحة غير باب',
    isDoorPlank: 'لوحة الباب',
    notDoorPlank: 'لوحة غير باب',
    width: 'العرض',
    long: 'الطول',
    plankWidth: 'عرض اللوحة',
    plankHeight: 'طول اللوحة',
    shortLong: 'طول الجانب القصير',
    shortWidth: 'عرض الجانب القصير',
    plankShape: 'شكل اللوحة',
    detail: 'التفاصيل',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    alreadyKnow: 'أعرف',
    Noprompts: 'لا تطالب مرة أخرى',
    deep: 'العمق',
    other: 'أخرى',
    heighGloss: 'تمييز',
    heighGlossPlank: 'لوحة التمييز',
    heighGlossSide: 'لوحة التمييز',
    notHeighGloss: 'غير تمييز',
    notHeighGlossPlank: 'لوحة غير شديدة اللمعان',
    saveSuccess: 'تم الحفظ بنجاح',
    deleteSuccess: 'تم الحذف بنجاح',
    addSuccess: 'الإضافة بنجاح',
    editSuccess: 'التعديل بنجاح',
    engraving: 'آلة النقش',
    electronicSaw: 'المنشار الإلكتروني',
    glassEquip: 'آلة قطع الزجاج',
    labelingMachine: 'آلة وضع الملصقات',
    copy: 'نسخ',
    paste: 'لصق',
    undo: 'تراجع',
    move: 'نقل',
    PTP: 'PTP',
    dock56FDrill: 'مثقاب خماسي ستة جوانب',
    sideHoleDrill: 'آلة ثقب جانبي',
    combination: 'مدمج المعدات',
    integration: 'آلة الكل في واحد',
    standardPlank: 'لوحة كبيرة قياسية',
    standardMaterial: 'لوحة قياسية',
    standardMaterialTip: 'ملاحظة: بعد الانتهاء من تعديل معلومات اللوحة الكبيرة، يحتاج المستخدمون في إنتاج تخطيط الخزانة إلى إعادة تشغيل عميل الخزانة لتطبيق أحدث التغييرات!',
    specialMaterial: 'لوحة خاصة',
    specialPlank: 'لوحة كبيرة خاصة',
    singlePlank: 'لوحة واحدة',
    previous: 'السابق',
    plankInfo: 'تفاصيل لوحة كبيرة',
    moreResult: 'المزيد من خطط التخطيط',
    moreResultTip: 'توجد أخاديد لمعالجة اللحامات في اللوحة الكبيرة. لن تشارك اللوحة الكبيرة في إعادة التخطيط',
    ok: 'موافق',
    dispersePaibanTip: 'تم اكتشاف أن بعض اللوحات الكبيرة لا يمكن توزيعها وتنضيدها. يمكنك ضبط خطة التخطيط أو تبديلها يدويًا لتجنب تشغيل اللوحات!',
    next: 'التالي',
    rate: 'معدل الاستخدام',
    paibanBatch: 'دفعة التنضيد',
    return: 'إرجاع',
    FGNo: 'رقم العقد',
    refresh: 'تحديث',
    inde: 'الرقم التسلسلي',
    productionLine: 'خط الإنتاج',
    operation: 'التشغيل',
    colorPlaceHolder: 'اضغط على Enter لإنشاء بطاقة ألوان تلقائيًا',
    saveAndContinue: 'حفظ ومتابعة',
    reset: 'إعادة تعيين',
    check: 'استعلام',
    inputPlaceholder: 'يرجى الإدخال',
    filter: 'تصفية',
    all: 'الكل',
    exportPDF: 'تصدير PDF',
    exportPic: 'تصدير الصورة',
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    restore: 'استرجاع',
    save: 'حفظ',
    saveSetting: 'حفظ الإعدادات',
    isHeightGloss: 'يرجى تحديد ما إذا كانت لوحة تمييز',
    noSync: 'غير متزامنة',
    sync: 'متزامنة',
    formatSuccess: '{type} ناجح',
    dataLoading: 'يتم تحميل البيانات...',
    warmTip: 'تذكير دافئ',
    importantTip: 'نصيحة مهمة',
    wellcome: 'مرحبًا بك في التنضيد السحابي',
    timeOut: 'انتهت مهلة التنضيد، ما إذا كان سيتم إعادة كتابة التنضيد',
    notSawKnifeTip: 'ملاحظة: لا تحتوي آلة النشر والنقش على تم إعداد "شفرة المنشار المتقاطع"، لذا لا يمكن إجراء التنضيد. يرجى الذهاب وإضافته!',
    doorFrameKnifeRadiusErr: 'لقد قمت بتفعيل ميزة "آلة النقش بالمنشار - قطع إطار الباب". نصف قطر شفرة القطع أكبر من سمك شفرة المنشار، ولا يمكن إجراء التنضيد!',
    doorFrameIrregularPlankErr: 'لقد قمت بتفعيل ميزة "آلة النقش بالمنشار - قطع إطار الباب". هذه الميزة لا تدعم حاليًا تنضيد الألواح غير المنتظمة!',
    warning: 'تحذير',
    export: 'تصدير',
    mark: 'تمييز',
    noMark: 'إلغاء تحديد',
    sawArrange: 'تخطيط قطع المنشار',
    directArrange: 'تخطيط القطع المستقيم',
    area: 'المنطقة',
    plankNum: 'باركود اللوحة',
    loc: 'الخزانة',
    cutHeight: 'طول التقطيع',
    cutWidth: 'عرض التقطيع',
    defaultProduction: 'خط الإنتاج الافتراضي',
    surplusNum: 'باركود المادة المتبقية',
    tip: 'نصائح',
    history: 'التاريخ',
    hinge: 'فتحة المفصلة',
    hingeScrew: 'فتحة دليل الباب المفصلي',
    CCPXHole: 'فتحة لامركزية ثلاثة في واحد',
    stretchHinge: 'فتحة جهاز فرد الشعر وفتحة كوب المفصلة',
    stretch: 'جهاز فرد الشعر',
    stretcher: 'فتحة جهاز فرد الشعر',
    eccHole: 'فتحة غريب الأطوار',
    preHole: 'فتحة مدمجة',
    clothole: 'فتحة الملابس من خلال الفتحة',
    backPlank: 'فتحة اللوحة الخلفية',
    ALS: 'فتحة المقبض المخفي',
    doorSlot: 'فتحة معدنية للوحة الباب',
    drawerSlot: 'فتحة معدنية للدرج',
    lkSlot: 'فتحة قفل',
    KC: 'فتحة سحب السراويل',
    stealth: 'الأجزاء المخفية',
    lightSlot: 'فتحة الإضاءة',
    ConventionalHole: 'الفتحة العادية',
    Keyhole: 'فتحة المفتاح',
    allHole: 'جميع الفتحات على ألواح ذات شكل خاص',
    allSlot: 'جميع الفتحات على ألواح ذات شكل خاص',
    freedomAllHoleSlot: 'جميع الفتحات والفتحات على ألواح ذات شكل خاص',
    freedomAllHoleSlotTip: 'لوحة خاصة: لوحة لها زاوية لا تكون قائمة',
    millInfo: 'مقبض القرن',
    haiTang: 'قرن بيجونيا',
    FSDrill: 'المثقاب الخماسي/ السداسي',
    engraving2: 'آلة القطع',
    xyReverse: 'XYتبادل المحاور',
    autoXYReverse: 'التكييف والتبادل التلقائي لمعدات معالجة الثقب',
    autoXYReverseTip: 'سوف يتكيف تمكين بيانات المعالجة لآلة الثقب الجانبي الخلفي والمثقاب الخماسي الجوانب تلقائيًا مع تبادل المحور XY لآلة النقش',
    autoXYReverseTip2: 'ملاحظة: PTP غير مدعوم حتى الآن',
    xyReverseTip: 'XY وظيفة تبديل المحور غير متوافقة بعد مع L اكتب الفجوة المادية المتبقية. يرجى استخدامه بحذر',
    rect: 'مستطيل',
    Ltype: 'L الشكل',
    archive: 'Archive',
    tellPlaceholder: 'يرجى إدخال رقم هاتفك المحمول',
    knivesStore: 'مجلة الأدوات',
    roll: 'لوحة الوجه',
    pause: 'إيقاف مؤقت',
    editTrans: 'تحرير الترجمة',
    translateManager: 'إدارة الترجمة',
    grating: 'الشبكة',
    addressEditErr: 'لا تدعم الطلبات المتعددة تعديل عنوان المشروع',
    customerEditErr: 'طلبات متعددة لا تدعم تعديل معلومات العميل.',
    factoryEditErr: 'الطلبات المتعددة لا تدعم حاليًا تعديل رقم طلب المصنع.',
    roomNameEditErr: 'تعديل اسم الغرفة غير مدعوم حاليًا للطلبات المتعددة',
    remarkEditErr: 'تعديل ملاحظات الطلب غير مدعوم حاليًا للطلبات المتعددة',
    toMaterialList: 'انتقل إلى قائمة المواد',
    deleteFail: 'فشل الحذف، يرجى المحاولة مرة أخرى لاحقًا!',
    batchRestore: 'استرجاع جماعي',
    batchDelete: 'حذف الدفعة',
    workShop: 'إنتاج ورشة العمل',
    FGAdrress: 'عنوان المشروع/رقم العقد',
    cuttingSize: 'حجم القطع',
    finishedSize: 'حجم المنتج النهائي',
    labelImg: 'صورة الملصق',
    layoutImg: 'رسم التخطيط',
    file: 'الملف',
    folder: 'المجلد',
    reName: 'إعادة تسمية',
    to: 'إلى',
    plankUnit: 'الورقة',
    tagTemp: 'قالب الملصق',
    roomRemark: 'ملاحظات الغرفة',
    noModificationPermission: 'لا يوجد إذن تعديل',
    modificationRecord: 'سجل التعديل',
    page: 'الصفحة',
    strip: 'المقالة',
    jump: 'الانتقال السريع',
    freeAgreement: 'إخلاء المسؤولية عن البرنامج',
    preStep: 'الخطوة السابقة',
    nextStep: 'الخطوة التالية',
    upload: 'تحميل',
    uploading: 'تحميل',
    iAgree: 'أوافق',
    pleaseSelectPlank: 'يرجى تحديد لوحة واحدة على الأقل',
    saveToStoreTip: 'يرجى تحديد لوحة واحدة غير مقطوعة على الأقل',
    fileIsNotExist: 'الملف غير موجود',
    selectAll: 'حدد الكل',
    pdfTag: 'PDF الملصق',
    tagImage: 'صورة الملصق',
    guigui: 'Guigui',
    gratingSlot: 'فتحة الشبكة',
    deleteTip: 'لا يمكن استعادة هذه البيانات بعد الحذف. هل تؤكد حذف هذه البيانات؟',
    deleteError: 'حدث خطأ غير معروف وفشل الحذف',
    cancelDelete: 'تم إلغاء الحذف',
    confirmDeleteTip: 'بعد الحذف، ستدخل اللوحة إلى "اللوحة المراد تنضيدها في المكتبة - غير المخزنة في المكتبة" في الركن الأيمن السفلي من الصفحة. هل أنت متأكد من حذف البيانات؟',
    confirmDeleteBujianTip: 'بعد الحذف، سيتم إدخال القطعة في الركن الأيمن السفلي من الصفحة في "مكتبة القطع"، هل أنت متأكد من حذف البيانات؟',
    confirmSureDeleteTip: 'تم الكشف عن وجود لوحات صغيرة من نفس المادة في المكتبة الحالية ليتم تنضيدها. بعد الحذف، لن يتم عرض اللوحات الصغيرة المقابلة في المكتبة التي سيتم تنضيدها. يرجى تأكيد ما إذا كنت تريد الاستمرار في حذف اللوحة الكبيرة؟',
    deleteEmptyTip: 'هل يجب حذف هذه اللوحة الكبيرة',
    notCanDelete: 'المادة المتبقية التي يتم قطعها لا تدعم التخزين.',
    new: 'New',
    innerBluneFailure: 'التنضيد السحابي المضمن لا يصبح ساري المفعول.',
    deleteBigPlankTip: 'توجد لوحة صغيرة في اللوحة الكبيرة الأخيرة ولا يمكن حذفها!',
    continueExport: 'تجاهل الملف واستمر في إخراجه',
    toCheck: 'تحقق من',
    pleaseCheck: 'نتيجة التخطيط الحالي بها تعارض في الفتحات/تطاير خارج اللوحة الصغيرة/عمق غير طبيعي، يرجى التحقق!',
    clampHandCheck: 'تم اكتشاف أن فتحات بعض اللوحات الخاصة بك لا يمكنها تجنب موضع التثبيت، يرجى الضبط يدويًا',
    conflictPartDetail: 'تفاصيل اللوحات المتعارضة',
    colorNotUndefined: 'لا يمكن أن يكون اللون فارغًا',
    materialNotUndefined: 'لا يمكن أن تكون المادة فارغة',
    newSetting: 'وظيفة جديدة',
    downImageErrTip: 'فشل تصدير الصورة، لأن صورة الملصق مقسمة إلى مجلدات مختلفة وفقًا للوحة الكبيرة، تحتاج إلى التحقق من علامة اللوحة الصغيرة للتصدير معًا',
    downNcErrTip: 'التنزيل فشل NC لأن صور العلامات مقسمة إلى مجلدات مختلفة وفقًا للوحة الكبيرة. تحتاج إلى التحقق من ملصق اللوحة الصغيرة للتصدير معًا.',
    downNcErrTipForSurFolder: 'فشل التنزيل NC، وتم تقسيم صور الملصقات إلى مجلدات مختلفة وفقًا للوحة الكبيرة ولا يمكن فتح إعدادات ملفات اللوحة الكبيرة للمادة المتبقية في نفس الوقت',
    yes: 'نعم',
    no: 'لا',
    checkColorPrint: 'تم تمكين ملصقات الألوان حاليًا، يرجى استخدام طابعة ملونة للطباعة ~',
    colorRules: 'بعد تشغيل إنشاء ملصقات الألوان، سيتم تمييز الطلبات/الغرف/الخزائن/ألواح الأبواب حسب اللون. حاليًا، تدعم تسمية الألوان بحد أقصى 12 بيانات من نفس النوع. القواعد المحددة هي كما يلي:',
    greyPart: 'الجزء الرمادي من الملصق على اليمين هو منطقة',
    region: 'Area',
    notSame: 'مناطق {regionName} مختلفة لها ألوان مختلفة',
    doorTip: 'الرمادي هو لوحة الباب، والأبيض هو اللوحة غير الباب',
    exist: 'موجود',
    limitNotEffect: 'أكثر من 12 بيانات، تسمية اللون غير صالحة',
    hoverTip: 'الصورة الحالية هي لاحقة bmp، وتنسيق التشفير أبيض وأسود، واللون لا يمكن إخراج صورة الملصق',
    lock: 'القفل',
    unlock: 'فتح القفل',
    batchLock: 'قفل/فتح دفعة',
    surplusLock: 'قفل المادة المتبقية',
    surplusUnlock: 'فتح قفل المادة المتبقية',
    is: 'نعم',
    not: 'لا',
    savingHistory: 'حفظ ملف السجل',
    saveHistorySuccess: 'حفظ ناجح لملف السجل',
    saveHistoryFail: 'فشل في حفظ ملف السجل',
    bw: 'ما إذا كان سيتم تصدير الملصقات بالأبيض والأسود',
    modular: 'خزانة الوحدة',
    autoAdjust: 'الضبط التلقائي',
    cutOrderTip: 'تم اكتشاف خطأ في ترتيب القطع 【第{errorCutOrdersString}张大板】! يرجى إجراء التعديلات قبل تنزيل ملف NC',
    lockedCutOrderTip: '【第{errorCutOrdersString}张大板】 مقفل، يرجى الانتقال إلى التعديل اليدوي',
    paibanImgCutOrderTip1: 'تم اكتشاف خطأ في أمر القطع',
    paibanImgCutOrderTip: '! يرجى الانتقال إلى صفحة التخطيط لضبط ثم تصدير ملف التخطيط',
    goAdjust: 'لضبط',
    autoAdjustWarning: 'نتيجة التخطيط الحالية لا تدعم الضبط التلقائي',
    checkNetwork: 'يرجى التحقق من الشبكة',
    moreInfo: 'لمزيد من المعلومات',
    continueLayout: 'الاستمرار في التخطيط',
    adjustPosition: 'ضبط الإعدادات',
    specialAndFiveSix: 'عند معالجة الألواح ذات الشكل الخاص بالحفر بخمسة/سداسية الجوانب، قد يؤدي تشغيل التعشيش ذو الشكل الخاص إلى قطع اللوحة. يرجى تأكيد ما إذا كنت تريد الاستمرار في التنضيد؟',
    plankPathErr: 'البيانات الداخلية ذات الشكل الخاص للوحة خاطئة، يرجى التحقق مما إذا كانت تلبي مواصفات الأداة! رقم اللوحة 【{plankIDList}】',
    edgeCheck: 'اكتشف النظام أنه تم تعديل تشذيب اللوحة الكبيرة، يرجى إعادة التخطيط لضمان دقة الإنتاج',
    iKnow: 'أفهم',
    versionErrTip: 'يرجى تحديث الخزانة إلى أحدث إصدار!',
    annualFeeExpired: 'انتهت صلاحية الرسوم السنوية، يرجى التجديد!',
    holeEquipment: 'معدات الحفر {num}',
    customizedService: 'دعم الخدمات المخصصة لإنشاء خطة الإنتاج الحصرية الخاصة بك',
    exampleCombination1: 'آلة النقش + مثقاب خماسي/سادسي الجوانب + مجموعة ماكينة ثقب جانبي',
    exampleCombination2: 'منشار إلكتروني + مثقاب خماسي/سداسي الجوانب + مجموعة ماكينة ثقب جانبي',
    exampleCombination3: 'خط إنتاج متكامل أوتوماتيكي بالكامل + مجموعة مثقاب خماسي/سادسي',
    feedback: 'يمكنك تقديم تعليقات مباشرة على احتياجاتك إلى موظفي مبيعات برامج الخزانة أو موظفي ما بعد البيع لديك',
    markModifiedBoards: 'وضع علامة على السبورة الصغيرة المعدلة',
    showMoveStep: 'تحديد خطوة التحريك على لوحة المفاتيح',
    moveStep: 'خطوة التحريك على لوحة المفاتيح',
    existChangeBoards: 'لوحات صغيرة تم تغييرها',
    crossMaterialBoard: 'لوحة عبر المواد والألوان',
    skipCrossMaterialTip: 'عدم الإظهار مرة أخرى في هذا التخطيط',
    crossMaterialConfirmTip: 'أنت حاليًا نقل لوحة صغيرة عبر مواد أو ألوان مختلفة. {highlight} هل تريد المتابعة؟',
    crossMaterialConfirmTipHighlight: 'قد لا تتطابق اللوحة المنتجة مع أمر التقسيم',
    exportHoleSlotPDF: 'مخطط فتحة ثقب التصدير',
    pdfFormat: 'تنسيق PDF',
    dxfFormat: 'تنسيق DXF',
    specialShapeKnivesInfo: 'نصائح حول اختيار الأداة ذات الشكل الخاص',
    specialShapeKnivesInfoTips: '{stockNum} جزء اللوحة:',
    specialShapeKnivesInfoTips2: 'يتم تشغيل التحديد التلقائي للأداة ذات الشكل الخاص، وبيانات التخطيط غير طبيعية، يرجى إعادة التخطيط من قائمة المواد، أو إيقاف تشغيل وظيفة التحديد التلقائي للأداة ذات الشكل الخاص',
    default: 'الافتراضي',
    exportLanguage: 'لغة التصدير',
    exportLanguageTip: 'ملاحظة: لا يمكن ترجمة بعض المعلومات النصية عند تصديرها إلى pdf',
    highGlossNameTip: 'يمكن وصف لوحة التمييز التي تمت مزامنتها من الخزانة بأنها كتابة نصوص أخرى، مما لا يؤثر على سمات التمييز الخاصة بها',
    mixPaibanPlanSetting: 'إعدادات خطة الخلط',
    mixPaibanPlanSettingTip: 'يكتشف النظام أن إعدادات خطة الخلط قد تغيرت، يرجى إعادة تحديد خطة الخلط هذه!',
    mixPaibanPlanSettingOk: 'تعيين نظام الترتيب المختلط',
    mixPaibanPlanSettingCancel: 'لا حاجة، التنضيد مباشرة',
    noMixPaibanPlan: 'لا يوجد حاليًا نظام ترتيب مختلط متاح',
    mixColors: 'لون الترتيب المختلط',
    mixPai: 'الترتيب المختلط',
    plan: 'المخطط',
    mixPaibanTitle: 'ترتيب الألواح الصغيرة ذات الألوان المختلفة معًا',
    mixColorsTip: 'يمكنك تحديد ألوان اللوحات التي يمكن ترتيبها على لوحة كبيرة من نفس اللون للإنتاج دون تغيير معلومات اللون الأصلية للوحات.',
    mixColorsTip2: 'بعد إضافة المخطط، يجب تشغيله في قائمة المواد ليصبح ساري المفعول',
    mixColorsTip3: 'هناك تعارض بين وظائف نطاقات الحواف ذات الألوان المختلفة ولا يمكن أن تكون الوظيفة فعالة في نفس الوقت',
    mixErrTip: 'مخطط الترتيب المختلط يفتقد العناصر المطلوبة، يرجى التحقق من',
    addPlan: 'إضافة مخطط',
    chooseMatcode: 'حدد مادة',
    chooseColor: 'حدد اللون',
    defineColor: 'حدد اللون المحدد كـ',
    confirmDeletePlan: 'هل أنت متأكد من أنك تريد حذف المخطط',
    trimmingMethod: 'طريقة التشذيب',
    followStandardTrim: 'اتبع قيمة التشذيب للوحة القياسية في الفيلم الأصلي',
    trimToast: 'ملاحظة: لقد استخدمت وظيفة التشذيب المخصصة للمادة المتبقية، وهي اختيارية فقط للنشر والتخطيط',
    individualTrimValue: 'اضبط قيمة التشذيب بشكل مستقل',
    topTrimEmptyToast: 'لا يمكن أن يكون التشذيب العلوي فارغًا!',
    bottomTrimEmptyToast: 'لا يمكن أن يكون التشذيب السفلي فارغًا!',
    leftTrimEmptyToast: 'لا يمكن أن يكون التشذيب الأيسر فارغًا!',
    rightTrimEmptyToast: 'لا يمكن أن يكون التشذيب الصحيح فارغًا!',
    topTrimBlurToast: 'يرجى إدخال قيمة التشذيب العلوية',
    bottomTrimBlurToast: 'يرجى إدخال قيمة التشذيب السفلية',
    leftTrimBlurToast: 'يرجى إدخال قيمة التشذيب اليسرى',
    rightTrimBlurToast: 'يرجى إدخال قيمة التشذيب اليمنى',
    effectToast: '1. وظيفة التشذيب المخصصة فعالة فقط للألواح الملحومة',
    defaultTrimSetting: 'إعدادات التشذيب الافتراضية للمواد المتبقية',
    enterHere: 'أدخل هنا',
    permissionTipExportDxf: 'تصدير مخطط الثقوب والفتحات DXF',
    permissionTipSurplusRecycleBin: 'محطة إعادة تدوير المخلفات',
    permissionTipAdvancedNesting: 'التداخل غير المنتظم المتقدم',
    permissionTipPanelGrainAlign: 'محاذاية خشب اللوحة',
    permissionSeparator: ', ',
    missingPermissionTip: 'الأذونات التالية مفقودة: {permissions}'
    },
  home: {
    head: {
      production: 'مقدمة المنتج',
      resolve: 'الحل',
      about: 'من نحن',
      equipment: 'الآلات والمعدات',
      tell: 'الخط الساخن للشكاوى',
      enter: 'أدخل التنضيد السحابي'
      },
    swiper: {
      case1: {
        tag: 'نسخة مطورة جديدة',
        subTitle: 'العقل الذكي للآلة',
        description: 'برنامج تحسين التنضيد السحابي عبر الإنترنت الذي يحدث ثورة في الصناعة'
        },
      case2: {
        title: 'إنتاج الخزانات',
        subTitle: 'الابتكار الفني',
        description: 'يدعم مجموعة متنوعة من آلات وضع العلامات، وآلات القطع، وآلات الفتحات الجانبية، وخمسة الجوانب PTP، إرساء الحفر الخماسي/ السداسي'
        },
      case3: {
        title: 'الدماغ الصناعي',
        subTitle: 'الحل',
        description: 'تحصل خوارزمية التنضيد الذكية على معدل استخدام أعلى للوحات'
        }
      },
    statistics: {
      today: 'حجم التحول اليوم',
      toMounth: 'حجم التنضيد الشهري',
      outturn: 'إنتاجية المواد',
      cumulative: 'المستخدمين التراكميين'
      },
    intro: {
      title: 'برنامج التنضيد عبر الإنترنت السحابي للبيانات الضخمة على مستوى المؤسسة',
      subTitle: 'رؤى حول اتجاهات الصناعة، مع التركيز على احتياجات العملاء، وتمكين التحول الرقمي للمؤسسات وترقيتها، وتعزيز التحول في صناعة أتمتة إنتاج الأثاث عبر الإنترنت استجابة لسيناريوهات الإنتاج الحالية صناعة الأثاث اللوحي، AI يتم إطلاق الخوارزميات المساعدة لمواصلة المساهمة في نمو جديد للمؤسسة',
      menue: {
        case1: {
          title: 'التنضيد عبر الإنترنت',
          subTitle: 'يمكن إجراء التنضيد في أي وقت',
          description: 'لا حاجة لتنزيل البرامج، يمكن إجراء التنضيد في أي وقت، ولا يحتاج التحكم عن بعد إلى الاعتماد على الكمبيوتر'
          },
        case2: {
          title: 'الإنتاج متعدد الخطوط',
          subTitle: 'التبديل السريع لخطوط الإنتاج',
          description: 'يدعم المعالجة السريعة لخطوط الإنتاج المتعددة في في نفس الوقت، ويمكن التبديل بسرعة بين خطوط الإنتاج'
          },
        case3: {
          title: 'الإنتاج الدقيق',
          subTitle: 'التنضيد الدقيق وإعدادات المعلمات الدقيقة',
          description: 'التنضيد الدقيق وإعدادات المعلمات الدقيقة تجعل إنتاج اللوحة أكثر دقة'
          },
        case4: {
          title: 'إنتاج مخصص',
          subTitle: 'ملصقات مخصصة، ومثاقب مخصصة خماسية وسداسية الجوانب، وأشكال المواد المتبقية',
          description: 'ملصقات مخصصة، ومثاقب مخصصة خماسية وسداسية الجوانب، وأشكال مخصصة للمواد المتبقية، ومعالجة المعدات المجمعة'
          }
        }
      },
    fangan: {
      title: 'حلول احترافية للصناعة',
      subTitle: 'تكلفة منخفضة، وقيمة إخراج عالية، وخوارزميات ذكية تعمل على تحسين استخدام اللوحة، ومتوافقة مع برامج التصميم المتعددة لتزويد المستخدمين بالإنتاج الأمثل الحلول',
      menue: {
        case1: {
          title: 'تلقي الطلبات عبر الإنترنت وتكامل الإنتاج',
          description: 'التشغيل عبر الإنترنت عن بعد، والتغلب على عوائق المساحة، وإخراج الطلبات في أي وقت لمزامنة المصنع، واستكمال التصميم والإنتاج في وقت واحد'
          },
        case2: {
          title: 'تبديل خطوط الإنتاج بنقرة واحدة',
          description: 'خطوط إنتاج مخصصة، ودعم خطوط إنتاج متعددة ورسو المعدات متعددة الأنواع'
          },
        case3: {
          title: 'تعمل الخوارزمية الذكية على تحسين استخدام اللوحة',
          description: 'تتميز الخوارزمية التقليدية باستخدام منخفض للوحة، وإعداد خوارزمية ذكية للمعلمات الدقيقة، وخطة إنتاج مخصصة'
          },
        case4: {
          title: 'حل القطع الاحترافي',
          description: 'تحسين تسلسل القطع ونقطة القطع لجعل مسار القطع أقصر وأكثر استقرارًا'
          }
        }
      },
    aboutUs: {
      title1: 'Xinger Habitat Technology',
      subTitle: 'شركة رائدة في تحويل صناعة إنتاج الأثاث',
      description: 'Xinger Enterprise، مع التركيز على تحقيق التحول عبر الإنترنت لصناعة إنتاج الأثاث التقليدي',
      culture: {
        case1: {
          title: 'غرض الشركة',
          subTitle: 'مساعدة المصانع على النمو ثلاثة أضعاف'
          },
        case2: {
          title: 'القيم الثقافية',
          subTitle: 'التركيز على العملاء، وتوجيه المجتهد، والعمل الجاد، والاستفادة الناس'
          },
        case3: {
          title: 'الأيديولوجية التوجيهية',
          subTitle: 'الخط الشامل، بناء فريق النخبة مع قوة المبيعات، وقوة المنتج، والقوة التنظيمية'
          }
        },
      feature: {
        case1: 'صيانة الفريق المحترف',
        case2: 'التحديثات والتكرارات المستمرة',
        case3: 'خدمة ما بعد البيع الفردية',
        case4: 'خدمة تخصيص الوظائف'
        }
      },
    cooperation: {
      title: 'التعاون الصادق لخلق المستقبل',
      subTitle: 'تغطي العلامة التجارية لمعدات الإرساء 90٪ من المعدات شائعة الاستخدام في الحزب الشيوعي المحلي، ويتواجد معنا 107.554 تاجرًا'
      },
    footer: {
      contact: {
        title: 'اتصل بنا',
        adrres: 'العنوان: الطابق 16، المبنى 1، رقم 50، Xiuxi، Binhu District، مدينة Wuxi، مقاطعة Jiangsu',
        subAdrres: 'K-park مبنى مركز الخدمة 1',
        tell: 'الهاتف'
        },
      business: {
        title: 'Xinger Core Business',
        department1: 'قسم برمجيات الأبواب والنوافذ',
        department2: 'قسم برمجيات الأثاث',
        department3: 'قسم بناء التجميع',
        department4: 'الموقع الرسمي للمقر الرئيسي لشركة Xinger'
        },
      brand: {
        title: 'Xinger Brands',
        brand1: 'Caishen Financial Services',
        brand2: 'Mentu.com',
        brand3: 'Dingxin Investment',
        brand4: 'Sanzhangtu Technology',
        brand5: 'Shanghai Fenmo Technology'
        },
      organization: {
        title: 'فروع Xingeer العالمية',
        organization1: 'مكتب Xingeer-جنوب الصين (فرع فوشان)',
        organization2: 'مكتب Xingeer-Northern (فرع Linyi)',
        organization3: 'مكتب Xingeer-الجنوب الغربي (فرع تشنغدو)',
        organization4: 'Xingeer - مركز خدمة مجلس الوزراء الغربي',
        organization5: 'Xingeer - مركز خدمة مجلس الوزراء الشرقي',
        organization6: 'Xinger - مجموعة الوكيل',
        organization7: 'Xinger - قسم التسويق الدولي'
        },
      follow: {
        title: 'مسح "الخزائن التالية"'
        },
      friendLink: {
        link1: 'برنامج Xinger',
        link2: 'K عرض برنامج دليل التسوق',
        link3: 'Mentu.com',
        link4: 'برنامج الخزانة المصنوع بالكامل من الألومنيوم',
        link5: 'ZOL تنزيل البرنامج',
        link6: 'Huajun Software Park',
        link7: 'تنزيل الصفحة الرئيسية',
        link8: 'ZOL تنزيل البرنامج',
        link9: 'Green Resource Network',
        link10: 'خزانة الملابس امتياز',
        link11: 'امتياز تأثيث المنزل',
        link12: 'امتياز الحمامات الأمريكية'
        }
      }
    },
  login: {
    title: 'تسجيل الدخول',
    tell: 'رقم الهاتف المحمول',
    password: 'كلمة المرور',
    passwordPlaceholder: 'الرجاء إدخال كلمة المرور',
    forget: 'نسيت كلمة المرور',
    registerAccount: 'تسجيل الحساب',
    backLog: 'العودة إلى تسجيل الدخول',
    verifyCode: 'رمز التحقق',
    getVerifyCode: 'الحصول على رمز التحقق',
    verifyCodeErr: 'خطأ في رمز التحقق',
    confimPassword: 'تأكيد كلمة المرور',
    confimPasswordPlaceholder: 'يرجى تأكيد كلمة المرور',
    editPassword: 'تغيير كلمة المرور',
    register: 'تسجيل',
    reSend: 'وإعادة الحصول على',
    loginLoadText: 'تسجيل الدخول، يرجى الانتظار...',
    loadingPageTextL: 'تسجيل الدخول بنجاح، جارٍ تحميل بنية الصفحة...',
    loginSuccess: 'تسجيل الدخول بنجاح',
    tellErr: 'تنسيق رقم الهاتف المحمول غير صحيح',
    passwordErr: 'الرجاء إدخال كلمة المرور'
    },
  main: {
    head: {
      title: 'Bluen',
      subTitle: 'توفير الوقت والمواد والجهد',
      task: 'قبول المهام',
      arrange: 'التنضيد',
      surplus: 'المواد المتبقية',
      setting: 'الإعدادات',
      find: 'اكتشف',
      upgrade: 'الترقية الآن',
      editNickName: 'تعديل اللقب',
      editPassword: 'تغيير كلمة المرور',
      logout: 'تسجيل الخروج',
      notice: 'إعلان',
      enterOfficial: 'انتقل إلى الموقع الرسمي',
      equipment: 'الآلات والمعدات',
      help: 'مساعدة',
      importFunc: 'عرض الوظائف الحصرية',
      enterThinkerOfficial: 'أدخل موقع Xinger الرسمي',
      history: 'حفظ التاريخ',
      plankManager: 'إدارة الأفلام الأصلية',
      tagManager: 'إدارة العلامات',
      suplumentManager: 'الأجزاء التكميلية والمكتبة التي سيتم تنضيدها',
      fileManager: 'إدارة الملفات',
      productionLine: 'إرساء المعدات',
      workeShop: 'الإنتاج السحابي',
      useLesson: 'البرنامج التعليمي للاستخدام',
      videoLesson: 'فيديو تعليمي',
      prolineManager: 'إدارة خط الإنتاج',
      materialManager: 'إدارة اللوحة',
      productManual: 'دليل المنتج',
      medialRelated: 'إصدار التدرج'
      },
    sideBar: {
      title: 'تحسين الإنتاج',
      materialList: 'قائمة قطع المواد',
      paibanResult: 'خطة التنضيد',
      printTag: 'ملصقات الطباعة',
      history: 'حفظ التاريخ',
      limitDate: 'إعفاء محدود',
      surplusManager: 'إدارة المواد المتبقية',
      translateManager: 'إدارة الترجمة',
      moreSettings: 'المزيد من الإعدادات',
      deepSeekTitle: 'الاستشاريون',
      paibanCommune: 'مجموعة تبادل التنضيد'
      },
    allRead: 'تمت قراءة الكل',
    learnMore: 'اعرف المزيد',
    noticeEmpty: 'لا يوجد إعلان حتى الآن....',
    noticeErr: 'احصل على خطأ محتوى إعلان تفصيلي',
    feedBack: {
      tab1: 'إرسال تعليقات',
      tab2: 'سجل التعليقات',
      type: 'نوع التعليق',
      typePlaceholder: 'يرجى اختيار الوظيفة',
      description: 'الوصف',
      descriptionPlaceholder: 'مرحبًا ~ يرجى ملء وصف تفصيلي لسيناريو الاستخدام لا يقل عن 15 كلمة حتى نتمكن من مساعدتك بشكل أفضل. شكرا لتعاونكم!',
      uploadPic: 'إضافة صور، يمكن إضافة ما يصل إلى 6 صور، حجم الصورة الواحدة لا يتجاوز 10 ميجا)',
      tell: 'رقم الاتصال',
      submit: 'إرسال',
      admin: 'مسؤول التنضيد السحابي:',
      picTip: 'الصورة: (انقر للتوسيع لعرض تفاصيل الصورة)',
      empty: 'لا توجد بيانات ملاحظات',
      picErr: 'حجم الصورة الواحدة لا يتجاوز 10 ميجا',
      contentErr: 'يجب أن يكون عدد الكلمات بين 15 و300',
      necessary: 'هذا الخيار مطلوب'
      }
    },
  taskPage: {
    tab1: 'مهمة الإنتاج',
    tab2: 'قائمة انتظار الإنتاج الضخم',
    filter: {
      title: 'تصفية',
      unArrange: 'عدم التنضيد',
      arranged: 'التنضيد',
      allArranged: 'التنضيد الكامل',
      preLayout: 'التنضيد المسبق'
      },
    search: {
      placeholder: 'يرجى إدخال محتوى البحث',
      orderName: 'اسم الطلب',
      sender: 'المرسل'
      },
    importTask: 'مهمة الاستيراد',
    refuseTask: 'رفض المهمة',
    refreshList: 'تحديث القائمة',
    refuseRecord: 'رفض السجل',
    taskCard: {
      sender: 'قائمة المواد المستوردة',
      delivery: 'تاريخ التسليم',
      delete: 'حذف',
      addToBatch: 'إضافة إلى الدفعة',
      save: 'الأرشيف',
      arrange: 'التنضيد المباشر',
      deleteTitle: 'حذف المهمة',
      checkDetail: 'انقر لعرض التفاصيل',
      refuse: 'رفض',
      refuseTime: 'وقت الرفض',
      refuseReason: 'سبب الرفض',
      refuseTask: 'رفض المهمة',
      refuseTaskPlaceholder: 'يرجى إدخال سبب الرفض',
      addErr: 'فشلت الإضافة، يرجى المحاولة مرة أخرى لاحقًا!'
      },
    batchNo: 'رقم الدُفعة',
    batchArrange: 'تخطيط الدُفعة',
    clearBatch: 'مسح قائمة الانتظار',
    taskCount: 'العدد الحالي للمهام:',
    checkAllTask: 'عرض جميع قائمة المواد',
    clearSuccess: 'المسح بنجاح',
    record: {
      batchNo: 'الدُفعة',
      saveDate: 'توفير الوقت',
      materialList: 'قائمة المواد',
      arrangedRecord: 'خطة التنضيد',
      searchPlaceholder: 'الرجاء إدخال رقم الدفعة',
      tipText: 'هل تريد حذف هذا الأرشيف؟'
      },
    errTip: 'لا توجد بيانات مهمة للمعالجة، يرجى الانتقال إلى قائمة المهام لإضافتها!',
    emptyErr: 'لا يحتوي أمر المهمة هذا على بيانات لوحة ولا يمكن كتابته وإنتاجه!',
    operationSuccess: 'تمت العملية بنجاح',
    operationFail: 'فشلت العملية، يرجى المحاولة مرة أخرى لاحقًا!',
    saveSuccess: 'تم الأرشفة بنجاح',
    plankMaxLimit: 'عدد اللوحات الصغيرة يتجاوز الحد الأقصى للتنضيد',
    batchWorning: 'يرجى الإنتاج على دفعات',
    batchEmptyErr: 'لا تحتوي قائمة الطلبات على بيانات اللوحة، ولا يمكن تنفيذ الإنتاج الضخم!',
    noRoomTip: 'الإنتاج الضخم مستحيل بدون غرفة!',
    refuseHistory: 'سجل الرفض'
    },
  materialPage: {
    specialProcess: 'عملية خاصة',
    distanceFromTop: 'من الأعلى',
    distanceFromRight: 'من اليمين',
    hingeData: 'بيانات المفصلة',
    labelBackProcTip: 'قام هذا التحديث بتحسين طريقة وضع العلامات على الجزء الخلفي من اللوحة الكبيرة. اتبع الآن المعلومات الموجودة على الملصق لإغلاق الحافة مباشرة وثقب الثقوب وسحب الأخاديد. أتمنى أن تعرف!',
    openDir: 'اتجاه فتح الباب',
    edgeEmptyTip: 'لا يمكن أن تكون قيمة التشذيب فارغة',
    edgeNumberLimit: 'يمكن إدخال قيمة التشذيب كأرقام فقط',
    chooseSurplusQuantity: 'هناك أنواع {total} من المواد المتبقية المتاحة، تم تحديد أنواع {quantity}',
    noCanSaveInfo: 'لا توجد معلومات يمكن حفظها',
    chooseBujianStoreQuantity: 'إجمالي {total} قطع الترقيع، إجمالي {quantity} قطع الألواح التي يمكن ترقيعها بالمناسبة، تم تحديد {chooseQuantity} قطع',
    isConfirmPushToAwaitStore: 'هل أنت متأكد من إضافة اللوحات المحددة إلى المكتبة ليتم تنضيدها؟',
    enterAutoCreateMatCode: 'اضغط على Enter لإنشاء المادة تلقائيًا',
    chooseAwaitStoreQuantity: 'إجمالي {total} اللوحات الصغيرة في المكتبة المراد تنضيدها، إجمالي {quantity} اللوحات التي يمكن تنضيدها، كتل {chooseQuantity} المحددة',
    defaultFold: 'يتم طي بيانات اللوحة افتراضيًا',
    startArrange: 'ابدأ بالتنضيد',
    importMaterial: 'استيراد قائمة القطع',
    saveToHistory: 'حفظ في التاريخ',
    addPlank: 'إضافة لوحات',
    addBujian: 'إضافة تصحيح',
    deletePlank: 'حذف اللوحات',
    batchEdit: 'تعديل الدفعة',
    moreSetting: 'المزيد من الإعدادات',
    plankSize: 'حجم اللوحة',
    plankSize2: 'الأبعاد (الطول*العرض*السمك)',
    searchPlaceholder: 'اسم لوحة البحث/رقم اللوحة',
    checkArranged: 'عرض التنضيد',
    checkErr: 'لا يوجد تنضيد، لا يمكن عرضه!',
    downloadSheet: 'تنزيل جدول العينة',
    downloadSheetShowScientific: 'تنزيل جدول العينة (يظهر التدوين العلمي)',
    exportHoleSlotPDF: 'مخطط تصدير ثقب اللوحة والأخدود',
    style1: 'النمط الأول',
    style2: 'النمط الثاني',
    style2PDF: 'النمط الثاني (PDF)',
    style2DXF: 'النمط الثاني (DXF)',
    style3: 'النمط الثالث',
    importNoCover: 'لم يتم تغطية استيراد قائمة المواد',
    openBujianPlankRecommend: 'تمكين التوصية بالألواح الصغيرة للأجزاء التكميلية',
    openAwaitStorePlankRecommend: 'تمكين التوصية بالألواح الصغيرة في المكتبة ليتم تنضيدها',
    openSurplusPlankRecommend: 'تمكين توصية لوحات كبيرة مع المواد المتبقية',
    pushToAwaitStore: 'احفظها في المكتبة ليتم تنضيدها',
    setTableHead: 'قم بتعيين رأس قائمة القطع',
    syncConfirm: 'بيانات الخزانة والقطعة الأصلية من التنضيد السحابي غير متسقة! هل تتم مزامنتها مع بيانات الفيلم الأصلية للخزانة؟',
    handleSync: 'ملاحظة: يمكن إجراء المزامنة اليدوية في إدارة الفيلم الأصلي',
    noMoreTip: 'لا تطالب مرة أخرى',
    checkMore: 'عرض المزيد',
    noHistory: 'لا يوجد سجل حفظ حتى الآن...',
    sameOrder: 'هناك طلبات تحتوي على ملفات إنتاج مُصدَّرة، يرجى الانتباه إلى مشكلات الإنتاج المكررة!',
    markOrder: 'هل تريد وضع علامة على الإنتاج في صفحة الطلب؟',
    editErrTip: 'الطلبات المتعددة لا تدعم حاليًا تعديل المعلومات',
    autoSaveSuccess: 'يتم حفظها تلقائيًا في التاريخ!',
    goAdd: 'انتقل إلى الإضافة',
    noProductionLine: 'تم حذف خط الإنتاج لهذا السجل، يرجى الانتقال إلى قائمة المواد لإعادة التخطيط',
    fileErr: 'فشل تحليل محتوى الملف، يرجى تأكيد محتوى الملف!',
    noCheckData: 'لم يتم الاستعلام عن أي بيانات!',
    noArrangeTip: 'غير قادر على عرض خطة التخطيط مباشرة، يرجى النقر لبدء التخطيط!',
    tooOld: 'إعدادات الحفر الجانبية الخمسة أو الستة قديمة جدًا',
    contactUs: 'يرجى الاتصال بموظفي ما بعد البيع لإعادة الاتصال',
    pathErr: 'هناك بيانات غير طبيعية داخل اللوحة (رقم اللوحة: {errorPathPlankID})، يرجى التحقق!',
    sizeErr: 'توجد لوحة كبيرة الحجم! حجم اللوحة الصغيرة: {width}-{height}',
    noKnife: 'لم يتم ضبط قطر سكين القطع، يرجى الذهاب إلى آلة النقش لضبط السكين!',
    noKnifeDiameter: 'قطر سكين القطع ({name}) لخط الإنتاج فارغ، يرجى الانتقال إلى إضافة قطر الأداة المقابلة',
    openDifferentMaterialCuttingKnives: 'تم تمكين سكاكين قطع المواد المختلفة',
    sendFactorySuccess: 'تم إرسالها بنجاح إلى ورشة العمل',
    sendFactoryErr: 'فشل الإرسال إلى ورشة العمل، يرجى الاتصال بموظفي ما بعد البيع للحصول على المساعدة',
    createTaskCard: 'هل تريد إنشاء بطاقة المهمة المقابلة؟',
    surplusStatistics: 'تم اختيار إجمالي',
    surplusStatistics2: 'من المواد المتبقية المتوفرة',
    suplementStatistic: '. يمكن ترقيع إجمالي [[6]] قطعة من الترقيع، ويمكن ترقيع إجمالي',
    expand: '. توسيع',
    packUp: 'طي',
    importErr: 'الرجاء تحديد الملف الصحيح!',
    sendLoadingText: 'معالجة وإرسال ملفات NC...',
    arrangeLoading: 'الإجمالي',
    arrangeLoading2: 'يتم تحسين اللوحات الصغيرة للتنضيد...',
    dealing: 'المعالجة...',
    deleteConfirm: 'بعد الحذف، سيتم نقل المادة المتبقية إلى سلة المحذوفات. هل أنت متأكد أنك تريد حذف هذه المادة المتبقية؟',
    copyTip: 'سيتم نسخ المواد المتبقية المحددة قريبًا',
    copyTip2: 'يرجى تأكيد الكمية المراد نسخها',
    surplusHead: {
      shape: 'الشكل',
      type: 'النوع',
      remark: 'ملاحظة',
      area: 'المساحة (م²)',
      area1: 'المنطقة'
      },
    surplusTip: 'لا توجد مواد متبقية متاحة، يمكنك الانتقال إلى',
    creatSurplus: 'إنشاء مادة متبقية جديدة',
    orderInfo: 'معلومات الطلب',
    suplement: {
      statistic: 'إجمالي {total} قطع الترقيع، إجمالي {useable} يمكن تصحيح قطع الألواح، تم تحديد {selected} القطع',
      exportSuplement: 'تصدير قائمة الترقيع',
      suplementLoading: 'تحميل بيانات التصحيح',
      exportSuplementIng: 'يتم تصدير قائمة التصحيح',
      noMatchSup: 'فشلت مطابقة بيانات التصحيح القابلة للاستخدام',
      exportTip: 'يرجى تحديد رقعة واحدة على الأقل قبل التصدير'
      },
    empty: 'لا توجد بيانات لوحة حتى الآن',
    paibanSetting: {
      title: 'إعدادات التخطيط',
      selectProduction: 'اختيار خط الإنتاج',
      arrangeWay: 'اختيار مخطط التخطيط',
      suitText: 'ينطبق على：',
      surplusTrimTip: 'ملاحظة: لقد استخدمت وظيفة التشذيب المخصصة للمواد المتبقية، ويمكن تحديد تخطيط النشر فقط',
      suitEquipmentNormal: 'آلة النقش التقليدية',
      suitEquipmentSpecial: 'آلة قطع الزجاج، آلة قطع شفرة المنشار',
      lessRoll: 'نسخ أقل',
      computedSpecial: 'حساب الأشكال الخاصة',
      specialTip: 'يؤثر على سرعة التنضيد',
      irregularNesting: 'تداخل الأشكال الخاصة',
      primaryNesting: 'التداخل العادي',
      specialShapedPanel: 'الشكل الخاص المضمن في اللوحة العادية',
      limitedTimeTrial: 'إعفاء محدود',
      seniorShape: 'التداخل المتقدم',
      heteromorphicInlay: 'الشكل الخاص المضمن في الأشكال الخاصة',
      autoCutSurplus: 'الاقتصاص التلقائي للمواد المتبقية',
      cutWay: 'طريقة الاقتصاص',
      maxRect: 'الاقتصاص إلى أكبر مستطيل',
      fixedRect: 'الاقتصاص إلى حجم ثابت',
      minRectSetting: 'المحاصيل إلى الحد الأدنى للحجم',
      firstCutL: 'القطع يعطي الأولوية لتوليد L بقايا على شكل',
      firstCutLTip: '. عند التشغيل، سيتم قطع مجموعات الألواح المستطيلة التي تستوفي الشروط إلى L بقايا على شكل',
      shortLine: 'الجانب القصير أكبر من',
      longLine: 'الجانب الطويل أكبر من',
      setDifferentThickness: 'تعيين الحد الأدنى لحجم القطع للألواح ذات السماكات المختلفة',
      defaultRuleTip: 'عندما لا يتطابق سمك اللوحة مع القاعدة، سيتم قطعها وفقًا للقواعد الافتراضية',
      panelThickness: 'سمك اللوحة الكبيرة',
      duplicateMinCutSize: 'نفس الحد الأدنى لحجم القطع موجود بالفعل لـ سمك الحالي',
      templateEmpty: 'لا يمكن أن تكون بيانات القالب "تعيين الحد الأدنى لحجم القطع للألواح ذات السماكات المختلفة" فارغة!',
      duplicateThicknessData: 'توجد بيانات سمك مكررة في بيانات القالب الخاصة بـ "تعيين الحد الأدنى لحجم القطع للألواح ذات السماكات المختلفة"!',
      atLeastOne: 'احتفظ بعنصر واحد على الأقل!',
      maxAddFive: 'أضف ما يصل إلى خمسة!',
      surplusTemplate: 'قوالب مشتركة للمواد المتبقية',
      add: 'إضافة',
      templateErr: 'حدد القطع للأحجام المشتركة، تحتاج إلى تحديد قالب بيانات واحد على الأقل',
      cutLong: 'طول القطع',
      cutWidth: 'عرض القطع',
      baseInfo: 'المعلومات الأساسية',
      continue: 'التأكيد والمتابعة',
      standardSelect: 'اختيار اللوحة الكبيرة القياسية',
      customPlankOrder: 'ترتيب تخطيط اللوحة الكبيرة المخصص',
      customPlankOrderDetail: 'قائمة اللوحات الصغيرة غير المرتبة',
      customPlankOrderTip: 'التنضيد السحابي المضمن لا يصبح ساري المفعول.',
      customPlankOrderBrandTip: 'تحتوي الطلبات المعلقة للتخطيط على ألواح بطاقات ألوان العلامة التجارية، يتم استخدام هذه الميزة افتراضيًا',
      surplusPlank: 'قائمة اللوحات الصغيرة المتبقية',
      overSizePlank: 'قائمة لوحات كبيرة الحجم',
      plankOrder: 'تسلسل التخطيط',
      plankType: 'نوع اللوحة',
      plankSize: 'حجم اللوحة',
      plankEdgeOff: 'قيمة القطع',
      amount: 'كمية القطع',
      amountMax: 'الحد الأقصى لعدد الفراغات',
      numAndOverSizeTip: 'هناك لوحات صغيرة كبيرة الحجم وكمية اللوحات الكبيرة غير كافية للتنضيد',
      numErrorTip: 'لا توجد لوحات كبيرة كافية للتنضيد',
      overSizeTip: 'توجد لوحات صغيرة كبيرة الحجم ولا يمكن تنضيدها',
      restPartList: 'قائمة اللوحات الصغيرة غير المرتبة',
      layoutOrder: 'تسلسل التخطيط',
      arrangeAmount: 'كمية القطع',
      specialShapeTip: 'لا يمكن تنضيد بقايا الأشكال الخاصة بالنشر',
      surplusConflictTip: 'تتعارض بقايا التشذيب مع الخطوط العريضة للوحة، يرجى إعادة القطع',
      stackingMethod: {
        title: 'طريقة التجميع',
        long: 'تجميع بالجانب الطويل',
        short: 'تجميع بالجانب القصير'
        },
      seniorShapeTip: '【التداخل المتقدم】انتهت فترة التجربة المجانية، يمكنك معاينة نتيجة تخطيط التداخل المتقدم (يمكنك أيضًا التبديل إلى التداخل العادي للإنتاج العادي)؛ إذا كنت بحاجة إلى تصدير ملف إنتاج التداخل المتقدم، يرجى الاتصال بموظفي المبيعات للشراء~'
      },
    filter: {
      title: 'مرشح اللوحة',
      search: 'يبحث',
      all: 'حدد الكل',
      diskSize: 'تم استخدام مساحة البيانات التاريخية للتنسيق',
      resetFilter: 'إلغاء عامل التصفية'
      },
    edit: {
      title: 'تعديل الدفعة',
      target: 'تعديل الكائنات',
      onlineSelectRow: 'تحديد الصفوف فقط',
      allRow: 'جميع الصفوف',
      editKey: 'تحتاج إلى تعديل المحتوى',
      editValue: 'التعديل إلى',
      warningTip: 'ملاحظة: بعد التعديل، سيتم مسح الثقوب والأشكال الخاصة تلقائيًا',
      allEdge: 'جميع نطاقات الحواف'
      },
    add: {
      title: 'إضافة لوحات',
      continue: 'التأكيد والمتابعة',
      matCodeErr: 'لا يمكن أن تكون المادة فارغة',
      thickErr: 'لا يمكن أن يكون السمك فارغًا',
      colorErr: 'لا يمكن أن يكون اللون فارغًا',
      longErr: 'لا يمكن أن يكون طول المنتج النهائي فارغًا',
      widthErr: 'لا يمكن أن يكون عرض المنتج النهائي فارغًا',
      countErr: 'يجب أن تكون الكمية على الأقل 1'
      },
    delete: {
      tip: 'لا يمكن استعادة هذه البيانات بعد الحذف. هل تؤكد حذف هذه البيانات؟',
      errTip: 'يرجى تحديد لوحة واحدة على الأقل قبل إجراء هذه العملية!',
      errTip1: 'الرجاء تحديد لوحة واحدة على الأقل قبل التنضيد',
      confirm: 'تأكيد الحذف'
      },
    restore: {
      confirm: 'تأكيد الاستعادة'
      },
    restoreConfirm: 'بعد الاستعادة، سيتم نقل المادة المتبقية إلى قائمة أو مستودع المواد المتبقية. هل أنت متأكد أنك تريد استعادة هذه المادة المتبقية؟',
    restoreBatchConfirm: 'هل أنت متأكد أنك تريد استعادة المواد المتبقية المحددة؟',
    save: {
      errTip: 'لا توجد معلومات يمكن حفظها!',
      title: 'حفظ الخطة',
      subTitle: '(ملاحظة: يتم حفظ السجل لمدة عام واحد فقط)',
      name: 'اسم الخطة',
      historyName: 'الخطة التاريخية',
      successTip: 'تم الحفظ بنجاح!',
      fieldTip: 'فشل الحفظ!'
      },
    exportErr: 'لا توجد لوحة، لا يمكن تصديرها',
    exportPicErr: 'تمت مواجهة خطأ غير معروف عند تصدير فتحة اللوحة ومخطط الفتحة، يرجى الاتصال بنا للحصول على الحل',
    plankNotFound: 'لم يتم العثور على اللوحات ذات الصلة! يرجى تأكيد ما إذا كان سيتم رسم اللوحات!',
    noPlankName: 'لم يتم العثور على اسم اللوحة',
    plankDataErr: 'بيانات اللوحة خاطئة، يرجى التحقق بعناية لتجنب خسائر الإنتاج',
    exportThreeViewErr: 'فشل تصدير ثلاث طرق عرض للثقوب والفتحات، يرجى الاتصال بخدمة ما بعد البيع',
    heighGlossWarning: 'ملاحظة: عندما تكون المادة عبارة عن لوحة شديدة اللمعان، لن تتم استعادة اللوحة إلى لوحة شديدة اللمعان بعد تعديل المادة!',
    reset: 'استعادة الافتراضي',
    settingHead: {
      title: 'قم بتعيين رأس قائمة القطع',
      head: 'الرأس',
      customHeadName: 'تخصيص اسم الرأس',
      example: 'مثال',
      tip: 'تلميحات العملية: يمكنك سحب تسمية بيانات الرأس إلى اليسار واليمين. الموضع',
      headerNameEmpty: 'لا يمكن أن يكون الرأس فارغًا',
      duplicateHeader: 'يوجد رأس مكرر'
      },
    copyLine: 'انقر لنسخ الصف الحالي أدناه',
    copySuccess: 'انسخ بيانات {name} بنجاح',
    arranging: 'يتم تحسين إجمالي {count} اللوحات الصغيرة للتنضيد...',
    overSize: {
      title: 'لوحة كبيرة الحجم',
      subTitle: 'قائمة لوحات كبيرة الحجم',
      overSizeTip: 'مطالبة لوحة كبيرة الحجم',
      nonWorkInfo: 'تفاصيل اللوحات التي لا يمكن معالجتها',
      mergeFrameDoorWholeTip: 'ملاحظة: هذا المكون هو باب هيكلي كامل تمت معالجته معًا',
      conflictWorkInfo: 'تفاصيل اللوحات المتعارضة',
      warning: 'تم اكتشاف لوحة صغيرة كانت طويلة جدًا، مما يجعل من المستحيل تنضيدها! يرجى ضبط حجم اللوحة الصغيرة أو إضافة القطعة الأصلية بالحجم المقابل',
      checkInfo: 'لعرض تفاصيل اللوحة',
      tipContent: 'يكتشف النظام وجود لوحات كبيرة الحجم في لوحة التنضيد. فيما يلي اقتراحات لإضافة لوحات خاصة. يمكنك تعديل طول اللوحات وعرضها يدويًا والنقر فوق الزر <span class="bold color-0"> "إضافة بنقرة واحدة" </span> الموجود أسفل الجدول لإضافة التنضيد ومواصلته بسرعة. يمكنك أيضًا إضافة اللوحات يدويًا في <span class="bold color-0"> الإعدادات الأصلية - اللوحات الخاصة </span>',
      add: 'إضافة بنقرة واحدة',
      addPlank: 'إضافة الأصل',
      error: 'اللوحة تجاوزت الحجم وفشل التنضيد',
      successTip: 'تمت إضافة اللوحة بنجاح! إعادة التنسيق',
      warningTip: 'يرجى ملء طول وعرض اللوحة!'
      },
    arrangeErr: 'هناك خلل في البيانات الداخلية للوحة، ولا يمكن تنفيذ عملية التنضيد',
    nonDelete: 'لا يمكن حذفها',
    addOverSizeTip: 'هناك حجم كبير، يرجى إضافته مرة أخرى',
    addPlankSuccess: 'تمت إضافة لوحة كبيرة خاصة بنجاح',
    addPlankFail: 'فشل في إضافة لوحة كبيرة خاصة',
    paibanFeedback: 'ملاحظات التنضيد',
    cuttingAndPaoban: 'لوحة تشغيل مقطوعة',
    lowUtilizationRate: 'استخدام منخفض',
    unreasonableLayout: 'تنضيد غير معقول',
    feedbackSuccessTip: 'ردود الفعل ناجحة!',
    feedbackFailTip: 'فشل التعليق!',
    mixedLayoutScheme: 'خطة الترتيب المختلط هذه'
    },
  arrangedPage: {
    subtleDownloadCheckTip: 'تم تغيير بيانات اللوحة، ولكن لم يتم حفظ الخطة. الرجاء النقر فوق "موافق" لحفظ الخطة قبل متابعة العمليات اللاحقة',
    paibanRequestFailed: 'فشل طلب الترتيب، يرجى المحاولة مرة أخرى',
    accordingPlankCountOrder: 'الترتيب حسب عدد اللوحات الكبيرة من الأعلى إلى الأدنى',
    editOrder: 'تحرير الرقم التسلسلي',
    dragOrder: 'السحب للفرز',
    inputOrder: 'ترتيب الإدخال',
    editOrderTip: 'تعديل التسلسل',
    range: 'النطاق',
    unsupportRotateTip: 'تم تدوير بعض اللوحات الكبيرة ولا يتم دعم إعادة التخطيط في الوقت الحالي. الرقم التسلسلي للوحة المدورة هو:',
    slotErrTip: 'تحتوي اللوحة الحالية على أخاديد لمعالجة الحشو وإعادة التخطيط غير مدعومة!',
    lockedPaibanTip: 'اللوحة الكبيرة مقفلة ولا يمكن إعادة تخطيطها',
    batchBujianErrTip: 'اللوحة الحالية غير موجودة في البيانات الأصلية لفاتورة المواد. يمكنك اختيار إعادة التخطيط في مكتبة الملحق/التخطيط المطلوب.',
    useFolderIsNot: 'تم اكتشاف أن موقع تنزيل الملف وحفظه "{type}" غير موجود! يرجى التحقق مما إذا تم حذف المجلد. إذا كنت تستخدم قرصًا محمولًا U، فيرجى التحقق مما إذا كان القرص U متصلاً بشكل صحيح',
    useFolderIsNot1: 'تم اكتشاف أنك لم تقم بتعيين موقع تنزيل الملف، يرجى تحديد الدليل أولاً',
    downloadNC: 'تنزيل NC',
    downloadNC1: 'تنزيل ملف NC',
    reArrange: 'إعادة التنضيد',
    reArrangeSpecifiedMaterialGroup: 'إعادة تنضيد مجموعات الألواح المحددة',
    specifiedMaterialRelayoutMoreResultTip: 'بعد إعادة تنضيد مجموعات الألواح المحددة، لن يتم توفير المزيد من نتائج التنضيد',
    searchMaterialGroup: 'البحث عن مجموعات الألواح',
    saveToHistory: 'حفظ في التاريخ',
    moreSetting: 'أكثر',
    cutIndexRe: 'استخدم سرعة المفتاح ctrl+z للتراجع عن الخطوة السابقة',
    followExportTag: 'تنزيل NC وتصدير ملف التسمية',
    followExportPaibanImg: 'تنزيل NC وتصديره ملف رسم التخطيط',
    followExportWorkerShop: 'تنزيل NC وتصدير أمر الشراء',
    tagTemplateSelect: 'اختيار قالب الملصق',
    showCuttingSequence: 'عرض أمر القطع',
    showPlankSize: 'عرض حجم اللوحة الصغيرة',
    sendToFactory: {
      title: 'إرسال إلى ورشة العمل',
      fileType: 'نوع ملف الملصق'
      },
    checkData: 'التحقق من سلامة البيانات...',
    dataLoading: 'تحميل...',
    addToBujianStore: 'إضافة مستودع قطع غيار...',
    updateTaskStatus: 'تحديث حالة المهمة...',
    sending: 'إرسال إلى ورشة العمل',
    waitLoadding: 'انتظار',
    loadding: 'حاليًا',
    finish: 'إكمال',
    loadSetting: 'تحميل الإعدادات',
    loadPreference: 'تحميل التفضيلات',
    dealTemplate: 'قوالب المعالجة',
    initTagData: 'تهيئة بيانات الملصق',
    prepareDrawData: 'تحضير بيانات رسم الملصق',
    drawDataText: 'بيانات رسم الملصق',
    genPdfTagFile: 'إنشاء ملف ملصق PDF',
    genPicTagFile: 'إنشاء ملف صورة التسمية',
    uploadFile: 'تحميل الملف',
    dealNCFile: 'معالجة NC الملف',
    zipFile: 'إنشاء ملف مضغوط محلي',
    plankCount: 'عدد اللوحات الكبيرة',
    rollCount: 'عدد النسخ',
    totalRate: 'معدل التحسين الإجمالي',
    rate: 'معدل التحسين',
    useArea: 'المساحة المحسنة',
    materialList: 'قائمة المواد',
    saveSurplus: 'المواد المتبقية المخزنة',
    workeShop: 'أمر الشراء',
    batchTagging: 'إعادة تسمية الدفعة',
    batchTaggingTip: 'يرجى تحديد الألواح التي تحتاج إلى إعادة تسمية أدناه',
    holeSlotErr: 'تم اكتشاف أن اللوحة بها ثقب وعمق فتحة غير طبيعي!',
    knivesErr: 'تم اكتشاف عدم تمكن اللوحة من العثور على أداة المعالجة!',
    checkDetail: 'عرض التفاصيل',
    deepErr: {
      title: 'عمق ثقب غير طبيعي للوحة',
      errStatistic: 'لوحة شبه صغيرة بها {count} شذوذ',
      errText: 'جزء غير طبيعي',
      markErrPart: 'تأطير الجزء غير الطبيعي'
      },
    warningTip: 'لوح عالي اللمعان معالج على الوجهين: معالجة <span class="font-style">السطح عالي اللمعان</span> أولاً، ثم معالجة <span class="font-style"> السطح غير اللامع</span>؛ لوحة عالية اللمعان معالجة من جانب واحد: معالجة مباشرة <span class="font-style">سطح غير لامع</span>',
    showDetail: {
      tip1: 'انقر لتحديد لوحة واحدة',
      tip2: 'عرض علامات اللوحة'
      },
    arrangeTip: '(يتم دعم التخطيط المتداخل ذو الشكل الخاص)',
    plankOpration: 'تشغيل اللوحة',
    rotate: 'تدوير 90 درجة',
    notCare: 'اللوحة لا تحتوي على نسيج',
    editRemark: 'تحرير الملاحظات',
    clearRemark: 'مسح الملاحظات',
    recalcIndex: 'إعادة حساب نقطة القطع وتسلسل القطع',
    recalcIndexSuccess: 'إعادة حساب نقطة القطع وتسلسل القطع بنجاح',
    storageArea: {
      title: 'منطقة التخزين المؤقتة للوحة',
      empty: 'لا يوجد تخزين مؤقت للوحة',
      storageTip: 'يمكنك سحب اللوحة هنا لحفظ اللوحة مؤقتًا'
      },
    subtleArrange: 'التنضيد الدقيق',
    addPlank: 'إضافة لوحة كبيرة',
    deletePlank: 'حذف لوحة كبيرة',
    deletePlankErr: 'توجد لوحات صغيرة في اللوحة الكبيرة الحالية، و لا يمكن حذف اللوحة الكبيرة!',
    useSurplus: {
      title: 'استخدم المواد المتبقية'
      },
    dragWarning: 'يرجى سحب اللوحة إلى اللوحة الكبيرة!',
    areaWarning: 'لا يمكن وضع اللوحة، انتبه إلى حجم المساحة الحرة',
    subtlePage: {
      cut: 'قطع المواد المتبقية',
      lineTip: 'قطع المواد المتبقية',
      cancelCut: 'قطع النهاية',
      cutPoint: 'نقطة شفط قطع المواد المتبقية',
      storageArea: 'منطقة انتظار اللوحة',
      cutErr: 'لا يمكن القطع إلا على اللوحة الكبيرة. لا تلمس اللوحة الصغيرة!',
      saveErr: 'يرجى تحديد المادة المقطوعة أولاً',
      cutErr2: 'لا يمكن إجراء القطع إلا على اللوحة الكبيرة، وليس خارج اللوحة الكبيرة!',
      selectTip: 'يرجى تحديد لوحة القطع المتبقية',
      noCutPath: 'لا يمكن قطع الأجزاء ذات الشكل الخاص إلى مستطيلات',
      cutOperate: 'عملية قطع المواد المتبقية',
      line: 'ضربة يدوية',
      cutErrtip: 'هناك مشكلة في القطع العرضي عند نقطة القطع، يرجى إعادة القص',
      cutErrtip2: 'ستتجاوز نقطة القطع الحد الأقصى للنقطة: 9، يرجى إعادة القص'
      },
    shortCut: 'مفاتيح الاختصار',
    updownRoll: 'التمرير لأعلى ولأسفل',
    leftRightRoll: 'اسحب لليسار واليمين',
    zoomScale: 'تكبير وتصغير',
    dragCanvas: 'اسحب الصفحة',
    mouseRoll: 'عجلة الماوس',
    mouseRight: 'زر الماوس الأيمن',
    doublePlank: 'انقر نقرًا مزدوجًا على اللوحة',
    keyboard: 'لوحة المفاتيح',
    picSymble: 'وسيلة الإيضاح',
    funished: 'المنتج النهائي',
    holeSlotConflict1: 'تعارض الفتحة والفتحة',
    plankErr: 'تعارض اللوحة',
    frontSlot: 'الأخدود الأمامي',
    backSlot: 'الأخدود العكسي',
    frontHole: 'الموضع الأمامي',
    backHole: 'موضع الوجه السلبي',
    resetScale: 'إعادة تعيين القياس',
    maxLong: 'الأطول',
    tempErr: 'فشلت الإضافة، موضع القالب غير صحيح أو أن القالب كبير جدًا!',
    sendErr: 'فشل الإرسال إلى ورشة العمل، يرجى التحقق مما إذا كان قالب الملصق وبيانات اللوحة صحيحة قبل الإرسال مرة أخرى',
    someTips: 'أنت تحاول التنضيد السحابي لبقايا ذات شكل خاص/وظيفة تداخل ذات شكل خاص لفترة محدودة، يرجى الانتباه لتجنب مشاكل الإنتاج!',
    nestingTips: 'انتهت الفترة التجريبية المجانية المحدودة لوظيفة [تخطيط التداخل للأشكال الخاصة المتقدم]. للاستمرار في الاستخدام، يرجى الاتصال بفريق المبيعات للشراء!',
    frameDoorTip: 'تم اكتشاف أن اللوحة بها تعارض في الفتحات والفتحات/تطير اللوحة الصغيرة للخارج',
    cutOrderErr: 'تسلسل القطع غير صحيح، الرجاء النقر لإعادة حساب نقطة القطع وتسلسل القطع!',
    holeSlotConflict: 'تم اكتشاف أن اللوحة بها تعارض في الفتحات والفتحات/تطير اللوحة الصغيرة للخارج',
    exportSetting: 'إعدادات التصدير',
    currentTagTemp: 'قالب الملصق الحالي',
    specialPaibanErr: 'تحتوي بعض اللوحات على عمليات خاصة أو أخاديد معالجة ملحومة، ولا يتم دعم إعادة التخطيط في الوقت الحالي!',
    moreResult: 'المزيد من النتائج',
    moreResultTip: 'توجد أخاديد لمعالجة اللحامات في اللوحة الكبيرة. لن تشارك اللوحة الكبيرة في إعادة التخطيط',
    batchBujian: 'التصحيح الدفعي',
    batchOperation: 'التشغيل المجمع',
    batchEditPlankSize: 'التعديل الدفعي لحجم اللوحة الكبير',
    editPlankSize: 'تعديل الحجم',
    editWay: 'طريقة التعديل',
    editByType: 'تعديل حسب النوع',
    editByPlankNumber: 'تعديل حسب رقم اللوحة',
    editContent: 'تعديل المحتوى',
    editContentTip: 'يرجى تحديد نوع اللوحة التي تحتاج إلى تعديل',
    editContentTip1: 'يرجى تحديد رقم اللوحة التي تحتاج إلى تعديل',
    editStart: 'البداية',
    editEnd: 'النهاية',
    bigPlank: 'لوحة كبيرة',
    editSize: 'تعديل الحجم إلى',
    bigPlankWidth: 'عرض اللوحة الكبيرة',
    bigPlankHeight: 'طول اللوحة الكبيرة',
    bigPlankLengthMarking: 'تحديد طول اللوحة الكبيرة',
    markedAs: 'تم تحديدها كما',
    maxAddTen: 'أضف ما يصل إلى 10',
    minValue: 'الحد الأدنى للقيمة',
    differentKnifeErr: 'يتم تحديد لوحات كبيرة بسكاكين قطع مختلفة ولا يمكن تعديل الحجم',
    noEditablePlank: 'لا توجد ألواح كبيرة مؤهلة للتعديل',
    skipBrandPlankTip: 'يوجد {count} لوح كبير من العلامة التجارية في النطاق المحدد لا يدعم تعديل الحجم وتم تخطيه',
    nonBrandToBrandTip: 'لا يمكن سحب هذا اللوح الصغير إلى اللوح الكبير لبطاقة ألوان العلامة التجارية!',
    brandToNonBrandTip: 'لا يمكن سحب هذا اللوح الصغير إلى اللوح الكبير لبطاقة ألوان غير العلامة التجارية!',
    brandToOtherBrandTip: 'لا يمكن سحب هذا اللوح الصغير إلى اللوح الكبير لبطاقة ألوان علامة تجارية أخرى!',
    editNo: 'No.',
    editAllPlank: 'جميع اللوحات الكبيرة',
    editBigPartSize: 'تعديل حجم اللوحة الكبيرة',
    disPlaySetting: 'إعدادات العرض',
    stored: 'مخزنة بالفعل',
    onlySurplus: 'عرض المادة المتبقية فقط',
    UnuseSurplus: 'لا تشارك المادة المتبقية في حساب الاستخدام',
    usePlankAdsorption: 'وظيفة امتصاص اللوحة',
    dataDefaultCollapsed: 'يتم طي البيانات افتراضيًا',
    unit: 'الحظر',
    cutSurplus: 'الباقي',
    frontWarningTip: 'لوح عالي اللمعان مُعالج على الوجهين: معالجة <span class="font-style">السطح غير اللامع أولاً</span>، ثم معالجة <span class="font-style">السطح عالي اللمعان</span><span>؛ لوح عالي اللمعان معالج من جانب واحد: معالجة مباشرة </span <span class="font-style">سطح عالي اللمعان</span>',
    selectTip: 'يرجى تحديد اللوحة الصغيرة التي تحتاج إلى مكملات أدناه!',
    plankKeyWordPlaceholder: 'يرجى إدخال اسم اللوحة أو رقم اللوحة',
    surplusStoreSuccess: 'التخزين الناجح',
    editCutOrder: 'تعديل تسلسل القطع',
    setCutPoint: 'ضبط نقطة القطع',
    specialPaibanChangeErr: 'هناك ألواح ذات عمليات خاصة أو أخاديد لمعالجة اللحام. تبديل مخطط التخطيط غير مدعوم في الوقت الحالي!',
    storedSuccess: 'تم الاستبدال بنجاح! تم وضع اللوحة المحددة في إدارة قطع الغيار!',
    noSurplus: 'لم يتم الاستعلام عن أي مواد متبقية متاحة',
    selectErrTip: 'لا يمكن إصلاح المواد المتبقية، يرجى اختيار اللوحة الصغيرة العادية أولاً',
    noRoomIDTip: 'لا تحتوي هذه اللوحة على غرفة ID، ولا يمكن وضع قطع الإصلاح في المستودع. يرجى اختيار لوحات صغيرة أخرى أولا',
    noPlank: 'لم يتم العثور على اللوحة',
    noPaibanData: 'لا توجد بيانات تنضيد، لا يمكن المتابعة',
    historyNameErr: 'الرجاء إدخال اسم الخطة',
    tempErrTip: 'تم اكتشاف أنك لم تقم بإضافة القالب للمثاقب الخماسية/السداسية، لذلك لا يمكن تصدير ملفات معالجة الحفر الخماسية/السداسية. ملاحظة: تحتاج إلى إعادة التخطيط بعد اكتمال الإضافة',
    changeDataTip: 'ملاحظة: تم اكتشاف أن بياناتك قد تغيرت. هل تريد إنشاء ملف محفوظات جديد لحفظ هذا التغيير؟',
    upgrade: 'ترقية',
    upgradeTip: '، يمكنك النقر على الزر أدناه لترقية الإصدار',
    plankOverEdge: 'فشل تنزيل NC! يرجى التحقق مما إذا كانت هناك لوحات أو لوحات متداخلة خارج اللوحة الكبيرة',
    useSurplusTip: 'ما إذا كان سيتم خصم المادة المتبقية',
    noDataExport: 'لا توجد بيانات تنضيد يمكن تصديرها',
    noPlankExport: 'لا توجد بيانات لوحة صغيرة يمكن تصديرها',
    lockTip1: 'انقر لفتح. بعد إلغاء القفل، يمكنك',
    lockTip2: 'تعديل موقع وسمات اللوحة الصغيرة',
    unlockTip1: 'انقر للقفل. بعد القفل لا يمكنك تعديل موقع وسمات اللوحة الصغيرة',
    unlockTip2: 'edit the position and attributes of the small board',
    plankLockErr: 'تم قفل اللوحة الكبيرة ولا يمكن وضعها',
    lockPartEditTip: 'اللوحة مقفلة ولا يمكن تحريرها',
    glassEquipmentTip: 'عندما يكون خط الإنتاج عبارة عن آلة قطع زجاج، لا يمكن تحريك اللوحة',
    expandedTip: 'تتميز اللوحة بعملية أخدود خاصة ولا تدعم عمليات التحرير!',
    sameWidthPlankTip: 'عند تشغيل تخطيط شفرة المنشار، لا يمكن للوحة التحرك.',
    expandedArrangeTip: 'اللوحة لديها عملية أخدود خاصة وتحتاج إلى إعادة تخطيط!',
    dragErrTip: 'غير قادر على التركيب، يرجى التحقق من مادة اللوحة وخصائص اللون والسمك!',
    subtleSaveTip: 'تم تشغيل اللوحة ولكن لم يتم حفظها. هل تريد الخروج؟',
    rollTip: 'توجد ثقوب/فتحات على اللوحة الكبيرة، لذا لا ينصح بالنسخ!',
    glossRollErr: 'لوحة التمييز ممنوعة من الانقلاب',
    lockDeleteErr: 'اللوحة مقفلة ولا يمكن حذفها',
    deleteConfirmTip: 'لا يمكن استرداد عملية الحذف',
    deleteContinueTip: 'هل تريد المتابعة؟',
    deleteConfirm: 'يرجى تأكيد ما إذا كنت تريد الحذف',
    selectPlankTip: 'يرجى تحديد اللوحة قبل إجراء هذه العملية',
    storeFailTip: 'فشل تخزين المواد المتبقية! يرجى التحقق مما إذا كانت هناك ألواح أو ألواح متداخلة خارج اللوحة الكبيرة',
    repeatStoreErr: 'تم وضع ألواح المواد المتبقية المقطوعة حاليًا في التخزين',
    surplusStoreFail: 'فشل التخزين، يرجى التحقق مما إذا كانت الألواح مستطيلة أو ألواح على شكل L!',
    plankConfilictErr: 'وضع النقاط هنا غير مدعوم وسيتعارض مع اللوحات الأخرى',
    surplusErrTip: 'وضع النقاط هنا غير مدعوم وسينتج عنه مادة متبقية غير صحيحة',
    changeArrageSuccess: 'تم تبديل مخطط التخطيط بنجاح',
    trialProduction: {
      trialProductionSample: 'خزانة عينة الإنتاج التجريبي',
      trialProduced: 'لقد حاولت الإنتاج',
      trialWarning: '{fontStyleStart}إذا فشلت {fontStyleEnd} في إجراء التحقق من إنتاج خزانة العينة، فستكون وحدك المسؤول عن جميع الخسائر والعواقب الضارة التي تلحق بنفسك، الآخرين وبرامج النشر السحابي',
      trialSlotTip: 'أثناء الإنتاج التجريبي، يرجى التحقق بعناية مما إذا كان حجم الفتحات الأمامية والخلفية وعمقها وسطحها وموقعها صحيحًا',
      trialSlotTip1: 'لتجنب انعكاس الخزانة',
      trialSlotTip2: 'سؤال',
      pleaseUploadTrial: 'يرجى تحميل صور لخزانة عينة الإنتاج التجريبي المجمعة',
      uploadTrial: 'تحميل خزانة العينة'
      },
    awaitPlankStore: {
      store: 'مكتبة اللوحات للتخطيط',
      notTip: 'لا توجد مطالبات أخرى بعدم تخزينها',
      justLookCurrent: 'عرض اللوحات الصغيرة بالطلب الحالي فقط',
      notInPushStorage: 'لم يتم وضعها في المخزون',
      beInStorage: 'مخزنة بالفعل',
      searchPlaceholder: 'أدخل طلبًا للبحث عن اللوحات الصغيرة من المكتبة المراد كتابتها',
      plankUploading: 'يتم حفظ اللوحات',
      oneClickStorage: 'تخزين بنقرة واحدة في المكتبة للتخطيط',
      notUsePlank: 'لا تتوفر لوحات صغيرة',
      notPlank: 'لا يوجد تخزين مؤقت للوحة',
      dragPlankInHere: 'يمكنك سحب اللوحة هنا لحفظ اللوحة مؤقتًا',
      surplusCannotBeStorage: 'لا يمكن وضع المواد المتبقية في المستودع',
      plankHasBeenDeduction: 'تم خصم اللوحات الصغيرة أو لا توجد بيانات أصلية ولا يمكن وضعها في المستودع',
      plankLoadErr: 'فشل تحميل معلومات اللوحة',
      taskTitle: 'تحميل اللوحات في المكتبة المراد كتابتها',
      dataGenErr: 'خطأ في إنشاء البيانات',
      pushSuccess: 'التخزين الناجح',
      pushErr: 'حدث خطأ غير معروف وفشل المستودع',
      awaitBoxExistPlank: 'المخزون المراد تنضيده غير موجود في المستودع. يوصى بالعمل بعد دخول المستودع',
      mergeFrameDoorWholeTip: 'هذا المكون هو جزء لا يتجزأ من الباب الهيكلي. بعد التخزين، سيقوم النظام تلقائيًا بتفكيكه إلى لوحات فردية للإدارة.',
      checkPlankStatus: 'التحقق من حالة اللوحة...'
      },
    batchSetCut: 'الإعداد الدفعي لنقاط القطع',
    applyTo: 'ينطبق على:',
    ncDownloadLifeText: {
      checkData: 'اكتشاف البيانات',
      checkDone: 'اكتمل اكتشاف البيانات',
      checkDataText: 'اكتشاف البيانات',
      loadSetting: 'إعدادات التحميل',
      settingLoadDone: 'اكتمل تحميل الإعدادات',
      loadSettingText: 'تحميل الإعدادات',
      downloadNc: 'التنزيل NC',
      ncDownloadDone: 'NC اكتمل التنزيل',
      downloadText: 'تنزيل NC',
      loadPreferenceSetting: 'تحميل إعدادات التفضيلات',
      PreferenceSettingLoadDone: 'اكتمل تحميل التفضيلات',
      loadPreferenceText: 'تحميل التفضيلات',
      dealTemp: 'المعالجة القوالب',
      TempDealDone: 'اكتملت معالجة القالب',
      dealTempText: 'قوالب المعالجة',
      beBeingGenTagFile: 'إنشاء ملفات {fileType}',
      genTagFileDone: 'اكتمل إنشاء ملفات {fileType}',
      genTagFileText: 'إنشاء ملفات {fileType}',
      zip: 'إنشاء ملفات مضغوطة محلية',
      zipDone: 'اكتمل إنشاء ملفات مضغوطة محلية',
      genZipText: 'إنشاء ملفات مضغوطة',
      fileTypeText: 'صورة'
      },
    surplusCommonTemp: 'قوالب مشتركة للمواد المتبقية',
    plankErrTip: 'توجد لوحات صغيرة في خطة المواد الحالية ولا تتوفر لوحات كبيرة للتنضيد!',
    brandPlankErrTip: 'توجد أجزاء ذات علامة تجارية في خطة المواد الحالية ولا تتوفر لها ألواح علامة تجارية للتخطيط!',
    overSizeTip: 'عدد اللوحات الكبيرة غير كافٍ أو كبير الحجم',
    uselessPart: 'لا يوجد حاليًا أي لوحات صغيرة متوفرة على اللوحة الكبيرة',
    splitArranged: 'عدد اللوحات الصغيرة كبير جدًا، يرجى إعادة التنضيد أو تنضيدها بالدفعات',
    arrangedErrTip: 'فشلت عملية التنضيد، لا يوجد عدد كافٍ من اللوحات الكبيرة أو اللوحات الصغيرة كبيرة الحجم',
    knivesModalTitle: 'توجد ثقوب ولا يمكن العثور على الأداة',
    cannotDownloadByKnivesErr: 'غير قادر على التنزيل NC، اكتشف النظام أن لا يمكن العثور على الثقوب والشقوق التالية ولا يمكن العثور على الأداة',
    viewPart: 'عرض المشكلة لوحة صغيرة',
    deductionModalTitle: 'يرجى تحديد كائن الاستقطاع',
    bujianDeduction: 'خصم الأجزاء التكميلية لوحة صغيرة',
    paibanDeduction: 'خصم لوحة صغيرة لمنطقة التخزين المؤقتة',
    surplusDeduction: 'خصم لوحة المواد المتبقية',
    unlockPaiban: 'فتح المواد المتبقية المشاركة في التنضيد',
    maintain: 'الحفاظ على قفل المادة المتبقية المشاركة في التنضيد',
    lockModalText: 'هناك مادة متبقية اللوحة مشغولة بأوامر أخرى، سواء لإعادة التخطيط',
    lockNewSModalText: 'لوحة المواد المتبقية المستخدمة حاليًا مشغولة بأوامر أخرى. هل تريد متابعة التنزيل NC',
    rePaibanWarn: 'اللوحات الكبيرة المتبقية مشغولة بأوامر أخرى، ولا يوجد ما يكفي من اللوحات الكبيرة المتوفرة. يرجى الانتقال إلى قائمة القطع لإعادة التخطيط',
    sawRePaiban: 'ملاحظة: أنت تستخدم شفرة منشار للقطع، وقد تمت إضافة تخطيط لوحة ذات شكل خاص. تحتاج إلى إعادة التخطيط قبل أن تتمكن من إخراج ملف NC',
    togglePlankTip: 'تتمتع اللوحات بعملية أخدود خاصة، ولا يتم دعم عمليات التبديل الأمامية والخلفية!',
    stepCuttingMsg: 'يجب أن يكون عمق القطع ذو الطبقات أقل من سمك اللوحة',
    stepCuttingMsg2: 'لا يمكن إدخال عمق القطع ذو الطبقات إلا كرقم أكبر من 0',
    flipPlankTip: 'تم تشغيل آلة القطع المنقسمة ذات الفتحة لمعالجة لوحة واحدة، ولا يُسمح بعملية تدوير اللوحة!',
    genNoCutTagNotSupportExportPic: 'تم تمكين إنشاء ملصقات لأجزاء اللوحة غير المقطوعة. تصدير الصور غير مدعوم في الوقت الحالي.',
    allSmallPlanksAreNoCutNotInLayout: 'اللوحات الصغيرة الحالية كلها لوحات غير مقطعة ولا تشارك في التنضيد.',
    canStillExportHoleSlotOrPrintTag: 'لا يزال بإمكانك الاستمرار في تصدير ملفات معالجة الثقب أو طباعة الملصقات.',
    desMaterialNoCutNotSupportSwitchLine: 'تم تشغيل خط الإنتاج الحالي. لم يتم قطع مادة اللوحة الصغيرة المحددة. التبديل المباشر لخط الإنتاج غير مدعوم في الوقت الحالي.',
    desMaterialNoCutSettingChanged: 'اكتشف النظام أنه تم تعديل إعداد عدم قطع مادة اللوحة الصغيرة المحددة. يرجى إعادة التخطيط لضمان دقة الإنتاج',
    continueDownload: 'متابعة التنزيل',
    desMaterialNoCutErrorTip: 'توجد ثقوب/أشكال خاصة مخصصة لآلة النقش في اللوحات المحددة بحيث لا يتم قطع مادة اللوحة الصغيرة. تم تخصيص جميع الثقوب/الأشكال الخاصة الموجودة في هذا التنزيل للحفر بخمسة أو ستة جوانب. هل تريد مواصلة تنزيل الملف',
    clearReuseRelation: 'انقر لمسح علاقة إعادة الاستخدام',
    layoutReuseTip: 'انسخ تخطيط اللوحة الكبيرة بسرعة؛ تغييرات اللوحة تلغي علاقة إعادة الاستخدام تلقائياً',
    hasBeenReused: 'تمت إعادة الاستخدام',
    layoutReuse: 'إعادة استخدام التخطيط',
    specialProcessNotSupported: 'اللوحة تحتوي على عمليات خاصة، هذه العملية غير مدعومة',
    conflictNotSupported: 'يوجد تعارض في اللوحة، هذه العملية غير مدعومة',
    noAvailablePlankForReuse: 'لا توجد ألواح متاحة لإعادة الاستخدام',
    noMatchingPlankFound: 'لم يتم العثور على لوحة مطابقة',
    reuseBoard: 'إعادة استخدام اللوحة {number}',
    influenceTip: {
      title: 'الميزات التي تؤثر على معدل التحسين',
      empty: 'لا يوجد',
      groupParams: 'معايير التخطيط',
      surplusNoRoll: 'لا قلب للمواد الفائضة',
      surplusCustomTrim: 'قيمة تشذيب فردية',
      otherPlateCustomTrim: 'قيمة تشذيب فردية للوحة خاصة',
      knifeDiameter: 'قطر المنشار',
      surplusNoFlip: 'لا قلب للمواد الفائضة',
      surplusNotLayout: 'لا يتم تخطيط الوحات الفائضة للوحات المحددة',
      plankEdgeOff: 'تشذيب',
      surplusCustomTrim2: 'تعديل القص الزائد المخصص',
      other: 'ميزات أخرى قد تتأثر',
      enabled: 'مفعل',
      plankThicknessStacking: 'ترتيب سمك اللوحات',
      edgePreMilling: 'ترتيب سمك اللوحات',
      multiMaterialCuttingBlade: 'ترتيب سمك اللوحات',
      sawSpecialShapePart: 'ألواح ذات شقوق غير منتظمة لماكينات النشر والنقش',
      longPlankCutting: 'تعديل ثاني للوحات طويلة'
      }
    },
  paibanImg: {
    title: 'إدارة التخطيط',
    exportCustomPaibanImg: 'تصدير تخطيط مخصص',
    customPaibanImg: 'تخطيط مخصص',
    isCustomName: 'اسم تخطيط مخصص',
    template: 'قالب تخطيط',
    addTem: 'إضافة قالب',
    canvasIndexSearch: 'بحث عن رقم تسلسلي كبير للوحة',
    symbol: 'تحديد التخطيط',
    frontSlot: 'الفتحة الأمامية',
    backSlot: 'الفتحة الخلفية',
    frontHole: 'الوجه الأمامي',
    backHole: 'الوجه الخلفي',
    printNum: 'طباعة ورقة واحدة لعرضها على الأكثر',
    printUnit: 'الرسومات التخطيطية',
    edit: 'تحرير قالب التخطيط',
    temName: 'اسم القالب',
    rotate: 'تدوير التخطيط',
    showOverflow: 'عندما يفيض النص على اللوحة، يعرض سطر التعريف بيانات اللوحة الصغيرة',
    showHoleSlot: 'يعرض معلومات الفتحة والفتحة',
    bigPartCss: 'يضبط نمط مخطط التخطيط للوحة الكبيرة',
    partCss: 'يضبط نمط مخطط التخطيط للوحة الصغيرة',
    addTemTip: 'يمكن إضافة 10 قوالب مخطط تخطيطي فقط على الأكثر!',
    exportTip: 'يرجى التحقق من قالب تخطيط واحد على الأقل للتصدير!',
    editSaveTip: 'يرجى التأكد من ملء جميع الحقول المطلوبة قبل الحفظ!',
    exportDXF: 'تصدير DXF',
    exportDxfGeneral: 'DXF عام ثنائي الأبعاد',
    exportDxf3d: 'DXF مخصص ثلاثي الأبعاد',
    exportDxfGeneralTip: 'مناسب للمعالجة اليدوية أو القطع بالاعتماد على الرسم أو فحص نتائج التخطيط',
    exportDxf3dTip: 'مناسب للاستيراد إلى أنظمة خارجية للإنتاج؛ يدعم آلات القطع بالليزر المتكاملة من Huiya'
    },
  historyPage: {
    matchErrBySpecialTip1: 'لا يمكن العثور على تطابق للوحات الخاصة التالية، وستكون هناك مشاكل في إعادة التخطيط على صفحة التخطيط. إذا تم استخدام نظام تخطيط مختلط في هذا التاريخ، يرجى تجاهل هذه المطالبة',
    specialPlankInfoErrTip2: 'حدث خطأ في الحصول على معلومات اللوحة الخاصة، مما سيؤثر على وظيفة إعادة التخطيط في صفحة التخطيط',
    download: 'التنزيل المحلي',
    allType: 'حفظ الكل',
    handleSave: 'الحفظ يدويًا',
    specialPlank: 'خاص',
    surplusPlank: 'زائد',
    autoSave: 'الحفظ تلقائيًا',
    allArrange: 'كل التخطيط',
    searchPlaceholder: 'البحث باسم الطلب / دفعة التخطيط / رقم الطلب',
    saveHistoryName: 'اسم السجل المحفوظ',
    trailProduction: {
      title: 'خزانة عينة الإنتاج التجريبي',
      lastTime: 'تاريخ الإنتاج التجريبي الأخير',
      recordList: 'سجل الإنتاج التجريبي',
      start: 'بدء الإنتاج التجريبي',
      date: 'الوقت',
      outputFrom: 'موضع الإخراج',
      empty: 'لا توجد بيانات حتى الآن',
      record: 'سجل صورة خزانة نموذج الإنتاج التجريبي الذي تم تحميله',
      tip1: 'ملاحظة: يستخدم أمر الإنتاج التجريبي الحالي بيانات الإنتاج الافتراضية',
      tip2: 'ملاحظة: لا يستخدم أمر الإنتاج التجريبي الحالي أحدث معلمات إعداد العملية. يمكنك الذهاب إلى غرفة الإنتاج التجريبي لحفظه مرة أخرى!',
      download: 'تنزيل ملفات المعالجة'
      },
    deleteTip: 'هل أنت متأكد من حذف سجلات التاريخ التالية؟',
    startDate: 'تاريخ البدء',
    endDate: 'تاريخ الانتهاء',
    lastWeek: 'الأسبوع الماضي',
    lastMonth: 'الشهر الماضي',
    lastSeason: 'الأشهر الثلاثة الأخيرة',
    toArrangePage: 'التوجه إلى صفحة التنضيد',
    notArrangedTip: 'لم يتم تنضيد هذا السجل، يرجى الانتقال إلى قائمة المواد أولاً!',
    toMaterialPage: 'التوجه إلى صفحة قائمة المواد',
    lessSelectTip: 'يرجى تحديد سجل واحد على الأقل قبل إجراء هذه العملية',
    downloadNc: 'تنزيل ملفات المعالجة'
    },
  workShopPage: {
    warningTip: 'هذه الوظيفة تجريبية لفترة محدودة، يرجى ترتيب إنتاج طلبك بشكل معقول!',
    fileManager: 'إدارة ملف الإنتاج',
    selected: 'المحدد',
    suplement: 'أجزاء التجديد',
    size: 'الحجم',
    saveToStore: 'إضافة مستودع قطع الغيار',
    enterArrange: 'الدخول إلى التنضيد...',
    deleteTip: 'لا يمكن استعادة هذه البيانات بعد الحذف. هل تؤكد حذف هذه البيانات؟',
    arrangeTip: 'تحليل بيانات التجديد، يرجى الانتظار...',
    store: 'مستودع قطع الغيار',
    downloadFile: 'تنزيل ملفات الإنتاج',
    notBujianFile: 'لم يتم العثور على ملفات التجديد',
    productLineDelete: 'تم حذف خط الإنتاج وملف NC لا يمكن تحميلها!'
    },
  basePlankManager: {
    saveTip: 'ملاحظة: اضغط على Enter لحفظ',
    offsetSize: 'حجم التشذيب',
    overSizeTip: 'عندما يكون الحجم كبيرًا جدًا، سيتم تحديد لوحة ذات حجم أكبر تلقائيًا للتنضيد',
    addTip: 'إذا كانت اللوحة كبيرة الحجم أثناء التنضيد، ستظهر نافذة منبثقة لإضافة لوحة كبيرة خاصة تلقائيًا',
    defaultOversizePlankValue: 'تعيين الحجم الافتراضي للوحات الكبيرة الخاصة',
    onlyLayoutTooBig: 'ستقوم اللوحات الكبيرة كبيرة الحجم بترتيب اللوحات الصغيرة كبيرة الحجم فقط',
    settingRemark: 'ملاحظة: تم ضبط الوظيفة الأصلية هنا على الإعدادات الموجودة على اليمين',
    searchPlaceholder: 'مادة/لون لوحة البحث',
    syncData: 'مزامنة بيانات الخزانة',
    syncDataM: 'مزامنة بيانات باب الخزانة',
    deletePlank: 'حذف لوحة كبيرة خاصة',
    addPlank: 'إنشاء لوحة خاصة جديدة',
    matCodePlaceholder: 'يرجى تحديد اللوحة',
    thickPlaceHolder: 'يرجى تحديد السمك',
    widthErr: 'لا يمكن أن يكون عرض اللوحة فارغًا',
    heightErr: 'لا يمكن أن يكون طول اللوحة فارغًا',
    matCodeErr: 'لا يمكن أن تكون مادة اللوحة فارغة',
    colorErr: 'لا يمكن أن يكون لون اللوحة فارغًا',
    editPlank: 'تحرير اللوحة',
    deleteTip: 'لا يمكن استعادة هذه البيانات بعد الحذف. هل تؤكد حذف هذه البيانات؟',
    plankKnifeSelect: 'اختيار سكين القطع الأصلي',
    plankKnifeSelectTip: 'عندما تصل اللوحة إلى قواعد متعددة، تكون لسمك اللوحة الأولوية فوق مادة اللوحة',
    knifeSelectTip: 'ملاحظة: التنضيد المضمن لا يدعم حاليًا هذه الوظيفة',
    knife: 'أداة التقطيع',
    matcodeInput: 'يرجى إدخال مادة اللوحة',
    thickInput: 'يرجى إدخال سمك اللوحة',
    default: 'النظام الافتراضي',
    unessential: 'هذا العمود: اختياري',
    emptyTip: 'ملاحظة: إذا لم يتم ملء هذا العنصر، فلن يتم تمييز هذه البيانات عند مطابقة القطعة الأصلية!',
    defaultUse: 'التحديد افتراضيًا',
    editMatcode: 'تحرير المادة',
    syncTip: 'سيتم الحصول على البيانات الموجودة في {fromMc} واستبدالها ببيانات إدارة الفيلم الأصلية في التخطيط السحابي الحالي. هل هو متزامن؟',
    sameErr: 'نفس البيانات موجودة بالفعل',
    cancelDelete: 'تم إلغاء الحذف',
    syncErr: 'فشل المزامنة',
    syncSuccess: 'المزامنة ناجحة',
    syncDataTip: 'مزامنة {fromMc} البيانات',
    editErrTip: 'هناك معلومات غير مملوءة، يرجى التحقق!',
    numberCheck: '{type} يمكن إدخال الأرقام فقط!',
    deleteStandardPlate: 'حذف اللوحة القياسية',
    createStandardPlate: 'إنشاء لوحة قياسية جديدة',
    editStandardPlate: 'تحرير اللوحة القياسية',
    trimmingDimension: 'حجم التشذيب',
    front: 'السابق',
    back: 'التالي',
    left: 'اليسار',
    right: 'اليمين',
    frontTrim: 'التشذيب العلوي',
    backTrim: 'التشذيب السفلي',
    leftTrim: 'التشذيب الأيسر',
    rightTrim: 'التشذيب الأيمن',
    customTrim: 'قيمة التشذيب المخصصة',
    trimValue: 'قيمة القطع',
    notEmpty: '{type} لا يمكن أن يكون فارغًا!',
    edgeDir: 'التشذيب ({type})',
    brandPlank: 'لوحة العلامة التجارية',
    brandPlankTip: 'ملاحظة: يتم حذف وتعديل ألواح العلامة التجارية في مكتبة موارد ألواح عميل Cabinet',
    brand: 'العلامة التجارية',
    supplier: 'المورد',
    brandPlaceholder: 'يرجى اختيار العلامة التجارية',
    supplierPlaceholder: 'يرجى اختيار المورد',
    brandInput: 'يرجى إدخال العلامة التجارية',
    supplierInput: 'يرجى إدخال المورد',
    addBrandPlank: 'إضافة لوحة العلامة التجارية',
    deleteBrandPlank: 'حذف لوحة العلامة التجارية',
    editBrandPlank: 'تحرير لوحة العلامة التجارية',
    searchBrandPlaceholder: 'البحث عن العلامة التجارية/المورد/المادة/اللون'
    },
  bujianAndStore: {
    bujianStore: 'مستودع قطع الغيار',
    awaitStore: 'مكتبة تخطيط اللوحة',
    depositAwaitStore: 'احفظها في المكتبة ليتم تنضيدها',
    pushToAwaitStore: 'ضعه في المكتبة ليتم التنضيد',
    useTwoTableArrange: 'استخدم نموذجين للتنضيد',
    confirmUseTwoTableTip: 'تحتوي اللوحة الصغيرة المحددة حاليًا على مكتبة التصحيح والمكتبة المراد تنضيدها. هل تريد الاستمرار في تنضيد اللوحة الصغيرة؟',
    confirmAddPlankToAwaitStore: 'هل أنت متأكد من إضافة اللوحة المحددة إلى مكتبة التخطيط؟',
    pushStoreSuccess: 'التخزين الناجح',
    dataGenErr: 'خطأ في إنشاء البيانات',
    unknownErr: 'حدث خطأ غير معروف وفشل المستودع'
    },
  surplusPage: {
    surplusMaterial: 'قائمة المواد المتبقية',
    surplusStore: 'مكتبة المواد المتبقية',
    recycleBin: 'مكتبة المواد المتبقية',
    recycleBinTip: 'سيتم حذف بيانات المواد الزائدة من سلة المهملات تلقائياً بعد مرور 90 يوماً',
    "deleteReason-0": 'حذف يدوي',
    "deleteReason-1": 'خصم تركيب النص',
    "deleteReason-2": 'إخراج عبر عملية Guigui المحمولة',
    surplusShape: 'شكل المادة المتبقية',
    batchTransfer: 'نقل الدفعة',
    createNewSurplusStore: 'إنشاء مكتبة مواد متبقية جديدة',
    pushStoreSetting: 'إعدادات تخزين المواد المتبقية',
    surplusStoreName: 'اسم مكتبة المواد المتبقية',
    surplusStoreName2: 'اسم مكتبة المواد المتبقية',
    addSurplusStore: 'إضافة مكتبة المواد المتبقية',
    inventoryCeiling: 'حد المخزون',
    autoTransferTip: 'بعد الحذف، المواد المتبقية في سيتم نقل المستودع تلقائيًا إلى قائمة المواد المتبقية',
    asIndexPushStore: 'وتخزينه بالترتيب وفقًا لحالة تخزين المستودع',
    pushToSurplusMaterial: 'تخزين المواد المتبقية في القائمة',
    surplusStoreTable: {
      number: 'الرقم',
      name: 'اسم مكتبة المواد المتبقية',
      quantity: 'كمية المواد المتبقية المخزنة (وحدات)',
      capacity: 'حد مخزون المواد المتبقية (وحدات)',
      rules: 'قواعد تخزين المواد المتبقية',
      remark: 'ملاحظة',
      operation: 'التشغيل'
      },
    editSurplusStore: 'تحرير مكتبة المواد المتبقية',
    addSurplus: 'إضافة المادة المتبقية',
    importSurplus: 'استيراد المادة المتبقية',
    downloadSurplusTemplate: 'تنزيل قالب استيراد المواد المتبقية',
    batchExportSurplus: 'تصدير قائمة المواد المتبقية الحالية',
    surplusBatchImportExport: 'استيراد وتصدير دفعة من المواد المتبقية',
    surplusMaterialStorageCode: 'رمز تخزين المواد المتبقية',
    generateQRCodeSuccess: 'إنشاء رمز الاستجابة السريعة بنجاح',
    generateQRCodeFailed: 'فشل في إنشاء رمز الاستجابة السريعة',
    refreshQRCode: 'تحديث رمز الاستجابة السريعة',
    refreshQRCodeFailed: 'فشل تحديث رمز الاستجابة السريعة',
    cancelRefresh: 'تم إلغاء التحديث',
    refreshQRCodeTip: 'ما إذا كان سيتم تحديث رمز الاستجابة السريعة. بعد التحديث، سيصبح رمز الاستجابة السريعة الحالي غير صالح.',
    refreshQRCodeConfirm: 'موافق',
    refreshQRCodeCancel: 'إلغاء',
    wechatScanTip: 'افتح WeChat وامسح رمز الاستجابة السريعة لإضافة المواد المتبقية يدويًا إلى المستودع لاستخدامها',
    deletSurplus: 'حذف المادة المتبقية',
    editSurplus: 'تعديل المادة المتبقية',
    surplusNoRoll: 'تمكين المادة المتبقية دون نسخ',
    type: {
      all: 'جميع الأشكال'
      },
    allMatcode: 'جميع المواد',
    allThick: 'جميع السماكات',
    surplusName: 'اسم المادة المتبقية',
    rectSurplus: 'المادة المتبقية مستطيلة',
    LTypeSurplus: 'L مادة متبقية ذات شكل',
    noMatchSup: 'لم يتم العثور على بيانات ذات صلة',
    jumpTo: 'انتقل إلى',
    page: 'الصفحة',
    newMatcode: 'مادة جديدة',
    newColor: 'لون جديد',
    autoCreateColor: 'اضغط على Enter لإنشاء بطاقة ألوان تلقائيًا',
    nameLimit: 'أدخل ما يصل إلى 10 أحرف لاسم المادة المتبقية',
    nameLimitNameErr: 'لا يمكن أن يكون اسم المادة المتبقية فارغًا',
    tempLongTip: 'يمكن إدخال أرقام فقط بطول اللوحة',
    minLongLimit: 'يمكن إدخال أرقام فقط تم إدخاله لطول الجانب القصير',
    minLongEmptyTip: 'لا يمكن أن يكون طول الجانب القصير فارغًا',
    minLongLimitMax: 'لا يمكن أن يتجاوز طول الجانب القصير طول اللوحة',
    widthLimit: 'يمكن لعرض اللوحة إدخال أرقام فقط',
    minWidthLimit: 'يمكن لعرض الجانب القصير إدخال أرقام فقط',
    minWidthEmptyLimit: 'لا يمكن أن يكون عرض الجانب القصير فارغًا',
    minWidthLimitMax: 'لا يمكن أن يتجاوز عرض الجانب القصير عرض اللوحة',
    thickLimit: 'يمكن لسمك اللوحة إدخال أرقام فقط',
    thickEmptyLimit: 'لا يمكن أن يكون سمك اللوحة فارغًا',
    countInputLimit: 'يمكن أن تكون الكمية عددًا صحيحًا موجبًا فقط',
    countEmptyLimit: 'لا يمكن أن تكون الكمية فارغة',
    remarkMaxlimit: 'يمكن إدخال الملاحظات حتى 50 حرفًا',
    orderAddressMaxlimit: 'يمكن إدخال عنوان أمر المصدر حتى 100 حرف',
    orderIdMaxlimit: 'يمكن إدخال رقم أمر المصدر حتى 100 حرف',
    createTime: 'أضف الوقت',
    deleteTime: 'وقت الحذف',
    deleteReason: 'سبب الحذف',
    branchName: 'مستودع المواد المتبقية',
    orderAddress: 'عنوان أمر المصدر',
    orderId: 'رقم أمر المصدر',
    lockStatus: 'حالة القفل',
    lockOrder: 'أمر القفل',
    enableSurplusLock: 'تمكين وظيفة قفل المواد المتبقية',
    isCloseSurplusLock: 'بعد إيقاف تشغيل الوظيفة، سيتم إيقاف جميع المواد المتبقية مقفلة. هل تريد الاستمرار؟',
    confirm: 'تأكيد الإغلاق',
    surplusTransfer: 'نقل المواد المتبقية',
    targetSurplusStore: 'مكتبة المواد المتبقية المستهدفة',
    enableSurLockTip: 'بعد الفتح، سيتم قفل المواد المتبقية المستخدمة لكل تنضيد لمنع أوامر أخرى من شغلها',
    addMainRule: 'إضافة قاعدة رئيسية',
    surplusRules: 'قواعد تخزين المواد المتبقية',
    mainRulesTip: 'توجد علاقة OR بين القواعد الرئيسية، أي أنه طالما تم استيفاء قاعدة رئيسية واحدة، سيتم وضع المواد المتبقية في المستودع',
    mainRulesTip1: 'بعد إضافة قاعدة، سيتم تخزين المواد المتبقية التي وصلت إلى القاعدة في هذا المستودع أولاً. عندما يمتلئ المستودع، سيتم تخزينه في مستودعات المواد المتبقية المجانية الأخرى.',
    rule: 'القاعدة',
    addSubRule: 'أضف قاعدة فرعية',
    subRuleTip: 'العلاقة بين القواعد الفرعية هي، أي أن جميع القواعد الفرعية ضمن القاعدة الرئيسية يجب استيفاؤها في نفس الوقت قبل وضعها في المستودع',
    bigPlankMatCode: 'مادة اللوحة الكبيرة',
    bigPlankThick: 'سمك اللوحة الكبيرة',
    bigPlankColor: 'لون اللوحة الكبيرة',
    greaterEqual: 'أكبر من أو يساوي',
    lessEqual: 'أقل من أو يساوي',
    capNumberCheck: 'لا يمكن إدخال الحد الأعلى للمخزون إلا كعدد صحيح!',
    capEmptyCheck: 'لا يمكن أن يكون الحد الأعلى للمخزون فارغًا!',
    surNameEmptyCheck: 'لا يمكن أن يكون اسم مكتبة المواد المتبقية فارغًا!',
    mainRuleLimit: 'وصلت القاعدة الرئيسية إلى الحد الأعلى',
    delMainRuleTip: 'هل تريد حذف هذه القاعدة الرئيسية؟',
    matCodeEmptyCheck: 'لا يمكن أن تكون مادة الطبق الكبير فارغة!',
    thickEmptyCheck: 'سمك اللوحة الكبيرة لا يمكن أن يكون فارغاً!',
    textureEmptyCheck: 'لا يمكن أن يكون لون الطبق الكبير فارغًا!',
    enableWarehouseSecondCon: 'تمكين التأكيد الثانوي لتخزين المواد المتبقية',
    surplusWarehouseConfirm: 'تأكيد تخزين المواد المتبقية',
    surplusWarehouseConfirm1: 'تأكيد التخزين',
    closeSurplusConfirm: 'إيقاف تشغيل تأكيد التخزين (يمكن إعادة تمكينه في إعدادات صفحة إدارة المواد المتبقية)',
    position: 'موقع التخزين',
    nameRepeatTip: 'اسم المادة المتبقية الحالي موجود بالفعل، يرجى تعديله وإعادة إدخال المستودع',
    surLimitTip: 'وصلت مكتبة المواد المتبقية الحالية إلى الحد الأعلى أو لا تستوفي قواعد التخزين',
    surFailTip: 'فشل التخزين، أو يوجد اسم مكرر للمادة المتبقية أو أن تخزين صومعة المواد المتبقية قد وصل إلى الحد الأعلى أو لا يستوفي قواعد التخزين',
    surplusExistTip: 'بعض لوحات المواد المتبقية موجودة بالفعل في المكتبة، وقد فشلت هذه العملية',
    surplusExistTip2: 'الحالي لوحات المواد المتبقية موجودة بالفعل في المكتبة ولا يمكن تخزينها',
    currentPage: 'الصفحة الحالية',
    totalPage: 'حدد الكل'
    },
  printPage: {
    goto: 'اذهب الآن',
    surplusSizeTittle: 'تذكير بأن حجم المادة المتبقية صغير جدًا',
    surplusSizeErrTip: 'حجم المادة المتبقية صغير جدًا، يرجى الانتقال إلى خط الإنتاج المقابل لتعيين الحد الأدنى لحجم المادة المتبقية!',
    opacityTip: 'الدعم الفني المقدم من Zhihui Color Label',
    opacityTip2: 'لم يقم الحساب الحالي بشراء Zhihui Color Label؛ إذا تم شراؤه، يرجى ربط حساب الخزانة في برنامج تسمية الألوان',
    loadFontTip: 'تحميل ملف مورد الخط المطلوب، يرجى الانتظار',
    leftAlign: 'المحاذاة اليسرى',
    rightAlign: 'المحاذاة اليمنى',
    topAlign: 'المحاذاة العلوية',
    bottomAlign: 'محاذاة سفلية',
    horizontalAlign: 'محاذاة أفقية للمركز',
    verticalAlign: 'محاذاة عمودية للمركز',
    horizontalSplit: 'تقسيم أفقي',
    verticalSplit: 'تقسيم عمودي',
    norTag: 'تسمية أصلية عادية',
    surTag: 'تسمية المادة المتبقية',
    genTag: 'إنشاء تسمية',
    all: 'حدد الكل',
    deleteWarning: 'تذكير دافئ',
    print: 'طباعة',
    defaultTemplate: 'القالب الافتراضي (60 × 40)',
    editTemplate: 'تحرير القالب',
    deleteTip: 'لا يمكن استعادة حذف هذا القالب. هل أنت متأكد من حذف هذا القالب؟',
    tagSetting: 'إعدادات الملصقات',
    rememberSetting: 'سيتم تذكر الإعدادات بعد التعديل',
    genCutingTag: 'إنشاء ملصقات للألواح المشذبة',
    genSurplusTag: 'إنشاء ملصقات للألواح المتبقية',
    genPlankTag: 'إنشاء ملصقات للألواح الكبيرة',
    genPartTag: 'إنشاء ملصقات للألواح الصغيرة',
    genNoCutTag: 'إنشاء ملصقات للألواح غير المقطوعة',
    tagPosition: 'موضع الملصقات',
    tagPositionTip: '(فقط بالنسبة لآلات وضع الملصقات، تحتاج إلى ملء البيانات الإحداثيات X/Y أدناه.)',
    Xposition: 'Xالإحداثيات',
    Yposition: 'Yالإحداثيات',
    genPlankSuffix: 'إنشاء علامة لوحة كبيرة مما يؤدي إلى طمس لاحقة اسم الملف',
    arrangeMirror: 'مرآة صورة الملصق',
    drillPlankBase: 'مسند الحفر والوضع بخمسة أو ستة جوانب',
    drillPlankBaseTip: 'خطأ في الحصول على بيانات مسند وضع اللوحة، يرجى المحاولة مرة أخرى لاحقًا!',
    suitAuto: 'يتم تكييف فرز الملصقات للتحميل والتفريغ التلقائي:',
    colorLabel: 'إنشاء ملصقات ملونة',
    colorRevert: 'إنشاء ملصقات ألوان عكسية للألواح الصغيرة',
    displayEnAndZh: 'عرض اسم الغرفة/الخزانة/اللوحة باللغتين الصينية والإنجليزية',
    displayEnAndZhTip: 'يدعم فقط اسم الغرفة/الخزانة/اسم اللوحة الافتراضي. لا تصبح هذه الوظيفة نافذة المفعول بعد التغيير إلى اسم مخصص',
    up: 'لأعلى',
    down: 'لأسفل',
    default: 'الافتراضي',
    printSetting: 'إعدادات الطباعة',
    oneToMore: 'صفحات متعددة لكل صفحة',
    perPage: 'لكل ورقة',
    coloumn: 'أعمدة',
    tagMargin: 'فجوة التسمية',
    coloumnMargin: 'تباعد الأعمدة',
    specialMark: 'علامة خاصة',
    opacity: 'الشفافية',
    opacityTip3: 'تحتاج الصور بتنسيق BMP إلى تحديد اللون الحقيقي لدعم الشفافية',
    suite: 'التكيف',
    svgListTip: 'لم يتم تمكين إنشاء علامات اللوحة الصغيرة، يرجى التحقق من',
    size: 'الحجم',
    lightSide: 'الحافة المرئية',
    locFrontSide: 'واجهة الخزانة',
    openSide: 'اتجاه فتح الباب',
    extraTip: 'نصيحة: عند استخدام الطباعة المباشرة لأول مرة، يرجى إضافة ورقة جديدة بهذا الحجم مع تبديل الطول والعرض في إعدادات الطابعة، ثم استخدم الورق الجديد للطباعة (على سبيل المثال: حجم الورق الأصلي) 60×40، حجم الورق الجديد 40×60)',
    noMore: 'لا مزيد من',
    prepareData: 'جارٍ إعداد البيانات...',
    genTagFile: 'يتم الآن إنشاء الملصقات. يرجى عدم تبديل الصفحات، أو تصغير المتصفح، أو التمرير لأعلى أو لأسفل، وما إلى ذلك!',
    waitGen: 'برجاء الانتظار حتى يكتمل تحميل الملصق قبل التنزيل',
    tempLoading: 'جارٍ تحميل قالب الملصق، برجاء الانتظار',
    front: 'السابق',
    open: 'فتح',
    toEdit: 'اذهب للتحرير',
    simplifyOneCodeTip: 'ملاحظة: سمات الباركود المعينة في قالب الملصق هذا لا تدعم وظيفة "الرمز الشريطي البسيط"، يرجى تعديل سمات الباركود (سمات الباركود الموصى بها: CODE128)',
    plankTemp: 'قالب ملصق اللوحة الصغيرة',
    surplusTemp: 'قالب ملصق المادة المتبقية',
    enableSubTag: 'تفعيل الملصق الثانوي',
    enableSubTagTip: 'يمكن الضبط من المزيد من الإعدادات > إعدادات الملصق الثانوي للوح الصغير > تعيين مصدر البيانات الفعال لإنشاء الملصق الثانوي. بعد التفعيل يُنشأ الملصق الثانوي فقط عندما يكون لمصدر البيانات المضبوط قيمة على الملصق الثانوي، وإلا فلن يُنشأ.',
    goSet: 'الانتقال إلى الإعدادات',
    mainTag: 'الملصق الرئيسي للوح الصغير',
    subTag: 'الملصق الثانوي للوح الصغير',
    downloadSubTagTip: 'تحتوي الملصقات المُصدَّرة على ملصق ثانوي، ولا تستطيع خط إنتاج الملصقات التلقائي إنشاء الملصقات الثانوية حالياً. هل تريد متابعة الإخراج؟',
    embeddedSubTagTip: 'الوظيفة الثانوية للملصق غير مدعومة. يرجى فتح التصميم الإلكتروني للملصق لاستخدامه.',
    subTagPerSaveTip: 'تمت إنتهاء صلاحية الملصق الثانوي. يرجى إغلاق الملصق الثانوي وحفظه مرة أخرى.',
    subTagPerexportTip: 'تحتوي ملف الإنتاج المُصدَّر على صلاحيات ملصق ثانوي تسدد. تمت إنتهاء هذه الميزة ويجب إغلاقها وإخراجها مرة أخرى.',
    tempNamePlaceHolder: 'يرجى إدخال اسم القالب',
    editTip: 'يمكنك سحب الزر الأيسر إلى ورق الملصق الأيمن لإكمال تحرير قالب الملصق وفقًا لاحتياجاتك الخاصة',
    oneCode: 'باركود',
    image: 'صورة',
    arrow: 'سهم',
    editPage: {
      digitLimitation: 'حد الأرقام',
      title: 'تحرير قالب التسمية',
      reset: 'استعادة الافتراضي',
      exit: 'الخروج من التحرير',
      tagInfo: 'معلومات التسمية',
      tagName: 'اسم التسمية',
      tagSize: 'حجم التسمية',
      tagData: 'بيانات التسمية',
      dragTip: 'اضغط باستمرار على زر الماوس الأيسر واسحب تسمية البيانات',
      dataTip: 'يرجى تحديد معلومات البيانات في شريط الخصائص الأيمن',
      text: 'النص',
      dataSource: 'معلومات البيانات',
      graph: 'الرسومات',
      typograpyPic: 'رسم التخطيط',
      barCode: 'الرمز الشريطي',
      QRCode: 'رمز الاستجابة السريعة',
      plankMark: 'علامة اللوحة',
      holeSlotPic: 'مخطط الفتحات والفتحات',
      edgeBandPic: 'مخطط نطاقات الحواف',
      visibleEdgePic: 'الحافة المرئية',
      holeSlotPicZoom: 'قياس مخطط الفتحات والفتحات',
      rotateDeg: 'زاوية الدوران',
      colorDeep: 'عمق الألوان',
      surplusMark: 'تحديد المادة المتبقية',
      surplusSizePic: 'مخطط حجم المادة المتبقية',
      dataSize: 'حجم البيانات',
      extraList: 'قائمة إضافية',
      QRCodeFormat: 'تنسيق رمز الاستجابة السريعة',
      formatQR: 'QR التنسيق',
      formatDM: 'DM التنسيق',
      locIndex: 'الرقم التسلسلي للخزانة',
      plankFrontSign: 'علامة اللوحة',
      genNCSuffix: 'إنشاء NC لاحقة',
      table: 'الجدول',
      inputPlaceholder: 'يرجى النقر نقرًا مزدوجًا لإدخال النص',
      attribute: 'الخصائص',
      fontFamily: 'نوع الخط',
      fontSize: 'حجم الخط',
      fontWeight: 'غامق',
      flipOverProcessing: 'معالجة الوجه الآخر',
      showSideMachiningSequenceDiagramBorder: 'إظهار حدود المخطط التسلسلي للمعالجة الجانبية',
      showSideMachiningSequenceNumber: 'إظهار رقم التسلسل للمعالجة الجانبية',
      autoRow: 'التفاف الخط',
      rowMargin: 'تباعد الأسطر',
      autoFontSize: 'ضبط حجم الخط تلقائيًا للتجاوز',
      statisticsDimension: 'الأبعاد الإحصائية',
      noLimit: 'غير محدود',
      sameOrderNo: 'نفس الترتيب',
      sameRoom: 'نفس الغرفة',
      sameWardrobe: 'نفس الخزانة',
      alignWay: 'المحاذاة',
      JustifyLeft: 'محاذاة إلى اليسار',
      JustifyRight: 'محاذاة إلى اليمين',
      JustifyCenter: 'محاذاة للوسط',
      otherOpration: 'عمليات أخرى',
      attributeReset: 'إعادة تعيين المعلمة',
      barCodeSize: 'حجم الرمز الشريطي',
      installPic: 'مخطط التثبيت',
      plankCode2: 'الرمز الشريطي للوحة (noMark)',
      frontCode: 'الرمز الشريطي الأمامي',
      backCode: 'الرمز الشريطي العكسي',
      orderRemark: 'ملاحظات الطلب',
      NCFileName: 'اسم الملف الفارغ',
      NCFileNameTip: 'يجب ألا يحتوي اسم الملف الفارغ على أحرف صينية ولا يمكن أن يتجاوز طوله 10 أرقام',
      showOpenSide: 'اتجاه فتح باب العرض',
      limitFixed: 'الحد من عدد النقاط العشرية',
      showFrontHS: 'عرض الفتحات الأمامية',
      showBackHS: 'إظهار الفتحة العكسية',
      showPartEdge: 'نطاق حافة لوحة العرض',
      showPlankSize: 'حجم لوحة العرض',
      tempNamePlaceholder: 'يرجى إدخال اسم العلامة',
      deleteAreaTip: 'يرجى تحديد الكتلة المراد حذفها',
      suitShunt: 'نطاق حافة لوحة العرض',
      suitShuntTip: 'بعد الاختيار ، لا يتم إنشاء رموز الشريطية للأجزاء التي لا تحتوي على عمليات لاحقة بعد التفرع',
      noHoleSlot: 'يتم عرض الرمز الشريطي أيضًا للفتحات غير المثقوبة',
      rotate: 'تدوير الرمز الشريطي',
      barcodeAtrribute: 'خصائص الرمز الشريطي',
      imgSize: 'حجم الصورة',
      graphStyle: 'نمط الرسم',
      noEdgeDisplay: 'نطاق الحافة هو 0 ولا يتم عرضه',
      allEdgeNoDisplay: 'لا يتم عرض نطاق الحافة',
      isShowDiffEdgeColor: 'عرض كل منهما لون نطاق الحافة',
      hideSameEdgeColorAsPlank: 'إخفاء لون الحافة عندما يكون مساويا للون اللوح',
      hideSameEdgeColorAsPlankTip: 'التنضيد السحابي المضمن غير مدعوم مؤقتًا',
      imgRotate: 'تدوير الصورة',
      circleD: 'قطر إطار الدائرة',
      roomNo: 'رقم الغرفة',
      roomOrder: 'رقم الخزانة (مرتبة حسب الغرفة)',
      alphabetically: 'الترتيب حسب الحروف',
      numberOrder: 'الترتيب حسب الأرقام',
      specialMarkup: 'رموز العلامات الخاصة',
      smallPlateMarking: 'علامة اللوحة الصغيرة',
      arrow: 'سهم',
      triangle: 'علامة الزاوية المثلثة',
      sixSideDrillPlankBase: 'مسند الحفر والوضع بخمسة أو ستة جوانب',
      boldSettingTip: 'PDF الجسم الأسود غير مدعوم',
      frontEdge: 'إظهار الجانب الأمامي للخزانة',
      visibleEdge: 'إظهار الحافة الظاهرة',
      lineCount: 'عدد الكلمات في كل سطر'
      },
    autoSaveToHistory: 'يتم حفظها تلقائيًا في التاريخ!',
    firstPrintTip: 'عند استخدام الطباعة المباشرة لأول مرة، يرجى إضافة ورقة جديدة بهذا الحجم مع تبديل الطول والعرض في إعدادات الطابعة، ثم استخدام الورقة الجديدة للطباعة',
    tagDownloading: 'يتم الآن تنزيل الملصقات...',
    cutLaveEnd: 'يتم إنشاء ملصقات المواد المتبقية خلف كل لوحة كبيرة',
    deleteTemplate: 'حذف القالب',
    copyTemplateRenderUrl: 'نسخ رابط القالب',
    noPermission: 'تم إيقاف الوظائف غير المصرح بها التالية في القالب المستورد',
    moreOperation: 'المزيد من العمليات',
    importTemplate: 'استيراد القالب',
    importTemplateLink: 'الصق عنوان رابط قالب التسمية في مربع الإدخال أدناه لإكمال استيراد القالب',
    importTemplateLinkPlaceholder: 'يرجى إدخال رابط القالب',
    noDeleteTemplate: 'لا يمكن حذف القالب الافتراضي',
    tip1: 'لا يوجد رابط نسخ للقالب الحالي',
    tip2: 'تم نسخ رابط بيانات القالب الحالي.',
    tip3: 'فشل نسخ رابط القالب، يرجى المحاولة مرة أخرى لاحقًا',
    tip4: 'غير قادر على التعرف على رابط استيراد القالب، يرجى تنزيله مرة أخرى واستيراده.'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: 'تم تصنيفها إلى مجلدات مختلفة وفقًا للون والمادة والسمك وحجم اللوحة (وضع العلامات على الملفات معًا)',
    notOpeFolderPermission: 'التشغيل غير المصرح به لهذا الدليل',
    notFindFolder: 'غير قادر على اكتشاف هذا الدليل في العميل الحالي',
    productLineUniversal: 'مشترك في جميع خطوط الإنتاج',
    effectCondition: 'يجب إعادة كتابة هذا الإعداد قبل أن يصبح ساري المفعول',
    addPath: 'إضافة مسار',
    downloadPositionChangeByType: 'تم تغيير موقع تنزيل الملف الذي تم إنشاؤه إلى {type}',
    isDeleteFolder: 'هل أنت متأكد من الحذف موقع تخزين الملفات المستخدمة؟',
    netWorkIsNotSafe: 'يبدو أن بيئة الشبكة الخاصة بك غير آمنة ولا يمكننا تمكين هذه الوظيفة. يمكنك تزويدنا بملاحظاتك',
    NotSupportBrowse: 'متصفحك لا يدعم هذه الوظيفة حتى الآن. يرجى تنزيل أحدث إصدار <a href="https://www.microsoft.com/zh-cn/edge/download" target="_blank" > Edge </a> لاستخدام المتصفح',
    notSupportDisk: 'الدلائل على مستوى النظام ليست اختيارية، مثل 【桌面】 【C盘】',
    useFolderDownload: 'يتم تنزيل ملفات الإنتاج في شكل غير مضغوط',
    downloadPosition: 'تنزيل موقع الملف',
    changeUseFolder: 'تغيير',
    folderNameSetting: 'إعدادات المجلدات',
    mainFolder: 'مجلد المستوى الأول',
    exportNameSetting: 'تتم تسمية ملف المعالجة المصدر وفقًا لرقم الطلب',
    fileMax: 'الحد الأقصى لاسم الملف هو',
    char: 'أحرف',
    overTip: 'لن يتم عرض الجزء الزائد (سيتم تسمية الحزمة المضغوطة لخريطة التسمية وملف json على اسم مجلد المستوى الأول)',
    example: 'مثال',
    engravingFolder: 'مجلد آلة النقش',
    electronicSawFolder: 'مجلد المنشار الإلكتروني',
    labellingFolder: 'مجلد آلة وضع العلامات',
    sideHoleDrillFolder: 'مجلد آلة الفتحة الجانبية',
    fiveDrillFolder: 'مجلد ماسي خماسي الجوانب',
    sixDrillFolder: 'مجلد ماسي سداسي الجوانب',
    PTPFolder: 'PTP مجلد',
    labellingTagFolder: 'مجلد صور الملصقات',
    surplusFolder: 'إعداد لوحة ملفات المواد المتبقية',
    surplusBigPlankSetting: 'يتم وضع ملف إفراغ لوحة المواد المتبقية/صورة الملصق/ملف الملصق بشكل منفصل',
    surplusBigPlankSettingTip: 'بعد الفتح، سيتم وضع ملف NC الخاص بالمادة المتبقية وصورة الملصق وملف الملصق في مجلد منفصل',
    folderMergeSetting: 'إعدادات دمج المجلدات',
    folderMerge: 'دمج المجلدات',
    mergeName: 'دمج الاسم',
    subMergeFolder: 'الدمج في المجلدات الفرعية حسب لون المادة وسمكها',
    subFolderName: 'اسم المجلد الفرعي',
    splitChar: 'المحدد',
    splitTip: '(لا تدعم الإدخال / : ? < > | . ” * وأحرف أخرى)',
    folderAutoAdd: 'يزيد عدد المجلدات من قيمة البداية',
    resetTip: '(إعادة الضبط إلى قيمة البداية عند الصفر كل يوم)',
    emptyErrTip: 'لا يمكن أن تكون المعلومات فارغة',
    repeatErrTip: 'اسم ملف مكرر',
    mergeDataTip: 'يجب أن تكون مادة اللوحة واللون والسمك والطول والعرض موجودة أو يزيد عدد الملفات تلقائيًا أو سمك لون مادة اللوحة',
    engravingFileSetting: 'إعدادات ملف آلة النقش',
    engravingSplitZF: 'ضع الملفات الأمامية/الخلفية لآلة النقش في مجلدات مختلفة',
    engravingSplitZFTip: 'ينطبق على آلة وضع العلامات الأوتوماتيكية 123،',
    engravingSplitWorkstation: 'آلة النقش حسب موقع العمل',
    engravingSplitWorkstationTip: 'يدعم الآلة النقش والآلة النقش القطع',
    holeFileSetting: 'إعدادات ملف التثقيب',
    holeFileSingle: 'يتم وضع ملفات التثقيب بشكل منفصل في المجلدات حسب ترتيب مختلف'
    },
  moreSettings: {
    generalSetting: 'الإعدادات العامة',
    outSyncTip: 'يتم إنشاء نافذة منبثقة سريعة عندما تكون بيانات القطعة الأصلية للتنضيد السحابي غير متزامنة مع الخزانة',
    secondarySwitchShow: 'لا يزال المحتوى الثانوي الذي يتم التحكم فيه بواسطة المفتاح في إعدادات آلة النقش معروضًا بعد إيقاف تشغيل المفتاح',
    isFrameDoorTip: 'يتم إنشاء نافذة منبثقة سريعة عندما يتم معالجة أبواب الأطار',
    exPaibanTip: 'يتم إنشاء نافذة منبثقة سريعة عند استخدام مادة متبقية ذات شكل خاص/تنضيد متداخل ذو شكل خاص',
    isDesMaterialNoCutTip: 'يتم إنشاء نافذة منبثقة سريعة عندما لا يتم قطع مادة اللوحة الصغيرة، وهناك ثقوب/أشكال خاصة مخصصة لها آلة النقش',
    surpTagThresholdTextHalf1: 'عندما تكون مساحة المادة المتبقية (المواد المتبقية غير المقطوعة) أقل من',
    surpTagThresholdTextHalf2: 'لا تقم بإنشاء ملصقات للمواد المتبقية',
    innerShapeToolMatch: 'تقوم آلة النقش تلقائيًا بتحديد الأداة المناسبة لمعالجة الأشكال الخاصة الداخلية',
    innerShapeToolMatchTip: '(تقوم آلة النقش بمعالجة الأشكال الخاصة الداخلية بقطر أصغر من سكين التقطيع. يمكن تمكين هذه الوظيفة عند حدوث خطأ في الحجم ولا يمكن معالجتها)',
    innerShapeToolMatchTip2: 'ملاحظة: بعد التمكين، سيتم استخدام أصغر قطع فتحة الطحن. يرجى ضبط "طول الأداة" و"أقصى عمق معالجة فردي" لأصغر قاطعة طحن ذات فتحة معقولة. يسري مفعوله فقط في التخطيط السحابي',
    surNotLayout: 'تحديد لوحة كبيرة تحتوي على مادة متبقية لا يؤدي إلى محاذاة اللوحة المحددة.',
    surNotLayoutTip: 'بعد الفتح، 1. لا يمكن ترتيب المواد المتبقية في اللوحة الكبيرة. يحتوي اسم اللوحة الصغيرة على الاسم أدناه. 2. عند التنضيد، يمكنك اختيار ما إذا كانت هذه الوظيفة صالحة لهذا التنضيد',
    addPlank: 'أضف اسم لوحة',
    addPlankTip: 'أضف اسم لوحة صغيرة واحدة على الأقل',
    thisInput: 'أدخل هنا',
    surNotLayoutMat: 'لم يتم ترتيب المادة المتبقية لتحديد لوحة صغيرة',
    subTagSetting: 'إعدادات الملصق الثانوي للوح الصغير',
    subTagDataSource: 'تعيين مصدر البيانات الفعال لإنشاء الملصق الثانوي',
    subTagDataSourceTip: 'بعد التفعيل يمكن إضافة مصادر بيانات تتحكم في إنشاء الملصق الثانوي. يُنشأ الملصق الثانوي عندما يحتوي على مصدر البيانات هذا ويكون للمصدر قيمة.',
    addSubTagDataSource: 'إضافة مصدر بيانات',
    addSubTagDataSourceTip: 'لا يُسمح بإضافة مصادر بيانات مكررة',
    addSubTagDataSourceTip1: 'يرجى إضافة مصدر بيانات واحد على الأقل',
    addSubTagDataSourceTip2: 'لا يمكن أن يكون مصدر البيانات فارغًا، يرجى الاختيار',
    reuseMatchingPlankName: 'إعادة استخدام المطابقة حسب اسم اللوحة',
    reuseMatchingPlankNameTip1: 'عند تعطيل هذه الميزة، تطابق إعادة استخدام التخطيط الألواح التي لها نفس المادة واللون والسماكة والأبعاد والملمس وخصائص اللمعان العالي',
    reuseMatchingPlankNameTip2: 'عند تمكين هذه الميزة، بالإضافة إلى شروط التطابق المذكورة أعلاه، يُضاف أيضاً التطابق حسب اسم اللوحة'
    },
  lineManager: {
    add: 'أضف خط إنتاج',
    engraving: 'معدات القطع',
    holeSlotEquip: 'معدات معالجة الفتحات',
    workSetting: 'إعدادات المعالجة',
    noUse: 'غير ممكّنة',
    warningTip: '* ملاحظة: بعد ضبط الوظائف التالية، يرجى عدم حفظها على صفحة إرساء جهاز عميل الخزانة لتجنب إعادة تعيين المعلمة!',
    engravingSetting: 'إعدادات ماكينة القطع',
    workWay: 'طريقة المعالجة',
    cutedSpecial: 'معالجة فتحات الفتحات الخاصة:',
    noWork: 'هذا الخيار غير فعال بالنسبة للقالب الافتراضي للحفر الخماسي/السداسي',
    onlyCut: 'التقطيع فقط',
    onlyFrontHoleSlot: 'معالجة الفتحات الأمامية والخلفية للوحة فقط',
    onlyHoleSlot: 'معالجة الفتحات الأمامية والخلفية للوحة فقط',
    sideHoleSetting: 'إعدادات ماكينة الفتحات الجانبية',
    cutHoleSlot: 'فتحات الفتحات المعالجة',
    minSize: 'حجم الجانب القصير',
    maxSize: 'حجم الجانب الطويل',
    minSize2: 'مم جميع',
    minSize3: 'والأجزاء ذات الشكل الخاص',
    onlyFrontHoleSlotTip: 'صفحة التخطيط على اللوحة فقط الألواح الصغيرة ذات فتحات الفتحات في المقدمة',
    onlyFrontHoleSlotTip2: 'لا تتضمن فتحات جانبية فتحات جانبية',
    holeAndSlot: 'الثقوب والفتحات',
    empty: 'فارغة',
    singleHole: 'فتحة واحدة',
    singleSlot: 'فتحة واحدة',
    diameterRange: 'نطاق قطر الفتحة',
    hDeepRange: 'نطاق عمق الفتحة',
    widthRange: 'نطاق عرض الفتحة',
    sDeepRange: 'نطاق عمق الفتحة',
    to: 'إلى',
    specialHS: 'فتحات الفتحات الخاصة والأشكال الخاصة',
    allowRoll: 'السماح لآلة القطع بتكرار فتحات الفتحات الخاصة ومعالجتها',
    engravingPath: 'معالجة الأجزاء ذات الشكل الخاص من اللوحة على آلة القطع',
    curve_range: 'جميع الأجزاء ذات الشكل الخاص من اللوحة مع الجانب الطويل للجزء ذي الشكل الخاص أكبر من',
    curve_range2: 'all special shape parts of the board',
    curveArea: 'منطقة ذات شكل خاص',
    drillSetting: 'ترصيع ماسي بخمسة أو ستة جوانب',
    engravingCuted: 'فتحات الثقب التي تتم معالجتها على آلة القطع موجودة في المثقاب الخماسي/ السداسي',
    engravingCutedSpecial: 'الأجزاء الخاصة التي تتم معالجتها على آلة القطع موجودة في المثقاب الخماسي/ السداسي',
    genCuttingPath: 'إنشاء بيانات القطع',
    otherCuted: 'فتحات الثقب التي تتم معالجتها بواسطة معدات أخرى موجودة في المثقاب الخماسي/ السداسي',
    noGen: 'لا تولد',
    genCut: 'تولد وتعالج',
    genNoCut: 'تولد لكن لا تعالج',
    cutTip: 'ملاحظة: يسري هذا الخيار فقط على ملفات الحفر المخصصة ذات الخماسية أو السداسية',
    maxShortSize: 'الحد الأقصى لحجم الجانب القصير',
    maxLongSize: 'الحد الأقصى لحجم الجانب الطويل',
    normalSlot: 'الفتحة العادية',
    specialSlot: 'الفتحة الخاصة',
    combinSetting: 'إعدادات المعدات المجمعة',
    allowShortSize: 'السماح بحجم جانبي قصير',
    equipment1: 'الجهاز الأول',
    equipment2: 'الجهاز الثاني',
    noSameTip: 'ملاحظة: لا يمكن تحديد جهازين بنفس الوقت',
    workRange: 'جهاز يمكن معالجة نطاق فتحة الفتحة',
    rangeWarning: 'ملاحظة: يمكن تعيين نطاق معالجة واحد فقط للمعدات، وستتم معالجة نطاق معالجة واحد غير المعدات على الجهاز الثاني، يرجى العمل بحذر!',
    deleteWarning: 'لا يمكن استعادة حذف خط الإنتاج هذا (سيتم حذف جميع الإعدادات الموجودة ضمن خط الإنتاج هذا). هل أنت متأكد من حذف خط الإنتاج هذا؟',
    top: 'الأعلى',
    inputCheck: '{msg} لا يمكن أن تكون القيمة الدنيا أكبر من القيمة القصوى',
    lockTip: 'تم قفل خط الإنتاج وتم حظر العمليات!',
    reNameTip: 'لا يمكن تعديل اسم خط الإنتاج الافتراضي',
    permissonTip: 'انتهت صلاحية معلومات الهوية، يرجى إعادة فتح هذه الصفحة من الخزانة!',
    permissonErr: 'ليس لديك هذا الإذن بعد، يرجى ترقية إصدار الحساب!',
    permissionOneMacErr: 'عدد خطوط الإنتاج المتكاملة التي يمكنك استخدامها حاليًا هو {idx}. إذا كنت بحاجة إلى زيادته، يرجى الاتصال بموظفي المبيعات!',
    permissionSawErr: 'ليس لديك الإذن باستخدام آلة النشر والنقش. يرجى الاتصال بالمبيعات لشراء حزمة ملحقات النشر المصنوعة بالكامل من الألومنيوم قبل استخدامها.',
    getAuthError: 'فشل الحصول على أذونات الجهاز!',
    sawAddNumber: 'تم استنفاد عدد خطوط إنتاج المنشار الإلكتروني المتوفرة لديكم حالياً. إذا كنت بحاجة إلى زيادة، يرجى الاتصال بالمبيعات!',
    newLine: 'خط إنتاج جديد {idx}',
    deleteCheck: 'لا يمكن حذف الكل',
    deving: 'قيد التطوير',
    combinTip: 'يرجى النقر فوق إعدادات المعدات المجمعة أدناه لإعداد',
    noUseEquip: 'لم يتم تمكين معدات المعالجة',
    equipmentSelectTip: 'عند تحديد آلة القطع لمعدات التجميع، لا يمكن لمعدات القطع تحديد المنشار الإلكتروني',
    lineLoading: 'يتم تحميل البيانات',
    strenchType: 'نوع فتحة جهاز فرد الشعر',
    aioProcessTip: 'لقد قمت بتمكين جهاز "الجهاز متعدد الإمكانات"، وتكون طريقة المعالجة افتراضية لمعالجة الفتحات الأمامية والخلفية للوحة',
    aioProcessTip2: 'فتحات ثقب خاصة تتم معالجتها في جزء آلة النقش بعد تمكين الجهاز متعدد الإمكانات',
    aioProcessTip3: 'ملاحظة: هذه الوظيفة غير متوافقة مع آلات النقش التي تتيح تبادل المحاور XY. يرجى الاستخدام بحذر',
    specialHoleTip: 'ملاحظة: عند استخدام وظيفة "معالجة فتحات الفتحات الخاصة" المذكورة أعلاه، يرجى ضبط "طريقة التثقيب عبر الفتحة" و"طريقة التثقيب عبر الفتحة" على التثقيب لمرة واحدة',
    specialHoleTip2: 'ملاحظة: عند استخدام وظيفة "معالجة فتحات الفتحات الخاصة" المذكورة أعلاه، يرجى ضبط "طريقة الحفر عبر الفتحة" و"طريقة التثقيب عبر الفتحة" على التثقيب لمرة واحدة فقط',
    fiveSixNotTake: 'هذا الخيار غير فعال بالنسبة للقالب الافتراضي للحفر الخماسي/السداسي',
    onlyFrontSide: 'معالجة فقط الجانب الأمامي.',
    onlyBackSide: 'تتم معالجة الجانب العكسي فقط',
    less: 'أقل من',
    equal: 'يساوي',
    greater: 'أكبر من',
    or: 'أو',
    and: 'و',
    bothFrontBack: 'معالجة أمامية وخلفية',
    shareDataErrTip: 'يتم تطبيق هذه البيانات بواسطة {operatorPhone}، ip: {actionIp}',
    restoreParams: 'استعادة المعلمات',
    loadMore: 'تحميل المزيد',
    currentCombinationEquipment: 'المعدات المركبة المحددة حاليًا، معدات القطع لا تسمح بالتبديل إلى آلة قطع الزجاج',
    selectEquipmentType: 'يرجى تحديد نوع المعدات',
    ruleRemark: 'ملاحظات القاعدة',
    remarkPlaceholder: 'هذه معلومات ملاحظة. يمكنك ملاحظة العمليات التي تتم معالجتها بواسطة هذه القاعدة لتجنب النسيان. بعد ملئ البيانات، احفظ خط الإنتاج ليصبح ساري المفعول',
    onlyNoSideHoleSlotSmallPlank: 'الألواح الصغيرة فقط بدون ثقوب/فتحات جانبية'
    },
  cuttingDock: {
    title: 'الفتح والإرساء',
    autoStockCode: 'رمز التحميل والتفريغ التلقائي',
    stationStart: 'بدء المحطة',
    stationStartCode1: 'رمز بدء المحطة 1',
    stationStartCode1Placeholder: 'أدخل رمز بدء المحطة 1',
    stationStartCode2: 'رمز بدء المحطة 2',
    stationStartCode2Placeholder: 'أدخل رمز بدء المحطة 2',
    stationEnd: 'نهاية المحطة',
    stationEndCode1: 'رمز نهاية المحطة 1',
    stationEndCode1Placeholder: 'أدخل رمز نهاية المحطة 1',
    stationEndCode2: 'رمز نهاية المحطة 2',
    stationEndCode2Placeholder: 'أدخل رمز نهاية المحطة 2',
    frontBackStart: 'البداية الأمامية والخلفية',
    frontBackEnd: 'النهاية الأمامية والخلفية',
    frontStartCode: 'رمز البداية الأمامية',
    frontStartCodePlaceholder: 'أدخل رمز البداية الأمامية',
    frontEndCode: 'رمز النهاية الأمامية',
    frontEndCodePlaceholder: 'أدخل رمز البداية الأمامية',
    backStartCode: 'رمز البداية العكسية',
    backStartCodePlaceholder: 'أدخل رمز البداية العكسية',
    backEndCode: 'رمز النهاية العكسية',
    backEndCodePlaceholder: 'أدخل رمز النهاية العكسية',
    plankStart: 'تدوير لوحة البداية',
    plankEnd: 'تدوير لوحة النهاية',
    plankRollCode1: 'رمز تحويل المحطة 1',
    plankRollCode1Placeholder: 'أدخل رمز تحويل المحطة 1',
    plankRollCode2: 'رمز تحويل المحطة 2',
    plankRollCode2Placeholder: 'أدخل رمز تحويل المحطة 2',
    autoBaitingCode: 'رمز التفريغ التلقائي',
    autoBaitingCode1: 'رمز مسح المحطة 1',
    autoBaitingCode1Placeholder: 'أدخل رمز مسح المحطة 1',
    autoBaitingCode2: 'رمز مسح المحطة 2',
    autoBaitingCode2Placeholder: 'أدخل رمز مسح المحطة 2',
    thickMarkPermission: 'ليس لديك حالياً صلاحية وضع علامة السمك الكبير للبلاطة، يرجى الاتصال بالمبيعات للشراء قبل الاستخدام',
    thickMark: 'وضع علامة السمك الكبير للبلاطة',
    preStartEquipment: 'معدات ما قبل التشغيل',
    firstKnifePreCode: 'رمز التشغيل المسبق للأداة الأولى مقدمًا',
    secondKnifePreCode: 'رموز التشغيل المسبق للأداة الثانية والأداة اللاحقة مقدمًا',
    rowInsert: 'إدخال الخط',
    pumpPause: 'إيقاف مضخة التفريغ مؤقتًا',
    pumpPauseTip: 'ملاحظة: تحتاج معدات المحطة الواحدة إلى ملء نفس "التحميل التلقائي" "رمز التعليق الأمامي للمعالجة على الوجهين" لكل من المحطة 1 والمحطة 2',
    pumpPause2Tip: 'ملاحظة: تحتاج معدات المحطة الواحدة إلى ملء نفس "رمز إيقاف مضخة التفريغ" لكل من المحطة 1 والمحطة 2',
    pumpPauseCode1: 'رمز إيقاف مضخة التفريغ للمحطة 1',
    pumpPauseCode1Placeholder: 'يرجى ملء رمز إيقاف مضخة التفريغ للمحطة 1',
    pumpPauseCode2: 'رمز إيقاف مضخة التفريغ للمحطة 2',
    pumpPauseCode2Placeholder: 'يرجى ملء رمز إيقاف مضخة التفريغ للمحطة 2',
    annotationCode1: 'رمز التعليق الأمامي للمعالجة على الوجهين للمحطة 1',
    annotationCode1Tip: 'المعدات المناسبة لتعليمات مختلفة للتحميل التلقائي للجانب الأمامي',
    annotationCode1Placeholder: 'أدخل رمز التعليق الأمامي للمعالجة على الوجهين في المحطة 1',
    annotationCode2: 'رمز التعليق الأمامي للمعالجة على الوجهين في المحطة 2',
    annotationCode2Placeholder: 'أدخل رمز التعليق الأمامي للمعالجة على الوجهين في المحطة 2',
    upSpeedTip: 'يرجى ملء سرعة تسريع الحافة المشتركة',
    cutThickTip: 'يرجى ملء سمك قطع الحافة المشتركة',
    sizeErrTip: 'يرجى ضبط الحجم الصحيح لمخطط تخطيط التصدير في آلة وضع العلامات!',
    offEdgeKnifeDiameter: 'يرجى إدخال قطر أداة التشذيب',
    slowDownSpeedTip: 'معلمات الإدخال الخاطئة لتباطؤ زاوية القطع',
    permissionErr: 'هذا حاليًا إصدار مجاني ولا يمكن حفظه',
    labellingTempErr: 'يرجى تحديد قالب آلة وضع العلامات',
    autoRollInputTip: 'تشغيل التدوير التلقائي للملصق، يجب إدخال قيمة صالحة',
    offlineTempFormat: 'تنسيق ملف آلة وضع العلامات الحالي غير متصل، يرجى تأكيد',
    autoStockCode1: 'رمز التغذية التلقائي للمحطة 1',
    autoStockCode1PlaceHolder: 'أدخل التغذية التلقائية للمحطة 1 كود',
    autoStockCode2PlaceHolder: 'أدخل كود التغذية التلقائية للمحطة 2',
    autoStockCode2: 'رمز التحميل التلقائي للمحطة 2',
    pauseCode: 'رمز الإيقاف المؤقت',
    pauseCodePlaceHolder: 'أدخل رمز الإيقاف المؤقت',
    cuttingToolMaxDepthTip: 'مجلة الأدوات {errKey} لا يمكن أن يكون الحد الأقصى لعمق المعالجة الفردي في الأداة أكبر من طول الأداة',
    cuttingParams: {
      title: 'معلمات القطع',
      stationWidth: 'عرض المكان',
      stationWidthTip: 'عند استخدام الألواح الكبيرة من البقايا، يمكن ترتيب الألواح الصغيرة في اتجاه العرض فقط ضمن نطاق الحجم المحدد',
      holeSlotMainSide: 'سطح تركيز الثقب',
      holeMainSide: 'سطح تركيز الفتحة',
      slotMainSide: 'سطح تركيز الفتحة',
      workPriority: '(أولوية الوظيفة: تخصيص الفتحة الخاصة وسطح معالجة الفتحة > يتبع الجانب الذي توجد فيه الفتحة المثقوبة فتحة غير مثقوبة على اللوحة الصغيرة > يتم إعطاء الأولوية لفتحات الثقب الخاصة الموجودة في الفتحة وتحويل الفتحة على الجزء الأمامي من اللوحة الكبيرة > سطح تركيز الفتحة > سطح تركيز الفتحة)',
      holeSlotSet: 'إعدادات معالجة فتحة التثقيب والتثقيب',
      hingeRollWork: 'ضع فتحات الكوب والمفصلة على الجانب الخلفي من اللوحة الكبيرة للمعالجة',
      followWork: 'يتبع الجانب الذي توجد فيه الفتحة المثقوبة الفتحة غير المثقبة على اللوحة الصغيرة',
      autoMatchSide: 'بشكل متناسب تخصيص فتحات الفتحات الأمامية والخلفية',
      backHSRate: 'نسبة الفتحات العكسية',
      matchTip: 'لن يتم تفعيل اللوحة شديدة اللمعان، أو نظام التنضيد الذي يقوم بتشغيل الأشكال الخاصة المحسوبة، أو مطابقة الأنماط.',
      specIalHoleAndSlotSurface: 'تخصيص سطح معالجة فتحة ثقب خاص',
      specialRuleTip: 'يرجى تحديد فتحة ثقب خاصة',
      specialSlotsHoles: 'نوع فتحة الثقب',
      holeType: 'نوع الفتحة',
      specialRules: 'القاعدة',
      normalHole: 'الفتحة العادية',
      normalSlot: 'الفتحة العادية',
      holeDiam: 'قطر الثقب',
      slotLongSide: 'فتحة الجانب الطويل',
      slotShortSide: 'الجانب القصير للفتحة',
      FixedmachSurface: 'سطح المعالجة الثابت',
      deleteRuleTip: 'ما إذا كان سيتم حذف هذه القاعدة',
      blankFront: 'واجهة اللوحة الكبيرة',
      blankBack: 'الجانب العكسي للوحة الكبيرة',
      addRules: 'أضف قاعدة',
      addRulesTip: 'عندما تضرب نفس اللوحة الصغيرة قواعد متعددة، وتصبح القاعدة ذات الرقم التسلسلي الأعلى سارية المفعول. يمكنك سحب أي صف لتغيير ترتيب القواعد',
      highGlossSetting: 'إعدادات لوحة التمييز',
      heighGlossFront: 'عند التنضيد، يتم ترتيب الجانب المميز من اللوحة الصغيرة قبل اللوحة الكبيرة',
      highGlossPlankNoRotate: 'لوحة التمييز لا تدور',
      highGlossAutoRoll: 'يتم قلب اللوحات الكبيرة فقط ذات الفتحات العكسية تلقائيًا',
      highGlossAutoRollTip: "<span class='color-o-4'> (بعد التمكين، سيتم قلب اللوحة الكبيرة فقط ذات الأخدود العكسي تلقائيًا وتحويلها إلى لوحة واحدة أثناء التنضيد. استخدمها مع بيانات اسم الملف المخصص \"عالي\" لوح الوجه الجانبي اللامع\") </span>",
      customHighGlossReverse: 'اقلب السطح شديد اللمعان وضع اللوحة',
      sideSlotPut: 'ضعها بجوار فتحة لوحة الحافة',
      optimize: 'يتم تحسين الوظيفة',
      sysDefault: 'النظام الافتراضي',
      plankInSide: 'الجزء الداخلي من اللوحة الكبيرة',
      plankOutSide: 'الجزء الخارجي من اللوحة الكبيرة',
      specialNotWork: 'لا تسري هذه الوظيفة على اللوحات ذات الشكل الخاص',
      commonSide: 'قطع الحواف الشائعة',
      commonSetting: 'إعداد الحواف الشائعة',
      plankThickRange: 'استخدم قطع الحواف الشائعة عندما يكون سمك اللوحة أقل من أو يساوي',
      useCommonSide: 'Use Common Edge Cutting When',
      zeroTip: 'يجب تغيير فجوة التنضيد يدويًا إلى 0. عند المعالجة إلى حافة القطع، ارفع السكين لتخطي الحافة. بعد تشغيل هذه الوظيفة، لن يتم دعم معالجة السكين المائل. يرجى الملاحظة!',
      useTip: 'بعد تشغيل هذه الوظيفة، لن يتم دعم معالجة أداة القطع المائل، يرجى ملاحظة ذلك!',
      commonSpeed: 'تسريع الحافة المشتركة',
      highSpeed: 'سرعة طحن وطحن عالية السرعة',
      min: 'الدقائق',
      notWorkTip: 'عندما تتوافق معالجة اللوحة مع قطع الحافة المشتركة، لن يسري مفعول تسريع الحافة المشتركة',
      changeStartPoint: 'تبديل نقطة البداية للمحطة المزدوجة',
      changeStartPointTip: 'بعد تمكين تبديل نقطة بداية المحطة المزدوجة، فهو غير متوافق مع وظيفة تبادل المحور XY، يرجى استخدامه بحذر',
      flatOffset: 'إزاحة مستوى الآلة',
      xRowChange: 'X مبادلة إسناد إحداثيات المحور',
      bigplankPointChange: 'مبادلة إسناد الإحداثيات الخلفية للوحة الكبيرة',
      reverseXRowChange: 'X مبادلة الإحداثيات',
      changebigplankPointTips: 'بعد تمكين هذه الوظيفة، فهي غير متوافقة مع تبادل المحور "XY، وظيفة تبديل نقطة البداية المزدوجة، يرجى استخدامها بحذر',
      reverseYRowChange: 'Y تبديل الإحداثيات',
      plankMirrorTip: 'استخدم هذه الوظيفة عند عكس اللوحة المعالجة على آلة القطع',
      notSameSize: 'أحجام مختلفة لطاولة المحطة المزدوجة',
      maxSize1: 'الحد الأقصى لحجم المحطة الأولى',
      notSameSizeTip: 'بعد تمكين أحجام مختلفة لجدول المحطة المزدوجة، فهي غير متوافقة مع وظيفة دمج ملفات المحطة المزدوجة، يرجى استخدامها بحذر',
      maxSize2: 'الحد الأقصى لحجم المحطة الثانية',
      autoSelectTip: 'عندما تكون محطتي العمل لمعدات المحطة المزدوجة ذات أحجام مختلفة، فإن استخدام هذه الوظيفة سوف يقوم تلقائيًا باختيار المحطة المقابلة لمعالجة اللوحة الكبيرة.',
      bigFlatLimit: 'تقوم المحطة الكبيرة فقط بمعالجة الألواح الكبيرة التي لا يمكن معالجتها بواسطة المحطة الصغيرة:',
      surplusSetting: 'إعداد المواد المتبقية',
      surplusPosition: 'وضع المواد المتبقية',
      cutHoleWay: 'طريقة القطع والتثقيب',
      knifeFlat: 'المستوى المرجعي لإعداد الأداة',
      flat: 'سطح الطاولة',
      plankFlat: 'سطح اللوحة الكبير',
      freeHeightZ: 'خامل Z الارتفاع',
      relativeHeight: 'بالنسبة إلى ارتفاع السطح العلوي للوحة الكبيرة',
      cutDeepZ: 'كمية القطع Z العمق',
      cutDeepH: 'طريقة التثقيب من خلال الثقب',
      setDisableDoubleSidedThroughHole: 'الإعداد غير فعال. اقلب وثقب مرتين',
      addHolesToRulesDisableDoubleSided: 'بعد إضافة الثقوب المارّة المقابلة (الثقوب المثقوبة بالكامل) إلى القواعد أدناه، لن يكون قلب اللوحة وثقبها مرتين ساري المفعول',
      onceThrough: 'مرة واحدة خلال',
      rollThrough: 'اقلب وثقب مرتين',
      cutDeepS: 'طريقة التثقيب عبر الفتحة',
      plankCutDirection: 'اتجاه قطع اللوحة الصغيرة',
      clockDirSwitch: 'فتحة الطحن المخصصة لفتحة الطحن / اتجاه القطع الداخلي ذو الشكل الخاص',
      millHoleSlotDir: 'اتجاه فتحة الطحن لفتحة الطحن',
      millInternalCurveDir: 'اتجاه القطع الداخلي ذو الشكل الخاص',
      sDirection: 'في اتجاه عقارب الساعة',
      nDirection: 'عكس اتجاه عقارب الساعة',
      curveReplenish: 'أمر الاستيفاء القوسي لقطع الألواح القوسية',
      curveReplenishTip: 'يمكن استخدام هذه الوظيفة عندما يظهر سن المنشار في قطع الألواح القوسية',
      noGen: 'لا تولد G17/G18/G19 الأمر السطحي',
      arcInstruction: 'بادئة أمر الاستيفاء القوسي',
      example: 'مثال',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: 'يتم تمثيل القطع القوسي بواسطة I، J',
      coverRate: 'معدل تداخل القطع عند فتحات الطحن:',
      roughTip: 'استخدم هذه الوظيفة عندما يكون هناك نتوءات متبقية داخل الفتحة عندما تقوم الأداة بطحن الفتحات',
      clearCurve: 'قم تلقائيًا بتنظيف شرائح الفتحات التي لم يتم سحبها خلال أثناء طحن الفتحة:',
      curveUseTip: 'حدد هذه الوظيفة عندما تحتاج إلى تنظيف الشرائح عند طحن الفتحات. لاحظ أن هذه الوظيفة لا تسري على الموصلات',
      slotCutWay: 'طريقة تغذية الطحن الشقيّ',
      outToIn: 'طحن الأخدود من الخارج إلى الداخل',
      inToOut: 'طحن الأخدود من الداخل إلى الخارج',
      zShapProcess: 'طحن الأخدود من الأعلى إلى الأسفل Z',
      zShapProcessTip: 'إنه فعال فقط للسحب الأمامي والخلفي من خلال الطحن بالفتحة. معدل تداخل مسار الأداة الافتراضي هو نصف قطر الأداة',
      zSlotCuttingOverlapRate: 'Z. معدل التداخل لقطع فتحة طحن الخط هو',
      zSlotCuttingOverlapRateTip: '. قد يتسبب معدل التداخل الحالي في إبطاء سرعة المعالجة. يرجى اختبار الجهاز قبل المعالجة.',
      slotWorkLimit: '(فعال فقط عندما يكون عدد ممرات طحن الأخدود أكبر من 1)',
      minKnifeChange: 'تقليل تغيير القطعة أثناء المعالجة',
      preventBreakage: 'منع كسر فاصل أخدود الحافة',
      preventBreakageTip: 'هذا الإعداد يسري فقط على الأخاديد الموجودة على الوجه الأمامي أثناء الترقيم، ويمكن استخدامه مع وظيفة "تخصيص سطح معالجة فتحة ثقب خاص"',
      preventBreakageTip1: 'يمكن حل حالة اقتراب الأخدود كثيرًا من حافة اللوح، حيث ينكسر الفاصل (الجزء المتبقي من الوصلة) في ذلك الموضع بسهولة بسبب تركز الإجهاد أثناء القطع',
      preventBreakageDistance: 'المسافة من حافة اللوح',
      preventBreakageLength: 'طول الجزء المحاذي للحافة',
      preventBreakageSlot: 'أخاديد',
      preventBreakageCutDeep: 'عمق القطع الأول',
      workSpeedOp: 'تحسين سرعة المعالجة',
      obliqueCut: 'السكين المائل أثناء القطع',
      obliqueCutTip: 'عندما لا يتم تحديد سمك اللوح، فإنه ينطبق على جميع الألواح ذات السمك الأصغر',
      obliqueThickLabel: 'سمك اللوح الفعال المخصص للقطع المائل',
      obliqueCutData: 'مسافة السكين المائلة',
      backOblique: 'السكين المائل للتقليم الخلفي',
      obliqueSpeed: 'سرعة السكين المائلة',
      obliqueSpeedTip: 'سرعة السكين المائلة',
      arcSpeed: 'سرعة المعالجة المنحنية',
      cuttingPreDistance: 'مسافة تقدم القاطع',
      backKnife: 'تباطؤ تراجع القطع',
      openKnifeSpeed: 'القاطع سرعة التراجع',
      retractionCompensation: 'تعويض مسافة تراجع القطع',
      retractionCompensationTip: 'القيمة القصوى 20',
      cutCornerSlow: 'تباطؤ زاوية القطع',
      addRow: 'تمت إضافة',
      bettwenDistance: 'المسافة قبل وبعد الزاوية',
      cuttingSpeed: 'سرعة القطع',
      stepCutting: 'القطع متعدد الطبقات',
      splitSlot: 'قطع الأخدود مرتين',
      splitPlank: 'يتم قطع اللوحة الصغيرة مرتين',
      splitPlank2: 'يتم قطع اللوحة الصغيرة مرتين',
      minSafeThick: 'السمك أكبر من',
      splitPlankTip: '(لا تسري هذه الوظيفة على الألواح ذات الشكل الخاص)',
      splitPlankTip2: '(غير متوافق: تعويض القطعة)',
      cutPlankMethod: 'يتم قطع اللوحة الصغيرة مرتين',
      cutPlankMethodTip: 'يتم قطع اللوحة مرتين في الأربعة أضلاع',
      cutPlankMethodTip2: 'يتم قطع اللوحة مرتين في الضلع الأخير',
      specialShapCut: 'يتم قطع اللوحة ذات الشكل الخاص مرتين',
      specialShapCutTip: '(جميع الألواح ذات الشكل الخاص سيتم قطعها مرتين عند التمكين)',
      bridgeRetention: 'طريقة جسر نقاط الإبقاء',
      bridgeRetentionTip: '(ملاحظة: 1. هذه الميزة لا تدعم حالياً الألواح ذات الأشكال الخاصة الخارجية. 2. لا تدعم التقطيع المائل نحو الأسفل. 3. الحد الأدنى لحجم اللوح لإنشاء جسر الربط هو 30مم.)',
      bridgeRetentionDesc: 'يساعد في حل اهتزاز اللوح أو انزياحه عندما توجد مناطق مجوفة كثيرة داخله فتفتقر مسار القطع إلى الدعم الكافي.',
      bridgePunchArea: 'الجزء المخترق يتجاوز المساحة الإجمالية',
      bridgeSize: 'حجم جسر الوصل',
      bridgeGenMethod: 'طريقة التوليد',
      bridgeAddTip: 'أضف حتى 10 بيانات',
      bridgeCount: 'عدد جسور الوصل',
      bridgePlankLength: 'طول اللوح (L)',
      maxWH: 'الطول أو العرض أقل من',
      areaLimit: 'والمساحة أقل من',
      secondDeep: 'عمق القطع الثاني',
      splitPlankThickSetting: 'إعدادات قطع طبقة القطع',
      saveCustomSpeedTip: 'لا يمكن أن تكون سرعة المعالجة فارغة',
      saveLayeredCuttingTip: 'يجب أن يكون مجموع قصاصات الطبقات الثلاث للقطع ذو الطبقات مساويًا لسمك اللوحة',
      saveLayeredRepeatTip: 'لا يوصى بتعيين بيانات طبقات مختلفة لسمك سمة تمييز المادة نفسها أثناء قطع الطبقات. يرجى حذف البيانات الزائدة!',
      splitPlankThick: 'قطع طبقات بسماكات مختلفة للوحة',
      movePlankSetting: 'إعدادات اللوحة المضادة للتشغيل',
      newCutSequence: 'إصدار جديد من خوارزمية القطع',
      newCutSequenceText: 'افتراضيًا، يكون الشفط الفراغي أقوى في وسط اللوحة الكبيرة، ويتم قطع الألواح الصغيرة في هذه المنطقة أخيرًا',
      positionTip: 'انقر فوق المنطقة المقابلة لتحديد',
      suctionPosition: 'موضع شفط قوي',
      strongArea: 'منطقة شفط قوية',
      minSuctionPlank: 'الحد الأدنى من لوحة الشفط',
      safeWidth: 'العرض',
      safeHeight: 'الطول',
      safeTip: 'إذا لم يكن من الممكن امتصاص اللوحة، فسيتم قطعها أولاً',
      scattered_layout: 'تنضيد اللوحة الصغيرة المشتتة',
      lastCutPointEnable: 'تخصيص نقطة القطع للوحة الصغيرة المقطوعة أخيرًا على اللوحة الكبيرة',
      lastCutPointEnableTip: 'عند التمكين، سيتم إنشاء نقطة القطع للوحة الصغيرة المقطوعة أخيرًا على كل لوحة كبيرة وفقًا لموضع النقطة المحدد',
      lastCutPoint: 'موضع نقطة القطع',
      lastCutPointTip: 'عند التمكين، ستستخدم اللوحة الصغيرة المقطوعة أخيرًا على كل لوحة كبيرة نقطة القطع هذه',
      leftTop: 'أعلى اليسار',
      rightTop: 'أعلى اليمين',
      leftBottom: 'أسفل اليسار',
      rightBottom: 'أسفل اليمين',
      specifyTheMaterial: 'تحديد المادة',
      shapeSecondCutenable: 'القطع الثانوي للوحة ذات الشكل الخاص',
      addMaterial: 'إضافة مادة',
      plankMaterial: 'مادة اللوحة',
      specifyTheMaterialTip: 'بعد تمكينها، ستكون وظيفة القطع الثانوية فعالة فقط للألواح التي تفي بمواد الجدول',
      dispersePaibanTipOne: '. بعد تمكينه، سيتم ترتيب لوحة واحدة على الأقل تلبي الحد الأدنى لحجم الشفط على كل لوحة كبيرة',
      dispersePaibanTipTwo: '2. لاحظ أن كمية الألواح الكبيرة قد تزيد بعد الاستخدام',
      totalThickLimit: 'يجب أن يكون مجموع القطع الثلاثة ذات الطبقات مساويًا لسمك اللوحة',
      offsetFollowStep: 'يتبع التشذيب أيضًا قطع الطبقات',
      longPlankTip1: '1. بعد تشغيل هذه الوظيفة أو إيقافها، تتطلب سجلات التخطيط المحفوظة في السجل إعادة التخطيط عند تنزيل NC.',
      longPlankTip2: '2. بعد تمكين هذه الوظيفة، يجب ضبط رمز إيقاف مضخة التفريغ مؤقتًا في [الفتح والإرساء - إيقاف مضخة التفريغ]، وإلا لا يمكن حل مشكلة انحناء اللوح الطويل عند القطع.',
      longPlankTip3: '3. تُفحص شروط التصفية المفعّلة أدناه بالتتابع حسب المستويات؛ لا تُقيَّم الألواح إلا إذا استوفت شروط تصفية المستوى السابق قبل الدخول إلى شروط تصفية المستوى التالي.',
      secondCutting: 'الألواح العادية لأشياء القطع الثانوية',
      normalPlank: 'Regular board',
      normalPlankTip: 'الألواح العادية: ألواح أخرى غير أبواب الخزانات مثل الأقسام الأفقية والرأسية في الخزانة والألواح المضافة مباشرة في قائمة القطع',
      designatedTarget: 'الكائنات المحددة',
      filterLevel1Label: 'تصفية المستوى 1',
      filterLevel1Category: 'نوع اللوحة',
      filterLevel2Label: 'تصفية المستوى 2',
      filterLevel2Category: 'قيود الحجم',
      filterLevel3Label: 'تصفية المستوى 3',
      filterLevel3Category: 'أخرى',
      specifiedBoardForceEnable: 'تجاهل الحجم/شروط التصفية الأخرى، التفعيل الإجباري',
      curveMaterialFilterTip: '(بعد تحديد «لوحة غير منتظمة»، يجب أن تكون اللوحة غير منتظمة قبل تصفية المادة)',
      cuttingSettings: 'إعدادات القطع',
      plankSizeLimitSuffix: ' لوحات',
      specifiedBoard: 'حدد اسم اللوحة للقطع',
      specifiedBoardTip: 'بعد تشغيلها، سيصبح القطع الثانوي ساري المفعول عندما يحتوي اسم اللوحة على تمت إضافة اسم اللوحة أدناه.',
      addPlankName: 'أضف اسم لوحة',
      plankNameEmpty: 'لا يمكن أن يكون اسم اللوحة فارغًا، يرجى إدخال',
      plankNameRequired: 'يرجى إضافة اسم لوحة واحد على الأقل',
      plankLongLimit: 'عندما يتجاوز الجانب الطويل من اللوحة الطويلة',
      plankShortLimit: 'يتجاوز الجانب القصير',
      cuttingSplit: 'القطع مرتين',
      longExpand: 'وزن القطع الأول: وزن الجانب الطويل',
      firstExpand: 'وزن القطع الأول',
      longExpandTip: 'وزن الجانب الطويل',
      longLimit: 'يتجاوز الجانب الطويل',
      cuttingSplitTip: 'ظروف قطع اللوحة الطويلة في قسمين',
      shortExpand: 'زيادة الصوت في الجانب القصير',
      expandTip: 'تتم زيادة أبعاد الجانب الطويل/القصير بمقدار X مم. أطوال الجوانب الطويلة والقصيرة للوحة الطويلة ذات الشكل الخاص هي طول الجانب الطويل',
      pumpOffWay: 'طريقة الإغلاق الفراغي',
      afterOnePlank: 'بعد قطع لوحة طويلة واحدة',
      afterAllPlank: 'بعد قطع اللوحة الكبيرة بأكملها',
      numberFixed: 'عدد المنازل العشرية',
      bufferCode: 'إعداد أمر المخزن المؤقت للقاطع',
      layoutGap: 'إعداد فجوة التنضيد',
      layoutGapTip: 'ملاحظة: قد يؤدي ضبط فجوة التنضيد إلى 0 إلى تداخل التنضيد.',
      wasteCutting: 'قطع الخردة تلقائيًا',
      zkPointCustomize: 'Z تخصيص النقطة المرجعية لدوران الثقب المائل بالزر',
      sawSetting: 'إعدادات النشر',
      cuttingLimit: 'قطع الخردة الأكبر من',
      waste: 'of waste',
      wasteSizeLimit: 'يجب ألا يقل الحجم الأدنى عن 100 مم',
      topLeft: 'اليسار، العلوي',
      topLeftD: 'الزاوية اليسرى العليا',
      bottomLeft: 'اليسار، السفلي',
      bottomLeftD: 'الزاوية اليسرى السفلية',
      topRight: 'اليمين، أعلى',
      topRightD: 'الزاوية اليمنى العليا',
      bottomRight: 'الحافة اليمنى، الحافة السفلية',
      bottomRightD: 'الزاوية اليمنى السفلى',
      firstTime: 'المرة الأولى',
      secondTime: 'المرة الثانية',
      thirdTime: 'المرة الثالثة',
      startCutting: 'بداية القطع',
      thickRange: 'السُمك ≥',
      longCut: 'معالجة اللوحة الطويلة',
      edgeSetting: 'إعدادات القطع',
      cuttingOrder: 'تسلسل القطع:',
      cuttingOrderTip: 'تحتوي هذه الطريقة على خطر تشغيل الألواح، يرجى استخدامها بحذر',
      plankFirst: 'قطع الألواح الصغيرة أولاً',
      wasteFirst: 'قطع القصاصات أولاً',
      offTip: 'عند إغلاقه، سيتبع إعدادات التشذيب في معلمات القطع',
      edgeCutDirection: 'اتجاه التشذيب',
      lGapTip: 'L يتم ضبط موضع فجوة لوحة المواد المتبقية على شكل L تلقائيًا في الاتجاه القطري لأسطوانة تحديد الموضع، باستثناء لوحة المواد المتبقية عالية اللمعان. كما أنه غير متوافق مع وظيفة تبادل المحور xy',
      cylinderDir: 'تحديد اتجاه الأسطوانة',
      onlyLong: 'يتم قطع الجوانب الطويلة فقط',
      backCutOrder: 'تسلسل التشذيب العكسي',
      backFirst: 'يتم تشذيب الجانب الخلفي في البداية',
      backSecond: 'ويتم تشذيب الجانب الخلفي بعد معالجة الأخدود.',
      frontReCut: 'إعادة تشذيب الجانب الأمامي',
      frontReCutTip: 'يجعل تحديد موضع حافة الأسطوانة أكثر سلاسة ويمنع العلامات',
      useNewCut: 'تمكين الإصدار الجديد من قواعد التشذيب',
      newCutTip: 'استخدم هذه الوظيفة عندما سيتم قطع حجم تشذيب إضافي على الجانب الأمامي للوحة كبيرة أثناء المعالجة على الوجهين',
      fixedTip: 'ملاحظة: قد يكون هناك تداخل في التنضيد عندما تكون الأرقام المحجوزة 0 أو 1',
      cuttingSlow: 'التخزين المؤقت لسطح اللوحة الفارغة',
      holeSlow: 'سطح اللوحة المثقبة التخزين المؤقت',
      slotSlow: 'التخزين المؤقت لسطح لوحة الحز/الطحن/الحز',
      slowCode: 'استخدام أمر التخزين المؤقت',
      code: 'الأمر',
      bufferOffset: 'إزاحة ارتفاع التخزين المؤقت لسطح اللوحة',
      zkRotatePoint: 'النقطة المرجعية للدوران',
      zkRotateDir: 'اتجاه زيادة زاوية الدوران',
      restSizeLimit: 'الحجم المتبقي أقل من',
      useSaw: 'استخدم شفرة المنشار',
      unGenSawPath: 'لا تنشئ مسار قطع طولي لنصل المنشار',
      suitMachine: 'مناسبة لمعالجة الألواح الملحومة المصنوعة بالكامل من الألومنيوم',
      plankBack: 'الجانب الخلفي من اللوحة الكبيرة',
      plankLeft: 'الجانب الأيسر من اللوحة الكبيرة',
      plankRight: 'الجانب الأيمن من اللوحة الكبيرة',
      plankFront: 'الجانب الأمامي للوحة الكبيرة',
      frontSide: 'الجانب الأمامي',
      backSide: 'الجانب الخلفي',
      rightSide: 'الجانب الأيمن',
      leftSide: 'الجانب الأيسر',
      singleMachineLimit: 'يقوم الجانب الأمامي للوحة المعالجة أحادية الجانب بإنشاء مسار تشذيب وتشذيب الحافة أولاً',
      singleMachineLimitTip: 'لا يتم تفعيل الماكينة الشاملة ونصل المنشار. هذه الوظيفة',
      setBatchPositionWaring: 'نصيحة: إذا كنت بحاجة إلى إلغاء التعديل السريع لوضع نقطة السكين السفلية، فيرجى إلغاء تحديد زر تعديل نقطة السكين السفلية الموجود على اليمين',
      setBatchPosition: 'تعديل دفعة لنقطة السكين السفلية',
      setBatchPositionAs: 'تعديل اتجاه القطع إلى:',
      activeBatchPosition: '{activePartCount} تم تحديد لوحات صغيرة',
      specialFrontSide: 'يتم إعطاء الأولوية للثقوب الخاصة المحددة في تحويل الثقب في مقدمة اللوحة الكبيرة',
      rollCountTip: 'بعد تمكين تحويل الثقب، الرقم يتم حساب عدد النسخ بناءً على الثقوب العكسية الفعلية التي تمت معالجتها بواسطة آلة النقش',
      specialFrontSideTip: 'خط الإنتاج الحالي لا يدعم تبديل خطوط الإنتاج بسبب تشغيل وظيفة 【孔槽分流中设置的特殊孔槽优先排在大板正面】 أو 【启用孔槽分流后按照实际在雕刻机加工的反面孔槽计算翻板次数】',
      doubleTrim: 'التشذيب المزدوج',
      trim: 'تقليم الحواف',
      trimTwoSide: 'تقليم حافتين',
      trimFourSide: 'تقليم أربع حواف',
      rightInmShow: 'كما هو موضح في الصورة على اليمين',
      currentTrimDir: 'هو اتجاه التشذيب المحدد حاليًا',
      cylinderTip: 'هو أسطوانة تحديد الموضع',
      onlyShort: 'تقوم بقص الحافة القصيرة فقط',
      singleTrim: 'تنشئ مسار تشذيب للوحة واحدة',
      hierarchyCutTwice: 'حفر وأخاديد طحن وقطع ذات طبقات',
      knifeDia: 'عندما يكون قطر الأداة أقل من أو يساوي',
      slotDeep: 'وعمق الأخدود أكبر من أو يساوي',
      cutTwiceSlot: '، أخاديد القطع ذات الطبقات',
      twiceSlotDeep: 'عمق قطع الطبقة الثانية هو',
      cutTwiceCondition: 'ظروف القطع',
      zkPointCustomizeTip: 'سيؤدي تشغيل تبادل المحور xy إلى أن يكون اتجاه المعالجة معاكسًا للنقطة المرجعية',
      zkPointCustomizeTip1: 'لن تسري هذه الوظيفة على المعدات التي تقوم بتشغيل تبادل المحور xy',
      isCustom: 'تشغيل التخصيص',
      useCutCon: 'استخدام شروط النشر',
      singleSetPlankSizeSpeed: 'اضبط سرعة المعالجة لنطاق حجم اللوحة الصغيرة بشكل فردي',
      singleSetPlankSizeSpeedTip: '(1. عندما تكون اللوحة الصغيرة ستتم معالجة الحجم الذي يلبي الحجم المحدد أدناه بسرعة المعالجة المحددة 2. عندما تلبي اللوحة الصغيرة قواعد متعددة في نفس الوقت، ستسري قاعدة الحد الأدنى للسرعة 3. لا تسري هذه الوظيفة على قطع شفرة المنشار)',
      addSpeedRules: 'أضف قاعدة',
      speedRules: 'القاعدة',
      shortSideSize: 'حجم الجانب القصير',
      lessThanEqual: 'أقل من أو يساوي',
      and: 'و',
      longSideSize: 'حجم الجانب الطويل',
      processingSpeed: 'سرعة المعالجة',
      trimLenCompensation: 'تعويض طول القطع:',
      trimGenerateAPath: 'لا يتم إنشاء مسار عندما تكون قيمة القطع 0:',
      cuttingMethod: 'طريقة القطع',
      horizontalCutting: 'القطع الأفقي',
      verticalCutting: 'القطع العمودي',
      openKnifeDistance: 'يرجى تحديد لوحة القطع المتبقية'
      },
    labelingSettings: {
      title: 'إعدادات وضع العلامات',
      output: 'إخراج ملف وضع العلامات التلقائي',
      specification: 'تنسيق ملف وضع العلامات',
      codeFrontGenerate: 'يتم إنشاء رمز التحميل التلقائي قبل رمز وضع العلامات',
      templateOffline: 'القالب المستخدم غير متصل!',
      rollLabelling: 'إعداد وضع الملصقات على الوجه',
      flipSetting: {
        title: 'إعداد الدوران',
        engravingFlipProcess: 'آلة النقش تقلب وضع وضع العلامات',
        flipTip: 'تمكين هذه الوظيفة عندما تحتاج آلة النقش إلى الدوران'
        },
      rotateSetting: {
        title: 'إعداد دوران الملصق',
        rotateTip: 'قم بتشغيل حالة الدوران وفقًا للاحتياجات، إذا تم تشغيله في نفس الوقت، فستأخذ الأولوية لتحديد قيمة الإعداد',
        horizontal: 'الحافة الأفقية للوحة',
        vertical: 'الحافة العمودية اللوحة',
        either: 'الحافة الأفقية أو الرأسية للوحة'
        },
      countertopSetting: {
        title: 'إعداد الجدول',
        startPoint: 'نقطة بداية محطة العمل',
        upLeft: 'الزاوية اليسرى العليا',
        upRight: 'الزاوية اليمنى العليا',
        downLeft: 'الزاوية اليسرى السفلية',
        downRight: 'الزاوية اليمنى السفلى',
        baseExchange: 'تبديل مسند الإسناد',
        exchangeX: 'تبديل المحور السيني',
        exchangeY: 'تبديل المحور Y'
        },
      offset: 'إزاحة إحداثيات الملصقات',
      offsetTip: 'بشكل عام، تكون إحداثيات الملصقات في مركز اللوحة الصغيرة، وتحتاج بعض المعدات إلى تعديل',
      label_rotate_offset: 'إزاحة الإحداثيات بعد تدوير الملصقات',
      label_rotate_offset_tip: 'عندما يكون موضع الإزاحة قبل تدوير الملصقات وبعده مختلفًا بشكل كبير، يلزم التعديل',
      label_rotate_offset_err_tip: 'بعد تشغيل إزاحة الإحداثيات بعد تدوير الملصقات، تكون إزاحات إحداثيات المحور X و Y مطلوبة',
      imgSetting: {
        title: 'إعدادات صورة الملصقات',
        suffix: 'لاحقة صورة التسمية:',
        code: 'طريقة تشفير الصورة:',
        codeTip: 'سيعمل png و jpeg على تعديل تنسيق ترميز صورة التنضيد في وقت واحد، ولا يدعم التنضيد السحابي المضمن هذه الوظيفة بعد',
        imgRatio: 'دقة صورة التسمية:',
        slowDown: 'ستقلل من كفاءة تصدير صور التسمية',
        color: 'اللون الحقيقي',
        bit: 'أبيض وأسود',
        resolution: 'دقة صورة التسمية',
        resolutionPlaceholder: 'الدقة',
        labelPool: 'تجمع علامات البيانات',
        showKey: 'إظهار الحقول',
        dragTip: 'يمكن سحب العلامات الموجودة في تجمع العلامات وإسقاطها',
        labelImgName: 'اسم صورة التسمية',
        labelImgNameErrTip: 'لا يمكن أن يكون اسم صورة التسمية فارغًا',
        labelTip1: 'عند التخصيص، يجب أن يستخدم [Board Barcode] أو [Label Sequence Number] واحدًا منها، وإلا ستكون هناك مشاكل في الكتابة فوق الصورة',
        labelTip3: '【رقم تسلسل العلامة】 هو رقم تسلسل اللوحة الصغيرة من الأعلى إلى الأسفل في قائمة القص، ولا يوجد هذا البيانات في اللوحة الصغيرة المضافة على صفحة التخصيص',
        labelTip2: '3. لا تسري هذه الوظيفة في قالب نظام آلة وضع العلامات',
        delimiter: 'لا يدعم الفاصل',
        inputTip: 'الإدخال /: ? < > | . " * أحرف مثل',
        numStart: 'القيمة الأولية لتسمية الرقم التسلسلي',
        example: 'اسم صورة التسمية المخصصة (مثال)',
        stockNumOffset: 'أرقام تعويض الرقم التسلسلي للوحة الكبيرة إلى',
        divideFolders: 'يتم تقسيم صور التسمية إلى مجلدات مختلفة وفقًا للوحة الكبيرة',
        foldersTip1: 'ملاحظة: 1. لا تدعم هذه الوظيفة الاستخدام مع وظيفة 【开料机文件合并】',
        foldersTip2: '2. هذه الوظيفة ليست فعالة بعد للتنضيد السحابي المضمن',
        stickIntoFolders: 'يتم إدراج ملف الملصقات في مجلد صور الملصقات المطابق للوحة الكبيرة',
        stickTip1: 'ملاحظة: 1. يجب استخدام هذه الوظيفة جنبًا إلى جنب مع وظيفة 【下载NC顺带导出标签】',
        stickTip2: '2. تحتاج قاعدة إنشاء الملف في قالب التسمية المستخدم إلى تحديد "إنشاء ملف واحد" حتى تدخل هذه الوظيفة حيز التنفيذ؛',
        stickTip3: '3. هذه الوظيفة ليست فعالة بعد للتنضيد السحابي المضمن'
        },
      pdfSetting: {
        title: 'وضع العلامات PDF الإعدادات',
        pdfLabelName: 'PDF اسم الملف',
        example: 'اسم الملف المخصص PDF (مثال)',
        address: 'عنوان المشروع',
        orderNo: 'رقم الطلب',
        firstFolder: 'مجلد المستوى الأول',
        customerName: 'اسم العميل'
        },
      paibanImgSetting: {
        title: 'إعداد التخطيط',
        tip: 'يتيح تصدير رسومات التخطيط المخصصة. لا يمكن تصدير القالب الثابت أدناه. إذا كنت بحاجة إلى التصدير، فيرجى إيقاف تصدير رسومات التخطيط المخصصة في المزيد من الإعدادات في صفحة التخطيط',
        reparation: 'يتم تعويض الرقم التسلسلي لرسم التخطيط تلقائيًا إلى',
        figure: 'أرقام',
        inputTip: 'يرجى إدخال رقم من 1 إلى 99',
        paibanImg: {
          export: 'تصدير رسم التخطيط',
          prefix: 'بادئة اسم رسم التخطيط',
          size: 'حجم التخطيط',
          format: 'تنسيق التخطيط',
          directional: 'اتجاه التخطيط',
          vertical: 'عمودي',
          horizontal: 'أفقي'
          }
        },
      autolabel: 'إعداد ترتيب وضع العلامات التلقائي',
      customTemp: 'صالح فقط للقوالب المخصصة',
      cuttingLabelOder: 'التسمية وفقًا لترتيب المواد المفتوحة',
      labelToUp: 'التسمية من الأسفل إلى الأعلى وفقًا لنتائج التخطيط',
      labelToDown: 'التسمية من الأعلى إلى الأسفل وفقًا لنتائج التخطيط',
      labelDodge: 'تجنب وضع العلامات التلقائي',
      nolabelForsurplus: 'لا تولد اللوحات الكبيرة للمواد المتبقية ملفات ملصقات',
      settingValue: 'حدد قيمة الإعداد',
      enabelTip: 'بعد التشغيل، عندما تستوفي اللوحة الصغيرة قيم الإعداد التالية، سيتم تدوير الملصق',
      fixedHori: 'حدد الحافة الأفقية للملصق لتكون موازية للحافة الثابتة للوحة الصغيرة',
      fixedHoriTip: 'فعالة فقط للألواح الصغيرة غير المزخرفة. بعد التشغيل، عند وضع الملصق، سيتم تدوير الملصق إلى الحافة الأفقية للملصق ليكون موازيًا للحافة الثابتة للوحة الصغيرة',
      tagHori: 'حافة الملصق الأفقية',
      effectiveTarget: 'الكائن الفعال',
      allPlank: 'جميع الألواح الصغيرة',
      notcarePlank: 'فقط الألواح الصغيرة غير المزخرفة'
      },
    drillSettings: {
      title: 'إعدادات الحفر',
      enable: 'تمكين حزمة الحفر',
      toolTable: {
        use: 'تمكين',
        number2: 'رقم حفر الصف الثاني للمحطة',
        number: 'رقم حفر الصف',
        diameter: 'قطر الحفر',
        xOffset: 'X الإزاحة',
        yOffset: 'Y الإزاحة',
        moveZF: 'Z سرعة الحركة السريعة للمحور',
        feedRate: 'Z سرعة الحركة السريعة للمحور',
        moveF: 'XY سرعة الحركة السريعة للمحور',
        benchmarkDrill: 'المثقاب المرجعي',
        addKnife: 'إضافة أداة',
        deleteKnife: 'أداة الحذف'
        },
      prefix: 'بادئة حفر الصف',
      suffix: 'لاحقة حفر الصف',
      startCode: 'رمز بداية حفر الصف',
      endCode: 'رمز نهاية حفر الصف',
      combineKnife: 'القطع المشترك لحفر الصف',
      combineTable: {
        prefix: 'بادئة رقم حفر الصف',
        suffix: 'لاحقة رقم حفر الصف',
        mainHole: 'الثقب الرئيسي',
        extraHole: 'الحفرة التابعة',
        notes: 'تعليق مختلط',
        firstUseNotes: 'تمكين التعليقات التوضيحية لأول مرة',
        addExtraHole: 'إضافة ثقوب تابعة',
        deleteExtraHole: 'حذف الثقوب التابعة',
        example: 'مثال'
        },
      tagPool: {
        drillRowNumber: 'رقم حفر الصف'
        },
      processSetting: {
        title: 'إعدادات المعالجة',
        mode: 'وضع معالجة حفر الصف',
        processTip: 'لن يصبح تحديد هذه الطريقة ساري المفعول. لن يتم تفعيل وظيفة القطع المجمعة لحفر الصف',
        recentHole: 'حفر الثقوب القريبة (تغيير سريع للأداة)',
        groupHole: 'حفر الثقوب حسب الفئة (إكمال نوع الثقب قبل تغيير الأدوات)',
        drill_benchmark: 'مرجع القطع المدمج',
        drill_benchmark_Tip: '(ملاحظة: بعد تحديد هذه الطريقة، لن تصبح وظيفة القطع المجمعة لحفر الصف نافذة المفعول)',
        mainHole: 'استخدم الثقب الرئيسي',
        secondaryHole: 'من الفتحة (ثقب الذيل)'
        },
      changeBenchDrillTip: 'يرجى إدخال رقم حفر الصف قبل إجراء هذا التحديد'
      },
    NCExportSettings: {
      jumpSkipTip2: 'وفقًا للون اللوحة الكبيرة وسمكها ومادتها، يتم تصنيفها إلى مجلدات مختلفة (وضع العلامات معًا)، ويتم وضع ملفات تقطيع اللوحة الكبيرة من نفس الحجم في نفس المجلد',
      title: 'NC إعدادات التصدير',
      tab1: 'إعدادات اسم ملف آلة القطع',
      tab2: 'دمج أسماء ملفات آلة القطع',
      tab3: 'التعليقات في ملفات آلة القطع',
      tab4: 'النوع',
      tab5: 'في الملف الافتتاحي هو المجلد الافتتاحي',
      tab6: 'إعداد تعليمات المعالجة',
      tab7: 'إعداد تنسيق الملف',
      fileNameSettings: {
        twoStationAutoSort: 'الفرز التلقائي لمحطة مزدوجة',
        reparation: 'تعويض أرقام الرقم التسلسلي للوحة الكبيرة',
        figure: 'أرقام',
        labelerBegin: 'بداية آلة الملصقات',
        machineCenter: 'بداية مركز المعالجة',
        front: 'الأمامي:',
        back: 'الخلفي:',
        customizeName: 'اسم الملف المخصص (التنسيق):',
        example: 'اسم الملف المخصص (مثال):',
        emptyTip: 'لا يمكن أن تكون معرفات الملف الأمامية والخلفية فارغة في نفس الوقت.',
        labelPool: 'تجمع علامات البيانات',
        dragTip: 'يمكنك السحب أو النقر لنسخ العلامات الموجودة في تجمع العلامات في مربع الإدخال'
        },
      fileMerge: {
        engravingMerge: 'دمج ملفات آلة القطع',
        zfMerge: 'الدمج الأمامي والخلفي',
        singleMerge: 'دمج محطة واحدة',
        doubleMerge: 'دمج المحطة المزدوجة',
        fEndCode: 'رمز النهاية العكسية',
        zBeginCode: 'رمز البداية الأمامية',
        displayfbInfo: 'يعرض اسم الملف المعلومات الأمامية والخلفية',
        fBeginCode: 'رمز البداية العكسية',
        zEndCode: 'رمز النهاية الأمامية'
        },
      marginalNotes: {
        addPlankInfo: 'إضافة معلومات اللوحة الكبيرة الحالية في بداية ملف القطع:',
        plankInfo: 'معلومات اللوحة الكبيرة:',
        addStationCodeFirst: 'إضافة محطة العمل الكود الموجود في بداية ملف فتح المادة:',
        addStationCodeSecond: 'أضف رمز المحطة قبل تغيير الأداة في ملف القطع:'
        },
      fileType: {
        zAddtion: 'Z ملحق الإحداثيات:',
        addSemicolon: 'أضف فاصلة منقوطة في نهاية كل سطر NC:',
        semicolonTip: 'بعد التحقق، سيصبح ملف المعالجة لمقبض البوق ساري المفعول أيضًا',
        fileName: 'اسم الملف',
        defaultName: 'اسم الملف الافتراضي',
        dedicatedName: 'اسم الملف الخاص لمعدات Xinghui',
        xhNotes: 'Xinghui E2-9 تعليق',
        format: 'تنسيق ملف آلة نقش الإخراج',
        example: 'مثال ملف: ملف NC',
        stillGenerate: 'عندما لا تتم معالجة الجانب العكسي، سيتم إنشاء ملف الجانب العكسي NC الذي يحتوي على رمز النهاية العكسية',
        generateTip: 'لا تدعم هذه الوظيفة الاستخدام مع وظيفة دمج الملفات',
        fileNameErrTip: 'لا يمكن أن يحتوي اسم الملف على أي من الأحرف التالية: / : * ? "'
        },
      categorize: 'وفقًا للون والمادة وسمك اللوحة الكبيرة، يتم تصنيفها إلى مجلدات مختلفة (تسمية الملفات معًا):',
      simplifyG: 'اختصار أمر المعالجة G',
      ZToW: 'تم تغيير الرمز من محور Z إلى محور W',
      knives: 'أداة حفر الصفوف',
      lineBreakSetting: 'إعداد تنسيق فاصل الأسطر',
      codeFormatSetting: 'إعداد تنسيق ترميز الملف',
      utf8bom: 'UTF-8 مع BOM',
      oneCodeSetting: 'إعداد الرمز الشريطي للوحة',
      simplifyOneCode: 'إنشاء رمز شريطي للتسمية بتنسيق بسيط',
      codeLocation: 'إعداد موضع الرمز',
      generateLocation: 'يتم إنشاء رمز نهاية المحطة قبل رمز النهاية العكسي',
      emergencySetting: 'إعدادات الطوارئ',
      show: 'عرض إعدادات الطوارئ',
      emergencyCode: 'رمز الطوارئ',
      params: 'المعلمات',
      emergencyTip: 'يمكن تنفيذ بعض الوظائف المتخصصة مؤقتًا بالتعاون مع موظفي ما بعد البيع',
      holeSetting: 'إعدادات ملف التثقيب',
      holeFileCategorize: 'يتم وضع ملفات التثقيب بشكل منفصل في المجلدات حسب ترتيب مختلف',
      holeTip: 'التنضيد السحابي لعملاء الخزانة المدمجة لا يسري مفعوله',
      specialCodeErr: 'الأحرف الخاصة غير مدعومة!',
      copySuccess: 'تم النسخ بنجاح!',
      copyErr: 'فشل النسخ، يرجى محاولة سحب الملصق!',
      lengthLimit: 'يدعم إدخال 15 رقمًا فقط!',
      plankInfo: 'معلومات المجلس',
      otherInfo: 'معلومات أخرى',
      uniqueBarCode: 'لوحة الباركود فريدة من نوعها',
      uniqueBarCodeForPack: 'لوحة باركود فريدة (للتعبئة فقط)',
      machineOrder: 'إنشاء الرقم التسلسلي للمعالجة من اسم الملف الفارغ',
      folderSetting: 'يتم وضع الملفات الفارغة للوحات الكبيرة ذات الحجم نفسه في نفس المجلد.',
      labelImageINCFolder: 'يتم وضع صورة الملصق في المجلد NC مع ملف الملصق.',
      custom: 'مصنوع بطريقة مخصصة',
      folderSettingTip: 'ملاحظة: التنضيد المضمن لا يدعم حاليًا هذه الوظيفة',
      settingMoveTip: 'تم ترحيل وظيفة "{func}" الأصلية إلى صفحة "{module}"!',
      fileManagerFunction: 'يتم وضع الملفات المثقوبة بشكل منفصل في مجلدات وفقًا لملفات الطلبات المختلفة.',
      gotoSetting: 'انتقل إلى الإعدادات',
      singleFileTitle: 'إعدادات معالجة الملفات الفردية',
      slectSingleProcess: 'اختر عملية الإخراج المنفردة',
      slectSingleProcessTip: 'لا تزال هناك عمليات معالجة ثانوية مدفوعة، يرجى حذفها ثم الحفظ مرة أخرى',
      setSingleRegularSize: 'تعيين أبعاد الثقوب والفتحات العادية للإخراج المنفرد',
      holeRange: 'نطاق سريان الثقب',
      slotRange: 'نطاق سريان الفتحة',
      holeRangeTip: 'لا يمكن أن يكون نطاق سريان الثقب فارغًا، يرجى التعبئة!',
      slotRangeTip: 'لا يمكن أن يكون نطاق سريان الفتحة فارغًا، يرجى التعبئة!',
      yhzc: 'فتحة مستقيمة في الجزء المنحني القوسي',
      xbgy: 'زاوية Haitang مشطوفة ومقبض مشطوف',
      nbyx: 'شكل داخلي غير منتظم',
      secondaryProcessingMerge: 'دمج ملفات المعالجة الثانوية',
      secondaryProcessingMergeName: 'اسم الملف المدمج',
      secondaryProcessingMergeTip: 'عند التفعيل، إذا كان اللوح المُصدَّر يحتوي على عدة عمليات معالجة ثانوية، فسيتم دمجها في ملف معالجة واحد',
      singleFileSetting: 'قم بإخراج ملفات منفصلة لمعالجة زوايا التفاحة المشطوفة والمقابض المشطوفة',
      straightArcSlot: 'قم بإخراج ملف منفصل لمعالجة الأخدود المستقيم لجزء الانحناء القوسي'
      },
    aioMachineSetting: {
      openFunction: 'يجب تشغيل الوظائف التالية للإرساء',
      openCarving: 'قم بتشغيل آلة النقش',
      xyReverseFunction: 'XYوظيفة تبادل المحاور',
      carvingStartSet: 'تم ضبط نقطة البداية لمحطة آلة النقش على',
      rightTop: 'الزاوية اليمنى العليا',
      carvingEdgeSet: 'يتم ضبط قيمة إعادة التشذيب الأمامية لآلة النقش على',
      finalEdgeSame: 'وهي نفس قيمة التشذيب الإجمالية',
      beginCode: 'رمز بدء البرنامج',
      endCode: 'رمز نهاية البرنامج',
      drillHole: 'الحفر',
      pullTrough: 'الحز',
      showDataTemp: 'عرض عينة البيانات',
      dataTemp: 'عينة البيانات',
      title: 'إعدادات آلة الكل في واحد',
      outputFile: 'إخراج ملفات معالجة آلة الكل في واحد',
      outputFileTips: 'بعض العلامات التجارية للآلات الكل في واحد غير متوافقة مع التبادل XY ودمج الملفات وعدم حفر ثقوب ذات شكل خاص. يرجى الاستخدام بحذر',
      fileType: 'تنسيق الملف',
      select: 'يرجى تحديد',
      diameter: 'قطر أداة التشذيب',
      jidongTip: 'عند استخدام آلة Jidong الكل في واحد، يرجى ضبط نقطة البداية لمحطة آلة النقش على الزاوية اليمنى العليا وتمكين وظيفة A',
      skill: 'الوظيفة',
      clampHandLength: 'طول المشبك (L)',
      clampHandWidth: 'عرض المقبض (W)',
      clampHandMargin1: 'مسافة القابض 1 من الحافة (H1)',
      clampHandMargin2: 'حافة مسافة المشبك 2 (H2)',
      duchClampHand: 'موضع المشبك لتجنب فتحة الثقب',
      clampHandDirection: 'اتجاه المشبك',
      left: 'الجانب الأيسر',
      right: 'الجانب الأيمن',
      top: 'الجانب العلوي',
      bottom: 'الجانب السفلي'
      },
    oneDragTwo: {
      title: 'آلة نقش واحد إلى اثنين',
      outputMachineFile: 'إخراج ملفات معالجة آلة نقش واحد إلى اثنين',
      outputMachineFileTips: 'تمكين آلة نقش واحد إلى اثنين غير متوافق مع وظيفة دمج ملفات آلة القطع، يرجى استخدامها مع الحذر',
      fileType: 'تنسيق الملف',
      select: 'يرجى تحديد',
      machineStart: 'نقطة بداية محطة العمل',
      positionClose: 'عند إغلاقه، سيتبع إعداد نقطة بداية المحطة في معلمات القطع',
      engravingPlus: 'آلة النقش السريع'
      },
    sawEngraving: {
      title: 'آلة النشر والنقش',
      preLayNav: 'إعدادات آلة النشر والنقش',
      preLayKnifeInput: 'قطر سكين القطع العرضي لشفرة المنشار',
      enableSaw: 'تمكين آلة النشر والنقش',
      sawAioTip: 'لا يوجد لديك إذن بإخراج بيانات لوحة اللحام AIO؛ يرجى التواصل مع المبيعات للتفعيل.',
      cutSet: 'إعدادات قطع لوحة اللحام',
      weldingPlank: 'لوحة اللحام',
      doorFrame: 'إطار الباب',
      doorFrameTip1: 'استخدام شفرة المنشار',
      doorFrameTip2: '2.استخدام شفرة المنشار 3.استخدام شفرة المنشار',
      sawUsing: 'استخدام شفرة المنشار',
      trim: 'تقليم الحواف',
      cutBlank: 'تقطيع القطع',
      backTrimOblique: 'تقليم الحواف الخلفية',
      holeSlotOblique: 'تقليم الحواف الخلفية',
      plankThicknessUnit: 'ترتيب سمك اللوحات',
      sawUseCond: 'شروط استخدام شفرة المنشار',
      exportPartData: 'إخراج ملفات بيانات اللوحة الصغيرة (ban، mpr، xml، إلخ.)',
      sawAioTip2: 'مناسبة لآلات النشر الشاملة الخالية من النسخ',
      hasUsing: 'استخدم فقط عندما يكون هناك مسار متاح',
      onlyUse: 'استخدم',
      cutMethod: 'طريقة القطع',
      oneKnifePull: 'اسحب اللوحة الكبيرة بسكين واحد',
      onlyOneKnifePull: 'اسحب مباشرة من خلال سكين واحد',
      enableSawThick: 'تمكين تنضيد سمك شفرة المنشار',
      edgedDir: 'حواف اللوحة الكبيرة محكمة الغلق التي لم تعد مقطوعة',
      sameWidthPart: 'قم فقط بترتيب الألواح الصغيرة بنفس العرض على كل لوحة كبيرة',
      emptyPath: 'لا تقم بإنشاء مسار فارغ عند القطع',
      sawUsePlank: 'استخدم معالجة شفرة المنشار فقط لـ الألواح الملحومة',
      paibanGap: 'فجوة تخطيط اللوحة الملحومة',
      minSurplusWidthDiff: 'الحد الأدنى لفرق العرض المطابق للمواد المتبقية',
      minSurplusWidthDiffTip: 'فقط عندما يكون فرق العرض بين اللوح الصغير والمادة المتبقية أقل من هذه القيمة، سيتم ترتيب اللوح الصغير على المادة المتبقية',
      sawReplaceEnable: 'يتم استبدال المسار القطع بالسيارة المستقيمة بالسيارة',
      minSawLength: 'يتم استبدال المسار القطع بالسيارة المستقيمة بالسيارة',
      keepDistance: 'المسافة بين الألواح الصغيرة المتجاورة للقطع بالسيارة المستقيمة',
      keepDistanceTip: 'ملاحظة: لتجنب قطع الألواح المجاورة، يجب أن يكون هناك مساحة كافية',
      sortByLength: 'الترتيب حسب طول الألواح',
      sortByLengthTip: 'يكون اتجاه القطع من الأسفل إلى الأعلى، ويتم ترتيب الألواح حسب العرض أولاً ثم حسب الطول',
      plankAtTop: 'يتم ترتيب الألواح الصغيرة في الأعلى',
      plankAtBottom: 'الألواح الصغيرة في الأسفل',
      useSawTipOne: 'بعد التمكين، ستتم معالجة اللوحات الصغيرة فقط ذات خصائص اللوحة الملحومة في الخزانة باستخدام شفرات المنشار، وسيتم قطع الألواح غير الملحومة بسكين مستقيم',
      useSawTipTwo: 'عند التمكين واستخدام "تسلسل تخطيط اللوحة الكبيرة المخصص"، لن تستخدم اللوحات الملحومة لوحات كبيرة قياسية للتخطيط، وسيتم استخدام لوحات كبيرة خاصة فقط للتخطيط',
      useSaiTipThree: 'بعد تمكين هذه الوظيفة، يجب أن تستخدم خطة التخطيط القطع والتخطيط بالمنشار',
      surplusStoreAndLabeling: 'يمكن تخزين المواد المتبقية بعد القطع وطباعتها باستخدام الملصقات',
      surplusMinLength: 'الحد الأدنى لطول المواد المتبقية',
      surplusMinSize: 'الحد الأدنى لحجم المواد المتبقية',
      crossCutOnlyMinSurplusSize: 'يتم إنشاء مسار القطع العرضي فقط إذا تم تحقيق الحد الأدنى للحجم القابل للاستخدام للمواد المتبقية',
      surplusStoreAndLabelingTip: '1. سيتم إنشاء منطقة زرقاء من المواد المتبقية في الجزء العلوي أو السفلي من اللوحة الكبيرة، والتي يمكن تخزينها وطباعة الملصقات بشكل طبيعي',
      surplusStoreAndLabelingTip2: '2. لن تكون وظيفة "القطع التلقائي للمواد المتبقية" فعالة بالنسبة للألواح الملحومة)',
      surplusStoreAndLabelingTip3: '(بعد التمكين',
      backCutSurplus: 'يتم اعتراض المواد المتبقية من الجانب الخلفي',
      cutSurplusTip: 'بعد التمكين، يرجى ضبط تسلسل التشذيب العكسي على "التقليم بعد معالجة الثقب العكسي"',
      top: 'الحافة العلوية',
      bottom: 'الحافة السفلية',
      left: 'اليسرى',
      right: 'اليمنى',
      dockTip: 'تتطلب معالجة لوحة اللحام التناكبي نفس الختم من الجوانب الأربعة والتشذيب الكلي للوحة المستطيلة، والتشغيل اليدوي في التنضيد في صف واحد',
      sawToLayoutTip: 'بعد تمكين هذه الوظيفة، سيتم حجز فجوة قطع تساوي سمك شفرة المنشار فقط بين الألواح الصغيرة أثناء التنضيد',
      sawToLayoutTip2: 'لا يدعم التنضيد بالنشر حاليًا سكين التقطيع المحدد',
      tempPaiabanTip: 'بعد تمكين قطع شفرة المنشار، لا يتم دعم إضافة لوحات ذات شكل خاص مباشرة في التنضيد. إذا كنت بحاجة إلى إضافته، يرجى الانتقال إلى قائمة القطع للإضافة والتنضيد!',
      generateCutSurplusPath: 'إنشاء مسار شامل يقطع المواد المتبقية أولاً',
      curSurplusPathTip: 'بعد التمكين، يرجى ضبط تسلسل التشذيب العكسي على "التقليم بعد معالجة الثقب العكسي"'
      },
    robotArmDocking: {
      title: 'إرساء الذراع الروبوتية',
      enable: 'تمكين إرساء ذراع الروبوت',
      enableTip: 'بعد التشغيل، عند إخراج ملف الإنتاج، سيتم إخراج ملف إرساء ذراع الروبوت'
      },
    laserCuttingMachine: {
      title: 'جهاز ليزر الكل في واحد',
      enable: 'تمكين جهاز ليزر الكل في واحد',
      backSafeHeight: 'عندما يكون الجانب الخلفي خاملاً Z الارتفاع (H)',
      laserDistance: 'المسافة بين سكين الليزر الأمامي/الخلفي وسطح اللوحة عند القطع',
      coordinateAxis: 'محور الإحداثيات',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: 'إعدادات القطع',
      backKnifeStore: 'مجلة الأداة العكسية',
      noSupportOriginalMaterialKnife: 'لا تدعم حاليًا وظيفة "تحديد سكين التقطيع الأصلي"',
      laserKnifeTip: 'القطع: يستخدم لمعالجة الأشكال الخاصة الداخلية غير المثقوبة',
      laserKnifeTip2: 'سكين الليزر: معالجة فتحات الثقب المثقوبة والأشكال الخاصة الداخلية وتقطيع الكفاف الخارجي',
      laserKnifeTip3: 'ملاحظة: بشكل افتراضي، يستخدم المحور العكسي Z الإحداثيات النسبية المقابلة لمسافة الجدول',
      laserKnifeTip4: 'لا يمكن أن يكون هناك أقل من أداة واحدة',
      laserKnifeTip5: 'لا يمكن حذف سكاكين القطع',
      laserKnifeTip6: 'تم الكشف عن عدم فحص أي أداة للقطع، يرجى التحقق من أداة واحدة على الأقل',
      laserKnifeTip7: 'لا يمكن لسكين الليزر معالجة الأشكال الخاصة التي لم يتم قطعها من الداخل، وتم إلغاء تحديد عنصر "القطع" تلقائيًا',
      laserKnifeTip8: 'يرجى التحقق من الأداة باستخدام خيار "القطع" في مكتبة الأدوات، وإلا فلن تتمكن من معالجة الأشكال الخاصة التي لم يتم قطعها من الداخل',
      laserKnifeTip9: 'قطر أداة الليزر لمخزن أداة القطع وآلة الليزر المتكاملة غير متناسقين، يرجى التحقق',
      laserKnifeTip10: 'قطر أداة القطع في مجلة أداة القطع غير متوافق مع قطر أداة القطع بالليزر الكل في واحد، يرجى التحقق من',
      laserKnifeTip11: 'تم تعديل معلمات إرساء المعدات، يرجى إعادة ترتيبها',
      noLaserPermission: 'ليس لديك إذن باستخدام آلة الليزر الكل في واحد، يرجى الاتصال بالمبيعات لشراء إذن آلة الليزر الكل في واحد قبل الاستخدام',
      laserOpenCode: 'رمز تشغيل الليزر',
      laserCloseCode: 'رمز إيقاف تشغيل الليزر',
      laserToolSettings: 'إعدادات سكين الليزر الأمامي/الخلفي'
      },
    firstSave: 'إنه كذلك اكتشف أن المستخدم يستخدم التنضيد السحابي لأول مرة. بعد حفظ الإعدادات، يرجى الانتباه إلى ما إذا كان اتجاه التشذيب في الملف معقولًا لتجنب الخسائر غير الضرورية',
    knives: {
      xOffset1: 'X إزاحة الإحداثيات',
      yOffset1: 'Y إزاحة الإحداثيات',
      zOffset1: 'Z إزاحة الإحداثيات',
      insert: 'إدراج صف',
      delete: 'حذف صف',
      tip: '(ملاحظة: بعد إكمال تعديل معلومات مجلة الأداة أو تعديل الإعدادات، يحتاج المستخدمون في إنتاج تخطيط الخزانة إلى إعادة تشغيل عميل الخزانة لتطبيق الأحدث التغييرات!)',
      number: 'الرقم',
      name: 'اسم',
      diameter: 'قطر الأداة Φ',
      sawDiameter: 'سمك شفرة المنشار Φ',
      cutting: 'القطع',
      use: 'الغرض',
      moveZF: 'Z سرعة الحركة السريعة للمحور',
      axis_offset: 'إزاحة المحور',
      arc_radius: 'نصف قطر القوس',
      cutZF: 'Z سرعة الحركة السريعة للمحور',
      moveF: 'XY سرعة الحركة السريعة للمحور',
      cutF: 'XY سرعة معالجة المحور',
      startCode: 'رمز بدء تغيير الأداة',
      stopCode: 'رمز نهاية تغيير الأداة',
      startCode2: 'رمز بدء تغيير أداة المحطة 2',
      stopCode2: 'رمز نهاية تغيير أداة المحطة 2',
      knifeLength: 'طول الأداة',
      maximum_single_depth: 'الحد الأقصى لعمق المعالجة الفردي',
      specialShapeKnifeTip: 'فعال فقط للأشكال الخاصة الداخلية',
      preStartCode: 'رمز البدء المسبق',
      punchHoles: 'الحفر',
      pullSlots: 'الحز',
      millHoles: 'الطحن بالثقب',
      millSlots: 'الطحن الشق',
      sawBlade: 'شفرة المنشار',
      doubleSaw: 'تمكين رموز بدء تغيير الأداة المختلفة للمحطات المزدوجة',
      singleStation: 'محطة واحدة',
      doubleStation: 'محطة مزدوجة',
      sawBladeTip: 'لا تسري هذه الوظيفة على آلات النقش الفردية والآلات المتكاملة',
      serialNum: 'الرقم',
      sawWidth: 'عرض الأداة',
      sawType: 'نوع شفرة المنشار',
      cutDirection: 'اتجاه القطع',
      moveSpeed: 'سرعة الخمول',
      cutSpeed: 'سرعة المعالجة',
      endCode: 'رمز نهاية تغيير الأداة',
      sawDownCode: 'رمز القطع',
      sawUpCode: 'رمز التراجع',
      abscissa: 'بادئة الإحداثيات الإحداثية',
      ordinate: 'بادئة الإحداثيات العمودية',
      sawHor: 'شفرة منشار القطع المتقاطع',
      sawVer: 'شفرة منشار القطع العمودي',
      towardsZero: 'القطع باتجاه إحداثي 0 نقطة',
      awayFromZero: 'القطع بعيدًا عن إحداثي النقطة 0',
      diameterDesc: 'قطر الأداة Φ',
      xOffset: 'إزاحة الإحداثيات الأفقية',
      yOffset: 'إزاحة الإحداثيات الطولية',
      zOffset: 'إزاحة إحداثيات الرفع',
      offsetX: 'الإزاحة X',
      offsetY: 'الإزاحة Y',
      offsetZ: 'الإزاحة Z',
      offsetNo: 'رقم الإزاحة',
      knifeWidth: 'عرض الأداة',
      drill: 'القطع',
      cut: 'المعالجة',
      speed: 'السرعة',
      type: 'النوع',
      millHoleSlot: 'فتحة/فتحة الطحن',
      rapidFeedSpeed: 'معدل التغذية السريع',
      typeOption1: 'لقمة الحفر',
      typeOption2: 'الطحن القاطع',
      typeOption3: 'قاطع التشكيل',
      typeTip: 'بعد تعيين نوع الأداة، سوف تتطابق فتحة الثقب مع نوع الأداة المقابل للمعالجة'
      },
    other: {
      title: 'أخرى',
      tip: '(ملاحظة: تحتاج معدات المحطة الواحدة إلى ملء نفس رمز التحميل التلقائي للمحطة 1 والمحطة 2)'
      }
    },
  sideHoleMachine: {
    moreSetting: 'المزيد من الإعدادات',
    sideStartCode: 'إنشاء رمز تغيير الوجه للمعالجة الأمامية',
    useArcCode: 'أمر الاستيفاء القوسي لقطع القوس',
    coordSwitch: 'تبديل مسند الإسناد',
    updownCoordSwitch: 'مبادلة مرجعية الإحداثيات للرفع والخفض',
    xCoordSwitch: 'مبادلة مرجعية الإحداثيات المستعرضة',
    yCoordSwitch: 'مبادلة مرجعية الإحداثيات الطولية',
    knifes: {
      number: 'الرقم',
      diameter: 'عرض الأداة',
      type: 'النوع',
      moveSpeed: 'معدل التغذية السريع',
      doSpeed: 'سرعة المعالجة',
      startCode: 'رمز بدء تغيير الأداة',
      endCode: 'رمز نهاية تغيير الأداة'
      },
    ymSetting: 'إعدادات اتصال Yimu',
    flanking: 'المعالجة الجانبية',
    frontProcess: 'المعالجة الأمامية',
    oldSetting: 'إعداد الإصدار القديم',
    equipParamsSetting: 'إعداد معلمة المعدات',
    holeSetting: 'إعداد الثقب',
    raminoSetting: 'إعداد اتصال Lamino',
    mortiseTenonSetting: 'إعداد اتصال نقر ولسان',
    straight: 'النمط المستقيم',
    eccentric: 'النمط غريب الأطوار',
    pbSize: 'حجم اللوحة المكسورة العلوية والسفلية',
    slotOverlapRate: 'معدل تداخل فتحة الطحن',
    breakingBoardDirection: 'اتجاه كسر اللوحة لأعلى ولأسفل',
    coordinateValue: 'قيمة الإحداثيات',
    codeFormat: 'تنسيق ترميز الملف',
    suffixSetting: 'إعداد لاحقة الملف',
    insertRow: 'إدراج صف',
    deleteRow: 'حذف صف',
    equipmentParams: {
      equipPauseCode: 'رمز إيقاف المعدات',
      wiggleCode: 'رمز التأرجح',
      equipStartCode: 'رمز بدء تشغيل المعدات',
      flipPauseCode: 'رمز إيقاف الإيقاف المؤقت',
      equipEndCode: 'رمز نهاية المعدات',
      equipStartCodePlaceholder: 'إدخال رمز بدء تشغيل المعدات',
      retractingCode: 'رمز أمر إغلاق الأداة',
      retractingCodePlaceholder: 'رمز أمر سحب أداة الإدخال',
      flipPauseCodePlaceholder: 'رمز الإيقاف المؤقت لقلب الإدخال',
      equipEndCodeTip: 'إدخال رمز نهاية المعدات',
      sideChangeSetting: 'التغيير الجانبي الإعدادات',
      workTip: 'افتراضيًا، تبدأ المعالجة من اليسار ① في اتجاه عكس عقارب الساعة',
      frontTurnCode: 'رمز البداية العلوية',
      frontTurnEndCode: 'رمز النهاية العلوية',
      frontTurnCodePlaceholder: 'أدخل رمز البداية العلوية',
      frontTurnEndCodePlaceholder: 'أدخل رمز النهاية العلوية',
      leftTurnCode: 'رمز البداية اليسرى',
      leftTurnEndCode: 'رمز النهاية اليسرى',
      leftTurnCodePlaceholder: 'أدخل رمز البداية اليسرى',
      leftTurnEndCodePlaceholder: 'أدخل رمز النهاية اليسرى',
      downTurnCode: 'رمز البداية أدناه',
      downTurnEndCode: 'رمز النهاية أدناه',
      downTurnCodePlaceholder: 'أدخل رمز البداية أدناه',
      downTurnEndCodePlaceholder: 'أدخل رمز النهاية أدناه',
      rightTurnCode: 'رمز البداية اليمنى',
      rightTurnEndCode: 'رمز النهاية اليمنى',
      rightTurnCodePlaceholder: 'أدخل رمز البداية اليمنى',
      rightTurnEndCodePlaceholder: 'أدخل رمز النهاية اليمنى',
      topFlipCode: 'رمز الوجه - العلوي',
      downFlipCode: 'رمز الوجه - السفلي',
      leftFlipCode: 'رمز الوجه - اليسار',
      rightFlipCode: 'رمز الدوران - اليمين',
      cylinderOutCode: 'رمز دفع الأسطوانة',
      cylinderbackCode: 'رمز تراجع الأسطوانة',
      cylinderbackDirective: 'أمر تراجع الأسطوانة',
      moveDirective: 'أمر الحركة',
      moveAxisCode: 'محور الحركة',
      pushAxisCode: 'محور دفع الأسطوانة',
      swingAxisCode: 'محور التأرجح',
      moveCode: 'رمز الحركة',
      punchCode: 'رمز المعالجة',
      free: 'حركة الخمول',
      punchPart: 'جزء المعالجة',
      cutFaceCode: 'رمز مستوى المعالجة',
      horVerCutFace: 'المستوى الطولي الأفقي',
      horCutFace: 'مستوى الرفع الأفقي',
      verCutFace: 'مستوى الرفع الطولي',
      specifySmallBoardMaterialNoCut: 'حدد مادة اللوحة الصغيرة ولا تكون فارغة',
      specifySmallBoardMaterialNoCutTip: 'الألواح التي تحتوي على كلمات رئيسية مقابلة في مادة اللوحة سوف تولد فقط ملفات فتحة ثقب للحفر بخمسة أو ستة جوانب ولن تكون فارغة',
      addMaterialKeyword: 'إضافة كلمات رئيسية للمادة',
      keyword: 'الكلمات الرئيسية'
      },
    tagPool: 'تجمع علامات البيانات',
    dragTip: 'يمكن سحب العلامات الموجودة في تجمع العلامات وإسقاطها',
    knives: 'أداة المعالجة:',
    directives: 'تعليمات المعالجة:',
    slot: 'معالجة الأخدود المستقيم',
    cirWork: 'معالجة القوس',
    cirInter: 'استيفاء القوس',
    cirOption1: 'في اتجاه عقارب الساعة: G03 عكس اتجاه عقارب الساعة: G02',
    cirOption2: 'في اتجاه عقارب الساعة: G02 عكس اتجاه عقارب الساعة: G03',
    coordinate: {
      xPointSymbol: 'الإحداثي الأفقي:',
      yPointSymbol: 'الإحداثي الطولي:',
      zPointSymbol: 'إحداثي الرفع:',
      upright: 'القيمة الموجبة',
      negative: 'القيم السالبة'
      },
    encodeFormat: {
      format: 'تنسيق ترميز الملف:',
      wrap: 'إعدادات تنسيق فاصل الأسطر:',
      formatOption1: 'UTF-8 التنسيق',
      formatOption2: 'ANSI التنسيق'
      },
    suffix: 'إعدادات لاحقة الملف:',
    enableFP: 'تمكين المعالجة الأمامية',
    slotSetting: 'إعدادات الحز',
    slotMillSetting: 'إعدادات الحز/الطحن وفتحة الطحن',
    millSlot: 'دعم فتحات الطحن والطحن',
    millingSlotOverlapRate: 'معدل تداخل فتحة الطحن',
    millingHoleSlotOverlapRate: 'معدل تداخل فتحة الطحن والطحن',
    takeUpDirective: 'أمر إغلاق الأداة',
    workSeparately: 'تتم معالجة الفتحة الجانبية الأمامية/الخلفية في قسمين',
    secondSlotLong: 'طول الفتحة الثانية',
    enableOld: 'تمكين إعدادات آلة الفتحة الجانبية القديمة',
    default: 'الإعدادات الافتراضية',
    customizable1: 'واحدة مخصصة',
    customizable2: 'مخصصة اثنين',
    customizable3: 'ثلاثة مخصصة',
    customizable4: 'أربعة مخصصة',
    knifeSetting: 'إعدادات الأداة',
    soltTip: '(بما في ذلك فتحات/فتحات الطحن)',
    specialSetting: 'إعدادات خاصة',
    ramino: 'لامينو',
    sun: 'نقر ولسان',
    please: 'ترقبوا',
    designatedKnives: 'تحديد الأداة',
    designated: 'تحديد',
    workOrder: 'أمر المعالجة',
    other: 'أخرى',
    nameSetting: 'إعداد اسم اللاحقة',
    repeatErr: 'رقم مكرر، يرجى إعادة تعيين'
    },
  electronicSaw: {
    importMaterial: 'قائمة استيراد المواد الخام',
    formSetting: 'إعداد نموذج المنشار الإلكتروني',
    fileFormat: 'تنسيق ملف قائمة قطع الإخراج:',
    isSmallFile: 'تصدير ملف صورة لوحة صغيرة:',
    fileGroupRule: 'ملف المنشار الإلكتروني مقسم إلى جداول مختلفة وفقًا للون والمادة وسمك اللوحة:',
    roomsByCategory: 'ملف المنشار الإلكتروني مقسم إلى جداول مختلفة الجداول حسب الغرفة:',
    delimiter: 'الفاصل:',
    fileName: 'اسم ملف قائمة قطع المواد:',
    fineNameTip: 'لا يمكن أن يكون اسم ملف قائمة قطع المواد فارغًا!',
    fileNamePlaceholder: 'قائمة المواد المخصصة',
    outputFileEncoding: 'تنسيق ترميز قائمة المخرجات:',
    utf8: 'UTF-8 مع BOM',
    cellTab: 'إنشاء علامة تبويب خلية:',
    texture: 'تمثيل الملمس:',
    special: 'تمثيل ذو شكل خاص:',
    notSpecial: 'ليس ذو شكل خاص',
    genSimpleLabelBarcode: 'إنشاء رمز شريطي للتسمية بتنسيق بسيط',
    uniqueBarCode: 'لوحة الباركود فريدة من نوعها',
    uniqueBarCodeTip: 'لا تصبح وظيفة إنشاء باركود تسمية بسيط التنسيق سارية المفعول بعد تشغيلها',
    roboticArmDocking: 'إرساء الذراع الروبوتية',
    customeForm: 'نموذج مخصص',
    tagPool: 'تجمع علامات البيانات',
    tagPoolTips: 'يمكنك السحب أو النقر لنسخ الملصق في مجموعة الملصقات',
    displayHead: 'لا تعرض الرأس',
    addTableHead: 'إضافة رأس',
    deleteTableHead: 'حذف رأس',
    generateExample: 'إنشاء عينة نموذج الإخراج',
    importExample: 'عينة نموذج الاستيراد',
    importExampleTip: 'عينة نموذج مستوردة، كمرجع فقط للمناشير الإلكترونية المخصصة',
    importExampleErrTip: 'تحتوي قائمة المواد على لم يتم استيرادها بعد، يرجى استيراد قائمة المواد',
    outputExample: 'نموذج نموذج الإخراج',
    outputExampleTip: 'نموذج إخراج النموذج المخصص',
    outputExampleErrTip: 'لم يتم إنشاء نموذج نموذج الإخراج بعد، يرجى إنشاء نموذج نموذج الإخراج',
    defaultTableHead: 'الرأس الافتراضي',
    deleteHeadErrTip: 'لا يوجد رأس يمكن حذفه!',
    genNonString: 'إنشاء نوع بيانات بتنسيق غير نصي',
    genNonStringTip: 'إذا لم يتمكن المنشار الإلكتروني من التعرف على بيانات الجدول التي تم إنشاؤها، فيمكنك محاولة تمكينها.',
    revertWidth: 'تبديل طول وعرض الألواح المخططة الأفقية'
    },
  lockModal: {
    passwordInput: 'الرجاء إدخال كلمة المرور',
    lockPassword: 'كلمة مرور القفل',
    lockPasswordInput: 'يرجى إدخال كلمة مرور إلغاء القفل',
    passwordInputPlaceholder: 'يرجى إدخال كلمة المرور المكونة من أربعة أرقام',
    editPassword: 'تغيير كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    setLockPwd: 'تعيين كلمة مرور إلغاء القفل',
    pwdFormatErr: 'تنسيق كلمة مرور خاطئة',
    sendMessageTo: 'سيتم إرسال رمز التحقق عبر الرسائل القصيرة إلى',
    captchaPlaceholder: 'يرجى إدخال رمز التحقق',
    sendCaptcha: 'إرسال رمز التحقق',
    sendSeccess: 'تم إرسال الرسائل القصيرة بنجاح',
    sendFail: 'فشل إرسال الرسائل القصيرة، يرجى المحاولة مرة أخرى لاحقًا',
    updateSeccess: 'تم تعيين كلمة المرور بنجاح',
    editSuccess: 'تم تعديلها بنجاح',
    lockSeccess: 'كلمة المرور] تم القفل بنجاح',
    lock: 'فتح القفل',
    lockSeccessTip: 'تم القفل بنجاح',
    inputErrLimit: 'لقد وصل العدد الحالي من الأخطاء إلى الحد الأقصى، يرجى إعادة تعيين كلمة مرور إلغاء القفل!'
    },
  dock56Drill: {
    equipType: 'نوع المعدات',
    equipment: 'المعدات',
    fiveDock: 'المثقاب الخماسي الجوانب',
    sixDock: 'المثقاب سداسي الجوانب',
    fileType: 'نوع الملف المُنشأ',
    templateOffline: 'القالب المستخدم غير متصل!',
    showExample: 'عرض عينة البيانات',
    conNoticeTip: 'ملاحظات الإرساء:',
    conNoticeTip1: '1. آلة النقش مع تمكين "XY تبادل المحاور" تحتاج إلى تشغيل وظيفة "التكيف التلقائي وتبادل معدات معالجة الثقب" في آلة النقش',
    conNoticeTip2: '2. لعرض أو معالجة الجزء ذو الشكل الخاص من اللوحة على المثقاب ذي الخمسة ستة جوانب، يجب تكوين بيانات الجزء ذي الشكل الخاص في القالب',
    conNoticeTip3: '3. بعد استخدام المثقاب ذو الشكل الخاص ذو الخمسة ستة جوانب أو تغيير القالب للمرة الأولى الوقت، يرجى <span style="color:#f00"> إجراء الإنتاج التجريبي للخزانة </span>، ثم المتابعة إلى الإنتاج المنتظم بعد التأكيد',
    conNoticeTip4: '4. أثناء الإنتاج التجريبي، يرجى التحقق بعناية مما إذا كان حجم الفتحات الأمامية والخلفية وعمقها وسطحها وموضعها صحيحًا، <span style="color:#f00" > لتجنب مشكلة انعكاس الخزانة </span>',
    example: 'عينة البيانات',
    commonSetting: 'إعدادات المعلمات العامة',
    throughHoleSetting: 'يتم فتح الفتحات من خلال الجانبين',
    throughSlotSetting: 'يتم فتح الفتحات على كلا الجانبين',
    nonHolesNotFiles: 'إذا كانت اللوحة المستطيلة لا تحتوي على ثقوب، فلن يتم إخراج الملف:',
    frontFileIdentifier: 'تعريف الملف الأمامي:',
    oppositeFileIdentifier: 'تعريف الملف العكسي:',
    oppositeFileIdentifierTips: 'طريقة التوليد هي: رمز اللوحة الأصلي 13 بت + حرف التعريف',
    arcDescription: 'طريقة وصف القوس',
    linePoints: 'وصف تشكيل مقطع الخط',
    arcCommand: 'وصف أمر القوس',
    slotWidthSplit: 'تفكيك أخدود عريض إلى أخاديد ضيقة متعددة للمعالجة:',
    slotSplitWidth: 'عرض أخدود فردي بعد التفكيك:',
    mm: 'ملاحظة: كائن التفكيك هو أخدود مستطيل عادي',
    isNotMergeSlot: 'يتم سحب الأخاديد المتساوية العرض والعمق المتساوي من خلال:',
    slotPunchTip: 'هذه الوظيفة فعالة فقط لأخاديد اللوحة الخلفية وأخاديد أسفل الدرج باستخدام قوالب مخصصة',
    sizeRange: 'الأبعاد المجاورة أقل من أو تساوي',
    enableWorningTip: 'لا يمكن تشغيل هذه الوظيفة واتجاه وضع نطاق الحافة الأمامية في نفس الوقت',
    longDirection: 'اتجاه وضع الجانب الطويل للألواح',
    horizontal: 'أفقي',
    vertical: 'طولي',
    slotDirection: 'أخدود حفر خماسي/ستة جوانب أو اتجاه وضع ذو شكل خاص',
    default: 'النظام الافتراضي',
    frontLeft: 'أمامي ويسار',
    frontRight: 'أمامي ويمين',
    backLeft: 'خلفي ويسار',
    backRight: 'خلفي ويمين',
    frontDirection: 'اتجاه موضع نطاق الحافة الأمامية',
    enableTip: 'ملاحظة: فعال فقط في التنضيد السحابي',
    fixedOn: 'تم التثبيت أمام:',
    front: 'Front',
    back: 'تحتفظ قيمة الإحداثيات',
    left: 'اليسرى',
    right: 'اليمنى',
    coordinateValue: 'التالية بعدد الأرقام:',
    decimalPlaces: 'أرقام',
    slotLengthCompensation: 'تعويض طول الأخدود',
    curveholesLengthCompensation: 'مسح الزاوية الداخلية ذات الشكل الخاص',
    slotCompensationEqualZero: 'تعويض حافة الأخدود بمسافة 0',
    slotCompensationNotEqualZero: 'تعويض حافة الأخدود بمسافة غير 0',
    slotCompensationTip: 'استخدم هذه الوظيفة عند معالجة شريحة صغيرة لم يتم قطعها بشكل نظيف أو الطول غير كافٍ',
    curveholesCompensationEqualZero: 'تعويض الحافة الداخلية ذات الشكل الخاص بمسافة 0',
    curveholesCompensationTip: 'الإدخال الموصى به: قيمة نصف القطر لأداة الطحن الداخلية ذات الشكل الخاص',
    curveholesCompensationTip2: 'استخدم هذه الوظيفة عندما يكون الشكل الداخلي الخاص المعالج بواسطة الحافة المستطيلة لمخطط اللوحة يحتوي على شرائح صغيرة غير مقطوعة',
    specialParameter: 'إعدادات المعلمات الخاصة',
    output5FDrillSlotKnifeCode: 'XML2 رقم أداة الطحن',
    output5FDrillShapeKnifeCode: 'XML2 رقم أداة الطحن',
    plankTexture: 'XML2نسيج اللوحة',
    offset: 'XML2 تعويض أداة الطحن',
    mprConHoleDir: 'الحفر بخمسة/ستة جوانب MPR فتحة جانبية للملف Z مستوى مسند الإسناد',
    plankTop: 'السطح العلوي للوحة',
    plankBottom: 'السطح السفلي للوحة',
    codeInfo: 'يحتوي ملف تنسيق الحظر على معلومات Code:',
    bomFile: 'ملف تنسيق بوم الإخراج:',
    plankHeight: 'وصف ارتفاع اللوحة:',
    plankNum: 'وصف رقم اللوحة:',
    backZpoint: 'إحداثيات الأخدود العكسي Z:',
    plankThick: 'سمك اللوحة',
    slotDeep: 'عمق الأخدود',
    outputMprFile: 'نوع الملف',
    oldMPR: 'الإصدار القديم MPR',
    newMPR: 'الإصدار الجديد MPR',
    mprFileZside: 'الحفر بخمسة/ستة جوانب MPR فتحة جانبية للملف Z مستوى مسند الإسناد',
    fileTypeOffline: 'نوع الملف الماسي ذو الخمسة جوانب المحدد حاليًا غير متصل بالإنترنت، يرجى التأكيد!',
    permissionErr: 'لقد فقدت المعلومات الشخصية، يرجى إعادة فتح هذه الصفحة من مجلس الوزراء!',
    banFileSetting: 'إعدادات ملف تنسيق الحظر',
    banFileCodeInfo: 'يحتوي ملف تنسيق الحظر على معلومات Code:',
    huahuaLine: 'خط Huahua التلقائي',
    huahuaLineTip: '(غير متوافق مع المعيار المرجعي لوضع التسمية)',
    huahuaPartFlag: {
      longSide: 'الجانب الطويل أصغر من',
      shortSide: 'أو الجانب القصير أصغر من',
      partFlag: 'إنشاء تعريف صغير للوحة لأجزاء اللوحة',
      tip: '(من الضروري إضافة بيانات "تحديد اللوحة - علامة اللوحة الصغيرة" لعرضها على الملصق، وستتم إضافة البيانات المقابلة تلقائيًا إلى ملف خط Huahua التلقائي)'
      },
    plankPutWay: 'طريقة وضع اللوحة',
    plankPutWayTip: 'إذا كانت خط الإنتاج الحالي مفعلًا ، فلا يتم دعم ضبط طريقة وضع اللوحة',
    autoHandle: 'التجنب التلقائي لتشابك الأيدي',
    manualHandle: 'الإعداد اليدوي للتجنب',
    fixedFront: 'نطاق الحافة الأمامية الثابتة',
    plankNamePlacement: 'الوضع حسب اسم اللوحة',
    plankNamePlacementTip1: '1. بعد الإعداد، عندما يحتوي اسم اللوحة على الحقل المحدد، سيتم تثبيت الحافة المقابلة للوحة على الجانب المحدد من الجهاز وفقًا للإعدادات',
    plankNamePlacementTip2: '2. أولوية هذا الإعداد أعلى من إعداد طريقة وضع اللوحة أعلاه',
    plankNamePlacementTip3: '3. هذه الميزة فعّالة فقط للتخطيط السحابي؛ إذا كان خط الإنتاج الحالي مفعّلًا لخط Huahua التلقائي، فلن يتم دعم إعداد وضع اللوحة بشكل منفصل',
    addRow: 'إضافة صف',
    plankNameTip: 'يرجى إدخال اسم اللوحة',
    plankSide: 'حافة اللوحة',
    deviceSide: 'تثبيت على الجهاز',
    weldingPlatePlacementEnable: 'تثبيت اللوحة الملحومة ثابت',
    onlyBluen: 'فعال فقط في التنضيد السحابي',
    fixedEdge: 'نطاق الحافة الأمامية الثابتة',
    fixedEdgeRule: 'القاعدة: تحديد موضع اللوحة',
    fixedEdgeRuleItem1: 'الحافة الطويلة تقريباً بالقرب من المشبك',
    fixedEdgeRuleItem2: 'نطاق الحافة الأمامية الثابتة',
    fixedEdgeRuleItem3: 'نطاق الحافة الأمامية الثابتة',
    fixedEdgeRuleItem4: 'ترتيب الأولوية',
    satisfiedCondition: 'ترتيب الأولوية',
    handDirection: 'اتجاه أيدي التثبيت',
    handleMachineTip: 'عن طريق الدوران، والفتحات والخاصة تتجنب الأشكال تلقائيًا الجانب الذي يوجد فيه المشبك، مما يسهل معالجة اللوحة',
    handleWidth: 'عرض المشبك',
    handleLength: 'طول المشبك',
    handleMaxWidth: 'الحد الأقصى للعرض الذي يمكن للمعدات معالجته',
    usefulRange: 'النطاق الفعال',
    plankLongSide: 'الجانب الطويل من اللوحة',
    usefulRangeTip: 'عندما يتم تمكين الجانب الطويل من اللوحة ويكون الجانب الطويل من اللوحة ضمن النطاق الفعال، سيتم إعطاء الأولوية للفتحة ومواضع الموضع ذات الشكل الخاص',
    moveTip: 'تكون وظيفة وضع علامات على المستندات الأمامية والخلفية تم الانتقال إلى',
    millingOuter: 'طحن الأشكال الخاصة الخارجية',
    millingInner: 'طحن الأشكال الخاصة الداخلية',
    drilling: 'تجهيز الثقوب',
    slotting: 'فتحات المعالجة',
    knivesTip1: '1. بعد إعداد قاطعة الطحن ذات الشكل الخاص، سيعوض مسار القطع نصف قطر القاطع الخاص بها',
    knivesTip2: '2. لا يدعم القطع ذو الشكل الخاص حاليًا آلة النقش القابلة للتبديل على المحور xy',
    internalCutting: 'يوجد القطع الداخلي ذو الشكل الخاص وفتح وإغلاق السكين داخل اللوحة',
    externalCutting: 'يوجد القطع الخارجي ذو الشكل الخاص والقطع الخارجي ذو الشكل الخاص على الجزء الخارجي من اللوحة',
    externalCuttingDirection: 'عندما يكون خارجيًا القطع على شكل خاص، سيتم قطع الحافة بأكملها التي تحتوي على الشكل ذو الشكل الخاص في وقت واحد',
    allExternalCutting: 'جميع الأشكال ذات الشكل الخاص الخارجي',
    onlyArcExternalCutting: 'شكل القوس الخارجي الخاص فقط'
    },
  doorWallCabinet: {
    tempErrTip: 'تم اكتشاف أنك لم تضف القالب المستخدم لآلة الأبواب والجدران والخزائن المتكاملة، لذلك لا يمكن تصدير ملف المعالجة. ملاحظة: بعد الإضافة، يجب إعادة التنضيد.',
    title: 'آلة الأبواب والجدران والخزائن المتكاملة',
    guifang: 'التربيع',
    processingTechnology: 'تقنية المعالجة',
    longPlateSecondarySquaring: 'التربيع الثانوي للوحة الطويلة',
    slotOnDoorPlate: 'فتحة في لوحة الباب',
    setting: 'إعدادات آلة الأبواب والجدران والخزائن المتكاملة'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: 'تنسيق ملف الإخراج',
    outputDefaultFileFormat: 'ملف التنسيق الافتراضي للإخراج',
    outputMPRFormat: 'ملف تنسيق الإخراج MPR',
    fileFormatSettings: 'إعداد تنسيق الملف',
    wrapSettings: 'إعدادات تنسيق فاصل الأسطر:',
    enCodeSettings: 'إعدادات تنسيق ترميز الملف:',
    utf8bom: 'UTF-8 مع BOM',
    partCoordinate: 'إحداثيات اللوحة الصغيرة',
    xPointSymbol: 'الإحداثي الأفقي:',
    yPointSymbol: 'الإحداثي الطولي:',
    zPointSymbol: 'إحداثي الرفع:',
    upRight: 'القيمة الموجبة',
    negative: 'القيم السالبة',
    plankMirroring: 'مرآة اللوحة',
    plankMirrorSetting: 'إعدادات مرآة اللوحة:',
    xAxis: 'X مرآة المحور',
    yAxis: 'Yانعكاس المحور',
    mirrorTip: '(استخدم هذه الوظيفة عند عكس اللوحة)',
    knifeTable: {
      type: 'النوع',
      diameter: 'القطرΦ',
      offsetX: 'الإزاحة X',
      offsetY: 'الإزاحة Y',
      offsetZ: 'الإزاحة Z',
      offsetNo: 'رقم الإزاحة',
      drillVelocity: 'قطع [F] مم/دقيقة',
      cutVelocity: 'معالجة [F] مم/دقيقة',
      rotationSeep: 'السرعة[S]ص/دقيقة',
      insertRow: 'إدراج صف',
      deleteRow: 'حذف صف'
      },
    labelPool: 'تجمع علامات البيانات',
    dragTip: 'يمكنك السحب أو النقر لنسخ العلامات الموجودة في تجمع العلامات في مربع الإدخال',
    procedure: 'برنامج',
    beginCode: 'رمز بدء البرنامج:',
    endCode: 'رمز نهاية البرنامج:',
    zzdKnifeBeginCode: 'تغيير رمز البدء لأداة المغزل:',
    spindleCutter: 'القاطع المغزل',
    zzdKnifeEndCode: 'تغيير رمز النهاية لأداة المغزل:',
    verticalDrill: 'الحفر العمودي',
    czzBeginCode: 'رمز بدء الحفر العمودي:',
    czzEndCode: 'رمز نهاية الحفر العمودي:',
    czzKnifeBeginCode: 'أداة الحفر العمودي تغير رمز البدء:',
    czzKnifeEndCode: 'أداة الحفر العمودية تغير رمز النهاية:',
    sidetrack: 'الحفر الجانبي',
    czBeginCode: 'رمز بدء التشغيل Sidetrack:',
    czEndCode: 'رمز نهاية الحفر الجانبي:',
    czKnifeBeginCode: 'تغيير رمز البدء لأداة الحفر الجانبية:',
    czKnifeEndCode: 'أداة الحفر الجانبية تغير رمز النهاية:',
    pauseCode: 'رمز الإيقاف المؤقت:',
    zSafeHeight: 'مسافة الأمان',
    spindleKnife: 'أداة المغزل والحفر العمودي Z ارتفاع أمان المحور',
    sideDrillZ: 'ارتفاع أمان المحور Z الحفر الجانبي',
    sideDrillXY: 'مسافة أمان المحور X/Y مسافة أمان المحور',
    auxiliaryFunction: 'الوظيفة المساعدة',
    xhDedicatedInfo: 'إنشاء معلومات محددة لمعدات Xinghui',
    xhCheckBox: 'البيانات:',
    outputSettings: 'إعدادات الإخراج:',
    partExegesis: 'إنشاء تعليقات بحجم لوحة صغيرة في ملف',
    knifeNo: 'رقم الأداة',
    specailKnifeNo: 'رقم الأداة ذات الشكل الخاص:',
    slotKnifeNo: 'رقم أداة الحز:',
    fileNamePlaceholder: 'قائمة المواد المخصصة',
    slotDrill: 'سكين فرد'
    },
  glassEquip: {
    title: 'آلة قطع الزجاج',
    fileType: 'نوع ملف المعالجة:',
    sizeReparation: 'تعويض حجم اللوحة:',
    cutPreSpace: 'المسافة الاحتياطية لقطع اللوحة:',
    divideIntoFolders: 'مصنفة في مجلدات مختلفة وفقًا للون الزجاج والمادة والسمك:'
    },
  translate: {
    search: 'يرجى إدخال الترجمة الصينية أو الرسمية للعثور على الإدخال',
    en: 'إنجليزي',
    es: 'الإسبانية',
    ar: 'العربية',
    kz: 'الكازاخستانية',
    vi: 'الفيتنامية',
    th: 'التايلاندية',
    id: 'الإندونيسية',
    ug: 'الأويغور',
    customTranslate: 'انقر لإضافة ترجمة مخصصة',
    customText: 'ترجمة مخصصة',
    text: 'الصينية',
    targetLang: 'الترجمة الرسمية',
    zh_hant: 'الصينية التقليدية'
    },
  preLayoutSetting: {
    title: 'الإعدادات المسبقة',
    titleTip: 'يمكنك ضبط معلمات التنضيد أولاً، والتنضيد أولاً، ثم تحديد خط الإنتاج',
    settingTip: 'يجب أن تكون المعلمات المحددة في خط الإنتاج متسقة مع معلمات التنضيد المسبق التالية لإخراج ملف الإنتاج، وهو فعال فقط لآلة القطع',
    emptyKnife: 'لم يتم ملء الأداة',
    noModify: 'لم يتم تعديل الإعداد، لا حاجة لحفظ',
    reSet: 'استعادة',
    gayPosition: 'يمكن للمربع الرمادي تبديل موضع وضع المواد المتبقية',
    surplusPosition: 'هو موضع وضع المواد المتبقي الحالي',
    click: 'انقر فوق',
    grayStart: 'يمكن للمربع الرمادي التبديل نقطة البداية لمحطة العمل',
    currentStart: 'لنقطة انطلاق المحطة الحالية',
    holeSlotSetting: 'إعدادات معالجة فتحة التثقيب والتثقيب',
    knifeDiameter: 'قطر سكين القطع',
    currentVersion: 'الإصدار الحالي',
    on: 'تشغيل',
    off: 'إيقاف',
    firstShort: 'القطع الأول - التحميل الزائد على الجانب القصير',
    firstLong: 'القطع الأول - التحميل الزائد على الجانب الطويل',
    cuttingSplitLong: 'يتم قطع اللوحة الطويلة مرتين - يتجاوز الجانب الطويل',
    cuttingSplitShort: 'يتم قطع اللوحة الطويلة مرتين - يتجاوز الجانب القصير',
    plankThick: 'سمك اللوحة التقليدية ≥',
    singleDoorThick: 'سمك لوحة الباب ≥ ',
    normalPlank: 'اللوحة التقليدية',
    confilictTip: 'هناك عناصر تعارض في الإعداد: {confilictTotal}',
    selectLine: 'حدد خط الإنتاج',
    selectLinePlaceholder: 'يرجى تحديد خط الإنتاج',
    lineConfilictTip: 'هناك تعارض بين خط الإنتاج المحدد و {line}',
    preWay: 'خطة التخطيط المسبق',
    paibanErrTip: 'عندما يتغير 【长、短边放量】 لمعالجة اللوحة الطويلة، قد يتسبب ذلك في فشل التخطيط',
    paibanTip: 'هناك سكين قطع مخصص لمواد اللوحة الكبيرة في هذا التخطيط، ويجب أن يكون إعادة التخطيط',
    reLayout: 'إعادة التخطيط باستخدام خط الإنتاج الحالي',
    fetchErr: 'فشل الحصول على إعدادات التخطيط المسبق',
    resetSuccess: 'تمت الاستعادة بنجاح',
    resetConfirm: 'هل أنت متأكد من رغبتك في الاستعادة إلى الإصدار التاريخي؟',
    prolineName: 'اسم خط الإنتاج',
    layoutGap: 'فجوة التنضيد',
    generalThickness: 'أداة القطع الثانوية - سمك اللوحة العادية',
    cutGeneralPlank: 'أداة القطع الثانوية - اللوحة العادية',
    cutSingleDoor: 'أداة القطع الثانوية - لوحة الباب',
    secondary_cutting_board_list: 'تحديد اسم اللوحة لقطع قائمة أسماء اللوحة',
    changeProline: 'تبديل خط الإنتاج',
    backTip: 'يرجى العودة إلى التنضيد العالمي لتحديد خط الإنتاج',
    preLayout: 'التنضيد وفقًا لنظام التنضيد المسبق',
    preWayEmpty: 'مخطط التنضيد المسبق (فارغ)',
    specialConfilictTip: 'تؤثر عملية الطحن القوسي على نتائج التنضيد وتحتاج إلى إعادة التنضيد'
    },
  lunbo: {
    tips: 'نصائح التشغيل',
    introduction: 'مقدمة الوظيفة',
    qtDownloadText: 'تذكير دافئ: إذا كان الملف الذي تم تنزيله غير مكتمل، فيرجى الانتقال إلى صفحة ويب التنضيد السحابي للتنزيل!'
    },
  sendModal: {
    paibanImgType: 'نوع ملف التخطيط'
    },
  authenticationModal: {
    title: 'مسح الرمز للتحقق من التفويض',
    tip: 'لا تغلق المربع المنبثق قبل نجاح التفويض!',
    countdownTip: 'تنتهي صلاحيته بعد {countdown}',
    refreshTip: 'تحديث رمز الاستجابة السريعة',
    qrcodeTip: 'يرجى استخدام WeChat لمسح رمز الاستجابة السريعة ضوئيًا لإكمال العملية',
    qrcodeTip2: 'إذا فشل حفظ رمز الاستجابة السريعة المسح الضوئي، فستحتاج إلى الحصول على تصريح لتعديل أذونات النظام في الإعدادات العامة للخزانة - إعدادات ترخيص المستخدم.',
    waiting: 'في انتظار المسح',
    scanning: 'الرمز الممسوح ضوئيًا، في انتظار التأكيد',
    success: 'نجح التحقق',
    error: 'فشل التحقق',
    expired: 'انتهت صلاحية رمز الاستجابة السريعة',
    tip2: 'لأمان بيانات حسابك، يجب التحقق من معلومات المشغل الحالية',
    tip3: 'يجب أن تكون خزانات الإنتاج التجريبي {fontStyleStart} خزانات غير متماثلة لتجنب انعكاس الخزانة {fontStyleEnd} مشاكل'
    },
  printTag: {
    dualLanguageTip: 'ليس لديك إذن بالإنشاء تسميات ثنائية اللغة باللغتين الصينية والإنجليزية. حاليًا، يمكنك فقط معاينتها. إذا كنت تريد استخدامها رسميًا، فيرجى الاتصال بالمبيعات لتنشيطها ~',
    generateDualLanguageTagTip: 'إنشاء ملصقات ثنائية اللغة باللغتين الصينية والإنجليزية',
    dualLanguageTip2: 'هذه الوظيفة مدفوعة الأجر. يرجى الاتصال بالمبيعات لتنشيطه ~',
    effectiveDataSource: 'مصدر البيانات الفعال',
    partName: 'اسم اللوحة'
    },
  userAccessToken: {
    createTime: 'وقت الإنشاء',
    lastUsedTime: 'وقت آخر استخدام',
    expireTime: 'وقت انتهاء الصلاحية',
    status: 'الحالة',
    tokenNamePlaceholder: 'أدخل اسم الرمز المميز',
    expireTimeSelectPlaceholder: 'حدد وقت انتهاء الصلاحية',
    securityBannerTip: 'لا تشارك رمز الوصول الشخصي الخاص بك مع الآخرين ولا تكشفه في المتصفح أو أي كود عميل آخر. لحماية حسابك، قد يتم تعطيل أي رمز مسرب علنًا تلقائيًا.',
    expired: 'منتهي الصلاحية',
    valid: 'صالح',
    remove: 'إزالة',
    previewOnceWarning: 'يتم عرض هذا الرمز مرة واحدة فقط. احفظ هذا السر في مكان آمن ويمكن الوصول إليه. لا تشاركه مع الآخرين ولا تكشفه في المتصفح أو أي كود عميل آخر.',
    token: 'الرمز المميز',
    deleteConfirm: 'هل أنت متأكد أنك تريد حذف هذا الرمز المميز؟',
    userAccessToken: 'رمز وصول المستخدم',
    dayUnit: 'يوم',
    custom: 'مخصص',
    previewModalTitle: 'رمز وصول شخصي جديد',
    addModalTitle: 'إضافة رمز وصول شخصي جديد'
    },
  bujianStore: {
    inputPlaceholder: 'أدخل رمز الجدار للبحث عن لوحات صغيرة للإصلاح',
    noData: 'لا يوجد بيانات',
    loadingErr: 'فشل تحميل الورق المطبوع',
    bujianStore: 'مكتبة الورق المطبوع',
    awaitStore: 'مكتبة المواد المطبوعة',
    noDrag: 'لا يمكن تعيين, يرجى التحقق من خصائص المواد واللون والسمك الخاص باللوحة',
    outOfCanvas: 'لا يمكن تعيين, يرجى التحقق من خصائص المواد واللون والسمك الخاص باللوحة'
    },
  alginTexture: {
    tip: 'ستؤدي هذه العملية إلى مسح معلومات محاذاة نسيج اللوحة. يرجى تأكيد ما إذا كنت تريد المتابعة؟',
    tip2: 'ستؤدي هذه العملية إلى تأثير المسافة بين الألواح ، مما يؤدي إلى مشاكل في التصنيع. يرجى تأكيد ما إذا كنت تريد المتابعة؟',
    group: 'مجموعة النسيج',
    groupTemp: 'مجموعة النسيج واحدة',
    textureAlignmentPlank: 'لا يمكن نقل لوحة محاذاة النسيج'
    },
  customizeFolder: {
    customizeFolder: 'تخصيص المجلد',
    customizeFolderTip: 'ملاحظة: بعد تمكين التخصيص المجلدي، لن يعمل القواعد السابقة لتقسيم المجلدات',
    processingFilesTitle: 'معالجة البيانات الملفية',
    dragToFolderTip: 'يمكن سحبه إلى المجلد الأيسر كمجلد فرعي أو ملف',
    folderNameEmpty: 'اسم المجلد لا يمكن أن يكون فارغ',
    folderNameExists: 'يوجد مجلد بنفس الاسم',
    fileNotFound: 'فشل في الحصول على الملف الصحيح',
    fileCannotBeClassified: 'هذا النوع من الملفات لا يمكن وضعه في أي مجلد تصنيف',
    cannotAddAtThisPosition: 'لا يمكن إضافة في هذا الموضع',
    fileAlreadyExists: '【{name}】يوجد بالفعل في هذا المجلد',
    confirmDeleteFolder: 'هل أنت متأكد من أنك تريد حذف هذا المجلد؟',
    confirmDeleteItem: 'هل أنت متأكد من أنك تريد حذف 【{name}】؟',
    confirmDeleteFolderWithChildren: 'هناك مجلدات/ملفات أخرى تحت هذا المجلد، هل أنت متأكد من أنك تريد حذفها؟',
    deleteFile: 'حذف الملف',
    addSubFolder: 'إضافة مجلد فرعي',
    editFolder: 'تحرير المجلد',
    deleteFolder: 'حذف المجلد',
    rootCannotDelete: 'لا يمكن حذف الدليل الجذري',
    newFolder: 'مجلد جديد',
    fileUsedCanDrag: 'مستخدم - يمكن سحبه مرات متعددة',
    fileDraggable: 'قابل للسحب',
    addFileToFolder: 'إضافة 【{fileName}】 إلى {folderName}',
    addFolderTitle: 'إضافة مجلد',
    editFolderTitle: 'تحرير المجلد',
    folderNameLabel: 'اسم المجلد',
    folderNamePlaceholder: 'الرجاء إدخال اسم المجلد',
    sequenceStartLabel: 'قيمة البدء للتسلسل الزائد',
    classifyMethodLabel: 'طريقة التصنيف',
    nameLengthLimitLabel: 'حد الطول الحرفي',
    tagInsertTip: 'اضغط على العلامة لإدخالها في اسم المجلد',
    classifyTagInsertTip: 'اضغط على العلامة لإدخالها في اسم المجلد، سيتم تصنيف الملفات بناءً على العلامة المحددة',
    engraving_front: 'ملف أمامي لآلة الحفر',
    engraving_opposite: 'ملف خلفي لآلة الحفر',
    engraving_merge: 'ملف مدمج لآلة الحفر',
    engraving_mill: 'تشغيل مخرطة قنوات القرن الثاني',
    engraving_haitang: 'ملف زاوية Haitang معالجة فرعية منحنية',
    engraving_arc_slot: 'تشغيل مخرطة قنوات دائرية معالجة فرعية منحنية',
    engraving_line_slot: 'معالجة فرعية مسار công cụ tùy chỉnh',
    engraving_straight_arc_slot: 'معالجة فرعية منحنية من قسم uốn cong hình cung slot thẳng',
    engraving_frame_door: 'ملف درابزين معالجة فرعية منحنية',
    engraving_inner_shape: 'معالجة فرعية من الشكل الداخلي',
    engraving_hole: 'معالجة فرعية من الثقب العادي',
    engraving_slot: 'معالجة فرعية من الثقب العادي',
    engraving_single_file_merge: 'معالجة فرعية من الدمج الملف',
    electronic_saw: 'ملف سيارة الكهرباء معالجة فرعية منحنية',
    glass: 'ملف ماكينة قص الزجاج معالجة فرعية منحنية',
    glass_machine: 'ماكينة قص الزجاج معالجة فرعية منحنية',
    side_machine: 'ملف ماكينة الحفر الجانبي معالجة فرعية منحنية',
    side_machine_xml3: 'ملف ماكينة الحفر الجانبي XML3 معالجة فرعية منحنية',
    side_machine_txt: 'ملف ماكينة الحفر الجانبي TXT معالجة فرعية منحنية',
    side_machine_nc: 'ملف ماكينة الحفر الجانبي NC معالجة فرعية منحنية',
    dock56F: 'ملف الحفر cinco/seis lados معالجة فرعية منحنية',
    ptp: 'ملف PTP معالجة فرعية منحنية',
    aio: 'ملف ماكينة all-in-one معالجة فرعية منحنية',
    aio_anc: 'ملف ANC frontal de la máquina all-in-one معالجة فرعية منحنية',
    labeling_1: 'ملف ماكينة التسمية 1 معالجة فرعية منحنية',
    labeling_2: 'ملف ماكينة التسمية 2 معالجة فرعية منحنية',
    labeling_3: 'ملف ماكينة التسمية 3 معالجة فرعية منحنية',
    robotic_arm: 'ملف يد روبوت معالجة فرعية منحنية',
    label_image: 'ملف صورة التسمية معالجة فرعية منحنية',
    label_pdf: 'ملف PDF de etiqueta معالجة فرعية منحنية',
    paiban_image: 'ملف صورة التصميم الصناعي معالجة فرعية منحنية',
    paiban_pdf: 'ملف PDF للتصميم الصناعي معالجة فرعية منحنية',
    engraving: 'آلة الحفر معالجة فرعية منحنية',
    electronic: 'سيارة الكهرباء معالجة فرعية منحنية',
    side_hole: 'ماكينة الحفر الجانبي معالجة فرعية منحنية',
    drilling: 'الحفر cinco/seis lados معالجة فرعية منحنية',
    labeling: 'ماكينة التسمية معالجة فرعية منحنية',
    robotic: 'يد روبوت معالجة فرعية منحنية',
    label: 'التسمية',
    warningTip: 'يرجى الانتباه: يجب أن يبقى الأقواس المنحنية 【{}】 ومحتواها سليمًا، لا يجب حذف/إضافتها بشكل منطقي!',
    fileClassifyError: 'هذا الملف لا يمكن تصنيفه بناع {classifyNames}',
    folderClassifyByTextureColorThickSize: 'تصنيف في مجلدات مختلفة بناع color, material, grosor y tamaño de la placa (archivos de etiqueta juntos)',
    unnamed: 'بدون اسم',
    specialText: 'خاص',
    surplusText: 'مادة زائدة',
    normalText: 'عادي',
    plankText1: 'لوح',
    resetTemplate: 'إعادة تعيين القالب',
    resetTemplateConfirm: 'هل أنت متأكد من أنك تريد إعادة تعيين القالب؟',
    clearTemplate: 'مسح القالب',
    clearTemplateConfirm: 'هل أنت متأكد من أنك تريد مسح القالب؟',
    legendFixedFolder: 'مجلد ثابت',
    legendClassifyFolder: 'مجلد مصنف',
    legendFixedTag: 'بيانات ثابتة',
    legendNormalTag: 'بيانات ديناميكية',
    legendClassifyTag: 'بيانات ديناميكية مصنفة',
    door_wall_aio: 'آلة الأبواب والجدران والخزائن المتكاملة',
    noPermission: 'ليس لديك حاليًا صلاحية استخدام المجلدات المخصصة. يرجى الاتصال بالمبيعات لشراء هذه الميزة قبل استخدامها.',
    enableCustomFolder: 'تمكين المجلدات المخصصة',
    exporttagTip: 'عند تصدير علامة PDF والصورة في نفس الوقت، يتم إرسال PDF افتراضيًا'
    },
  paibanTask: {
    pausedTip: 'آلة الأبواب والجدران والخزائن المتكاملة',
    deleteTip: 'هل أنت متأكد من أنك تريد حذف المهمة «{taskBatch}»؟ لا يمكن استرجاعها بعد الحذف.',
    continueTip: 'استمرار المهمة',
    completed: 'مكتمل',
    failed: 'مهمة فاشلة',
    paused: 'مهمة موقوفة',
    pending: 'معلق',
    running: 'في التشغيل',
    extraTip: 'مهمة التخطيط فقط تعرض البيانات للأسبوع الماضي. يرجى حفظ المهمة في السجل بعد الانتهاء!',
    taskStatus: 'حالة المهمة',
    createTaskTip: 'إنشاء مهمة التخطيط، الدخول إلى التخطيط',
    taskBatchTitle: 'مجموعة مهام',
    relatedOrderNosTitle: 'أرقام الطلبات المرتبطة',
    progressTitle: 'تقدم التخطيط',
    boardCountTitle: 'استخدام اللوح المحدد',
    optimizedAreaTitle: 'مساحة التحسين المحددة',
    productionLineTitle: 'خط الإنتاج',
    operationTitle: 'الإجراءات',
    optimizeRateTitle: 'تقدير معدل التحسين',
    optimizeRateTip: 'معدل التحسين للمواد الزائدة المقصوصة تلقائيًا لا يتم حسابه.',
    optimizeRateTip2: 'معدل التحسين المحدد يعتمد على الصفحة التخطيطية',
    boardCountTip: 'كمية استخدام اللوح الكبير المحددة تعتمد على صفحة التخطيط',
    optimizedAreaTip: 'المساحة المصممة المحددة يعتمد على الصفحة التخطيطية',
    paibanSettingTip: 'تم تعديل إعدادات خط الإنتاج للمهمة الحالية. قد تتعارض نتائج التخطيط الحالي مع ملفات التصدير الفعلية للإنتاج. يوصى بإعادة تخطيط الإنتاج.',
    dataException: 'استثناء البيانات، يرجى تحديث الصفحة وإعادة المحاولة'
    },
  paibanSetting: {
    advancedSetting: 'الإعدادات المتقدمة',
    advancedFeature: 'الميزات المتقدمة',
    surplusCutSpeedUp: 'تسريع القص الآلي للمواد الزائدة',
    surplusCutSpeedUpTip4: 'الميزة قيد التطوير، يرجى الإنتظار',
    surplusCutSpeedUpTip: 'يتم ضبط فجوة تخطيط المواد المتبقية تلقائيًا على 0',
    surplusCutSpeedUpTip2: 'قص المواد المتبقية يتجاوز تلقائيًا المسارات المقطوعة ومسارات تشذيب الحواف لتحسين الكفاءة',
    surplusCutSpeedUpTip3: 'هذه الميزة لا تعمل مع الآلات التشغيلية والآلات التشغيلية ذات الدورة الواحدة (لا تستخدم مع القص المشترك أو التسريع المشترك)',
    surplusCutSpeedUpTip5: 'فقط فعال لآلات الحفر وآلات الحفر ذات الدورة الواحدة',
    featureDisplay: 'عرض الوظائف',
    featureDisplayTip: 'تتحكم هذه الصفحة فقط في عرض مداخل الميزات، ولا تعدل حالة التمكين وإعدادات المعلمات للميزة نفسها'
    },
  alignedPlan: {
    deepSearch: 'بحث عميق',
    deepSearchTip: 'ميزة حصرية: زد عمق الحساب بإعادة الترتيب للحصول على نتائج أفضل',
    deepSearchTip2: 'بعد ترقية البحث العميق، أعد الترتيب لزيادة عمق الحساب. متاح للتجربة حالياً',
    deepSearchTip3: 'البحث العميق يقدم مخططاً أوفر للألواح',
    deepSearchTip4: 'لا تملك حالياً صلاحية ترتيب البحث العميق. يرجى التواصل مع المبيعات للشراء.',
    deepSearchTip5: 'بعد ترقية البحث العميق، استمتع بقوة حوسبة خادم مخصصة لجودة أفضل. المعاينة متاحة حالياً'
    }
  }